// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.2.0 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bs-link-color);
  text-decoration: underline;
}
a:hover {
  color: var(--bs-link-hover-color);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.375rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #6c757d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
.gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
.gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
.gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
.gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
.gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
.gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
.gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
.gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
.gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
.gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
.gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
.gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
.gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
.gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
.gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
.gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
.gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
.gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
.gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
.gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
.gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
.gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
.gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
.gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
.gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
.gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
.gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
.gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
.gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
.gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
.gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
.gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
.gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
.gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
.gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
.gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
.gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
.gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
.gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
.gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
.gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
.gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
.gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
.gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
.gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
.gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
.gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
.gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
.gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
.gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
.gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
.gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
.gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
.gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
.gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
.gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
.gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
.gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
.gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
.gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #bacbe6;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #cbccce;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #bcd0c7;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #badce3;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #e6dbb9;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #dfc2c4;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #dfe0e1;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #373b3e;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: #212529;
  background-color: #e9ecef;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #dde0e3;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
}
.form-control-color::-webkit-color-swatch {
  border-radius: 0.375rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #212529;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}
.form-check-input:checked[type=radio] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e");
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e");
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e");
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -moz-appearance: none;
       appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::-moz-placeholder, .form-floating > .form-control-plaintext::-moz-placeholder {
  color: transparent;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:not(:-moz-placeholder-shown), .form-floating > .form-control-plaintext:not(:-moz-placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.form-floating):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback),
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #198754;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(25, 135, 84, 0.9);
  border-radius: 0.375rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #198754;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #198754;
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #198754;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e"), url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #198754;
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #198754;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #198754;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #198754;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}
.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.375rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #dc3545;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e"), url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #dc3545;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #dc3545;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #212529;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.375rem;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check:focus + .btn, .btn:focus {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, .btn-check:active + .btn, .btn:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus, .btn-check:active + .btn:focus, .btn:active:focus, .btn.active:focus, .btn.show:focus {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: 0.5rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: 0.25rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: #212529;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.375rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(0.375rem - 1px);
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: #1e2125;
  --bs-dropdown-link-hover-bg: #e9ecef;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.375rem;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link.disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #dee2e6;
  --bs-nav-tabs-border-radius: 0.375rem;
  --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: #fff;
  --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(var(--bs-nav-tabs-border-width) * -1);
  background: none;
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(var(--bs-nav-tabs-border-width) * -1);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.375rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.375rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-border-width: 1px;
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: 0.375rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(0.375rem - 1px);
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(0, 0, 0, 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #000;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.375rem;
  --bs-accordion-inner-border-radius: calc(0.375rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-body-color%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #0c63e4;
  --bs-accordion-active-bg: #e7f1ff;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #6c757d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #dee2e6;
  --bs-pagination-border-radius: 0.375rem;
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: #e9ecef;
  --bs-pagination-hover-border-color: #dee2e6;
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: #e9ecef;
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: #6c757d;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #dee2e6;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: 0.5rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: 0.25rem;
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.375rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.375rem;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: #084298;
  --bs-alert-bg: #cfe2ff;
  --bs-alert-border-color: #b6d4fe;
}
.alert-primary .alert-link {
  color: #06357a;
}

.alert-secondary {
  --bs-alert-color: #41464b;
  --bs-alert-bg: #e2e3e5;
  --bs-alert-border-color: #d3d6d8;
}
.alert-secondary .alert-link {
  color: #34383c;
}

.alert-success {
  --bs-alert-color: #0f5132;
  --bs-alert-bg: #d1e7dd;
  --bs-alert-border-color: #badbcc;
}
.alert-success .alert-link {
  color: #0c4128;
}

.alert-info {
  --bs-alert-color: #055160;
  --bs-alert-bg: #cff4fc;
  --bs-alert-border-color: #b6effb;
}
.alert-info .alert-link {
  color: #04414d;
}

.alert-warning {
  --bs-alert-color: #664d03;
  --bs-alert-bg: #fff3cd;
  --bs-alert-border-color: #ffecb5;
}
.alert-warning .alert-link {
  color: #523e02;
}

.alert-danger {
  --bs-alert-color: #842029;
  --bs-alert-bg: #f8d7da;
  --bs-alert-border-color: #f5c2c7;
}
.alert-danger .alert-link {
  color: #6a1a21;
}

.alert-light {
  --bs-alert-color: #636464;
  --bs-alert-bg: #fefefe;
  --bs-alert-border-color: #fdfdfe;
}
.alert-light .alert-link {
  color: #4f5050;
}

.alert-dark {
  --bs-alert-color: #141619;
  --bs-alert-bg: #d3d3d4;
  --bs-alert-border-color: #bcbebf;
}
.alert-dark .alert-link {
  color: #101214;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: #e9ecef;
  --bs-progress-border-radius: 0.375rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: #212529;
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.375rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #212529;
  --bs-list-group-action-active-bg: #e9ecef;
  --bs-list-group-disabled-color: #6c757d;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(var(--bs-list-group-border-width) * -1);
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(var(--bs-list-group-border-width) * -1);
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #084298;
  background-color: #cfe2ff;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #084298;
  background-color: #bacbe6;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #084298;
  border-color: #084298;
}

.list-group-item-secondary {
  color: #41464b;
  background-color: #e2e3e5;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #41464b;
  background-color: #cbccce;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #41464b;
  border-color: #41464b;
}

.list-group-item-success {
  color: #0f5132;
  background-color: #d1e7dd;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #0f5132;
  background-color: #bcd0c7;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #0f5132;
  border-color: #0f5132;
}

.list-group-item-info {
  color: #055160;
  background-color: #cff4fc;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #055160;
  background-color: #badce3;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #055160;
  border-color: #055160;
}

.list-group-item-warning {
  color: #664d03;
  background-color: #fff3cd;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #664d03;
  background-color: #e6dbb9;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #664d03;
  border-color: #664d03;
}

.list-group-item-danger {
  color: #842029;
  background-color: #f8d7da;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #842029;
  background-color: #dfc2c4;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #842029;
  border-color: #842029;
}

.list-group-item-light {
  color: #636464;
  background-color: #fefefe;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #636464;
  background-color: #e5e5e5;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #636464;
  border-color: #636464;
}

.list-group-item-dark {
  color: #141619;
  background-color: #d3d3d4;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #141619;
  background-color: #bebebf;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #141619;
  border-color: #141619;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e") center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: 0.375rem;
  --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-toast-header-color: #6c757d;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  position: absolute;
  z-index: 1090;
  width: -moz-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(var(--bs-toast-padding-x) * -0.5);
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.5rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.5rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5) calc(var(--bs-modal-header-padding-x) * -0.5) calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
.modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
.modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
.modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
.modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
.modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.375rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  padding: var(--bs-tooltip-arrow-height);
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: 0.5rem;
  --bs-popover-inner-border-radius: calc(0.5rem - 1px);
  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: var(--bs-heading-color);
  --bs-popover-header-bg: #f0f0f0;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: #212529;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(var(--bs-popover-arrow-width) * -0.5);
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e");
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
.spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: ;
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1045;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(var(--bs-offcanvas-padding-y) * -0.5);
  margin-right: calc(var(--bs-offcanvas-padding-x) * -0.5);
  margin-bottom: calc(var(--bs-offcanvas-padding-y) * -0.5);
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(13, 110, 253, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: #0d6efd !important;
}
.link-primary:hover, .link-primary:focus {
  color: #0a58ca !important;
}

.link-secondary {
  color: #6c757d !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: #565e64 !important;
}

.link-success {
  color: #198754 !important;
}
.link-success:hover, .link-success:focus {
  color: #146c43 !important;
}

.link-info {
  color: #0dcaf0 !important;
}
.link-info:hover, .link-info:focus {
  color: #3dd5f3 !important;
}

.link-warning {
  color: #ffc107 !important;
}
.link-warning:hover, .link-warning:focus {
  color: #ffcd39 !important;
}

.link-danger {
  color: #dc3545 !important;
}
.link-danger:hover, .link-danger:focus {
  color: #b02a37 !important;
}

.link-light {
  color: #f8f9fa !important;
}
.link-light:hover, .link-light:focus {
  color: #f9fafb !important;
}

.link-dark {
  color: #212529 !important;
}
.link-dark:hover, .link-dark:focus {
  color: #1a1e21 !important;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-1 {
  --bs-border-width: 1px;
}

.border-2 {
  --bs-border-width: 2px;
}

.border-3 {
  --bs-border-width: 3px;
}

.border-4 {
  --bs-border-width: 4px;
}

.border-5 {
  --bs-border-width: 5px;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #6c757d !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
     -moz-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
     -moz-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root {
  --darkBodyBackground: black;
  --darkBodyBackgroundActive: #202020;
  --darkContentBackgroundColor: #2d2d2d;
  --darkLightenContentBackgroundColor: #3c3c3c;
  --darkBootstrapDefaultBorder: #ced4da;
  --darkPaginationHoverNotActive: #ddd;
  --darkDisabledField: #323232;
  --darkDisabledIcon: #757575;
  --darkContentColor: black;
  --lightContentColor: white;
}

.accessibility-contrast #egradjani {
  border-bottom: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast #egradjani .zgl-showmore a:hover {
  color: var(--darkContentColor) !important;
}
.accessibility-contrast #egradjani #current_user a, .accessibility-contrast #egradjani #current_user .unread a {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #egradjani #fontsize_slideout .lining {
  background-color: var(--darkContentBackgroundColor) !important;
}
.accessibility-contrast #egradjani #user_slideout {
  background-color: var(--darkContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #egradjani #user_slideout a.action {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #egradjani #user_slideout a.action:hover {
  border: 2px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta {
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta #egradani_modal_izaberite_subjekt {
  background-color: var(--darkContentBackgroundColor) !important;
  border-bottom: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .assist {
  background-color: var(--darkContentBackgroundColor) !important;
  border-bottom: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .assist a {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .assist a:hover {
  opacity: 0.5 !important;
}
.accessibility-contrast #promjena_subjekta .lining {
  background: var(--darkContentBackgroundColor) !important;
  border-bottom: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .mfp-close {
  border-bottom: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .mfp-close:hover::before {
  opacity: 0.5 !important;
}
.accessibility-contrast #promjena_subjekta .mfp-close::before {
  background-color: var(--darkContentBackgroundColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .selection ul li:hover {
  background-color: var(--darkContentColor) !important;
}
.accessibility-contrast #promjena_subjekta .zgl-area::before {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast #promjena_subjekta input {
  background-color: var(--darkContentColor) !important;
}
.accessibility-contrast .alert {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .bg-white, .accessibility-contrast .navbar-content {
  background-color: var(--darkBodyBackground) !important;
}
.accessibility-contrast .bm-menu {
  background-color: var(--darkContentColor) !important;
  border-right: 1px solid var(--lightContentColor);
}
.accessibility-contrast .btn.btn-primary, .accessibility-contrast .btn.btn-info {
  background-color: var(--darkBodyBackground) !important;
}
.accessibility-contrast .btn.btn-secondary, .accessibility-contrast .btn.btn-outline-secondary, .accessibility-contrast .btn.btn-danger {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .btn.btn-primary, .accessibility-contrast .btn.btn-secondary, .accessibility-contrast .btn.btn-info, .accessibility-contrast .btn.btn-outline-secondary, .accessibility-contrast .btn.btn-danger {
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .btn.btn-primary:disabled, .accessibility-contrast .btn.btn-secondary:disabled, .accessibility-contrast .btn.btn-info:disabled, .accessibility-contrast .btn.btn-outline-secondary:disabled, .accessibility-contrast .btn.btn-white:disabled, .accessibility-contrast .btn.btn-danger:disabled {
  opacity: 0.5 !important;
}
.accessibility-contrast .btn.btn-primary:hover, .accessibility-contrast .btn.btn-primary:active, .accessibility-contrast .btn.btn-primary:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-primary:not(:disabled):not(.disabled):active, .accessibility-contrast .btn.btn-secondary:hover, .accessibility-contrast .btn.btn-secondary:active, .accessibility-contrast .btn.btn-secondary:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-secondary:not(:disabled):not(.disabled):active, .accessibility-contrast .btn.btn-info:hover, .accessibility-contrast .btn.btn-info:active, .accessibility-contrast .btn.btn-info:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-info:not(:disabled):not(.disabled):active, .accessibility-contrast .btn.btn-outline-secondary:hover, .accessibility-contrast .btn.btn-outline-secondary:active, .accessibility-contrast .btn.btn-outline-secondary:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-outline-secondary:not(:disabled):not(.disabled):active, .accessibility-contrast .btn.btn-white:hover, .accessibility-contrast .btn.btn-white:active, .accessibility-contrast .btn.btn-white:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-white:not(:disabled):not(.disabled):active, .accessibility-contrast .btn.btn-danger:hover, .accessibility-contrast .btn.btn-danger:active, .accessibility-contrast .btn.btn-danger:not(:disabled):not(.disabled).active, .accessibility-contrast .btn.btn-danger:not(:disabled):not(.disabled):active {
  background-color: rgba(255, 255, 255, 0.4) !important;
  transition: 0.2s;
}
.accessibility-contrast .btn.btn-primary:not(:hover), .accessibility-contrast .btn.btn-secondary:not(:hover), .accessibility-contrast .btn.btn-info:not(:hover), .accessibility-contrast .btn.btn-outline-secondary:not(:hover), .accessibility-contrast .btn.btn-white:not(:hover), .accessibility-contrast .btn.btn-danger:not(:hover) {
  transition: 0.2s;
}
.accessibility-contrast .custom-toggle-checkbox:checked + .custom-toggle-slider {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .error-tab, .accessibility-contrast .error-tab svg {
  color: #d85b61 !important;
}
.accessibility-contrast .file-drop-wrapper:hover {
  border: 3px dashed var(--lightContentColor) !important;
}
.accessibility-contrast .footer {
  background-color: var(--lightContentColor) !important;
  color: var(--darkContentColor) !important;
}
.accessibility-contrast .footer span {
  color: var(--darkContentColor) !important;
}
.accessibility-contrast .footer img {
  filter: grayscale(1) !important;
}
.accessibility-contrast .form-control {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .form-control:disabled {
  color: var(--darkContentColor) !important;
  background-color: var(--lightContentColor) !important;
  opacity: 0.5 !important;
}
.accessibility-contrast .form-check-input {
  border-color: var(--lightContentColor) !important;
}
.accessibility-contrast .form-check-input:focus {
  box-shadow: 0 0 0 0.1em rgb(255, 255, 255) !important;
}
.accessibility-contrast .form-check-input:checked {
  color: var(--lightContentColor) !important;
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .form-header,
.accessibility-contrast .form-label,
.accessibility-contrast .invalid-feedback {
  color: var(--darkPaginationHoverNotActive) !important;
}
.accessibility-contrast .form-switch .form-check-input:focus {
  filter: grayscale(1) !important;
}
.accessibility-contrast .icon-table, .accessibility-contrast .icon-table-header {
  color: white !important;
}
.accessibility-contrast .icon-table:hover, .accessibility-contrast .icon-table-header:hover {
  opacity: 0.5 !important;
}
.accessibility-contrast .input-group .addon-icon {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .input-group .addon-icon:hover {
  background-color: unset !important;
  color: var(--darkContentColor) !important;
}
.accessibility-contrast .input-group .input-group-text {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .input-group .input-group-text:-moz-read-only {
  background-color: rgba(255, 255, 255, 0.4) !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .input-group .input-group-text:disabled, .accessibility-contrast .input-group .input-group-text:read-only {
  background-color: rgba(255, 255, 255, 0.4) !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .input-group .input-group-text:hover, .accessibility-contrast .input-group .input-group-text:active, .accessibility-contrast .input-group .input-group-text:not(:disabled):not(.disabled).active, .accessibility-contrast .input-group .input-group-text:not(:disabled):not(.disabled):active {
  background-color: rgba(255, 255, 255, 0.4) !important;
  transition: 0.2s;
}
.accessibility-contrast .input-group .input-group-text:not(:hover) {
  transition: 0.2s;
}
.accessibility-contrast .input-group input {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .input-group input:disabled {
  background-color: var(--lightContentColor) !important;
  color: var(--darkContentColor) !important;
  opacity: 0.5 !important;
}
.accessibility-contrast .has-validation .input-group-text {
  border-color: var(--lightContentColor) !important;
  border: 3px solid var(--lightContentColor) !important;
}
.accessibility-contrast .has-validation .input-group-text:-moz-read-only {
  border-color: var(--lightContentColor) !important;
  border: 3px solid var(--lightContentColor) !important;
}
.accessibility-contrast .has-validation .input-group-text:read-only {
  border-color: var(--lightContentColor) !important;
  border: 3px solid var(--lightContentColor) !important;
}
.accessibility-contrast .is-invalid {
  border-color: var(--lightContentColor) !important;
  border: 3px solid var(--lightContentColor) !important;
}
.accessibility-contrast .input-invalid {
  border: 3px solid var(--lightContentColor) !important;
}
.accessibility-contrast .modal-content {
  background-color: var(--darkBodyBackground) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .modal-content .modal-header .btn-close:focus {
  box-shadow: none !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .modal-content .modal-header .btn-close::after {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .page-content {
  background-color: var(--darkBodyBackground) !important;
  border-bottom: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination .page-item .page-link {
  background-color: var(--darkBodyBackground) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination .page-item .page-link:hover, .accessibility-contrast .pagination-wrapper .pagination .page-item .page-link:active, .accessibility-contrast .pagination-wrapper .pagination .page-item .page-link:focus, .accessibility-contrast .pagination-wrapper .pagination .page-item .page-link:focus:active {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination .page-item.active .page-link {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination .page-item.disabled .page-link {
  opacity: 0.5 !important;
}
.accessibility-contrast .pagination-wrapper .pagination-size .edozvola-select {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination-size .edozvola-select > option {
  background-color: var(--darkContentColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination-size .custom-select:hover:not(:disabled) {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .pagination-wrapper .pagination-size .custom-select:focus:not(:disabled) {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .rdt .rdtActive {
  color: var(--darkContentColor) !important;
}
.accessibility-contrast .rdt .rdtActive:before {
  background-color: var(--lightContentColor) !important;
}
.accessibility-contrast .rdt .rdtBtn:hover {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .rdt .rdtNext,
.accessibility-contrast .rdt .rdtPrev,
.accessibility-contrast .rdt .rdtSwitch {
  background-color: var(--darkContentColor) !important;
  border-bottom: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .rdt .rdtNext:hover,
.accessibility-contrast .rdt .rdtPrev:hover,
.accessibility-contrast .rdt .rdtSwitch:hover {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .rdt .rdtNew,
.accessibility-contrast .rdt .rdtOld {
  opacity: 0.5 !important;
}
.accessibility-contrast .rdt .rdtTimeToggle {
  border-top: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .rdt .rdtTimeToggle:hover {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .rdt .rdtToday:before {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .rdt .rdtToday:hover {
  color: var(--darkContentColor) !important;
}
.accessibility-contrast .rdt table {
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .rdt table td {
  background-color: var(--darkContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .rdt table td.rdtDisabled {
  color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .rdt table td:not(.rdtDisabled):hover:before {
  background-color: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .rdt table tr {
  background-color: var(--darkContentColor) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .sidebar-statement-link {
  background: var(--darkBodyBackground) !important;
  border-right: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .sort-arrow {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .sort-arrow:hover {
  opacity: 0.5 !important;
}
.accessibility-contrast .table thead {
  background: var(--darkBodyBackground) !important;
  border: 1px solid var(--lightContentColor) !important;
}
.accessibility-contrast .table tbody tr {
  background: var(--darkContentBackgroundColor) !important;
}
.accessibility-contrast .table tbody tr td {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .table tbody tr:hover {
  background: var(--darkBodyBackgroundActive) !important;
}
.accessibility-contrast .table .custom-toggle-checkbox:checked + .custom-toggle-slider {
  background-color: var(--darkBodyBackground) !important;
}
.accessibility-contrast .table-striped tbody tr:nth-of-type(odd) {
  background: var(--darkLightenContentBackgroundColor) !important;
}
.accessibility-contrast .table-striped tbody tr:nth-of-type(odd) td {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .table-striped tbody tr:nth-of-type(odd):hover {
  background: var(--darkBodyBackgroundActive) !important;
}
.accessibility-contrast .Toastify__toast {
  background-color: var(--darkContentBackgroundColor) !important;
  border: 4px solid var(--darkContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast .Toastify__toast .Toastify__close-button svg {
  fill: var(--lightContentColor) !important;
}
.accessibility-contrast .Toastify__toast .Toastify__toast-icon svg {
  fill: var(--lightContentColor) !important;
}
.accessibility-contrast .Toastify__toast .Toastify__progress-bar--wrp {
  background-color: var(--darkContentColor) !important;
}
.accessibility-contrast .Toastify__toast .Toastify__progress-bar--error,
.accessibility-contrast .Toastify__toast .Toastify__progress-bar--success {
  background-color: var(--lightContentColor) !important;
}
.accessibility-contrast .uploaded-file-item {
  background-color: var(--darkContentBackgroundColor) !important;
  border: 2px solid var(--lightContentColor) !important;
}
.accessibility-contrast .upload-icon {
  color: var(--darkContentBackgroundColor) !important;
}
.accessibility-contrast .fw-bold, .accessibility-contrast .loader-text, .accessibility-contrast .text-danger, .accessibility-contrast .text-gray {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  background-color: var(--darkContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .btn .multiple:disabled {
  opacity: 0.5 !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .dropdown-menu {
  background-color: var(--darkLightenContentBackgroundColor) !important;
  border: 1px solid var(--lightContentColor) !important;
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .dropdown-menu .dropdown-item {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .dropdown-menu .dropdown-item.disabled {
  color: var(--darkContentColor) !important;
  background-color: var(--lightContentColor) !important;
  opacity: 0.5 !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .dropdown-menu .dropdown-item:hover {
  font-weight: bold !important;
  background-color: var(--darkBodyBackground) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .disabled {
  color: var(--darkContentColor) !important;
  background-color: var(--lightContentColor) !important;
  opacity: 0.5 !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-contrast div[id\$=-paginated-dropdown].dropdown .close {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .is-invalid {
  border: 3px solid var(--lightContentColor) !important;
  border-color: unset !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .icon {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast div[id\$=-paginated-dropdown].dropdown .no-value-text {
  color: var(--lightContentColor) !important;
}
.accessibility-contrast main {
  background-color: var(--darkBodyBackground) !important;
}
.accessibility-contrast a,
.accessibility-contrast input,
.accessibility-contrast hr,
.accessibility-contrast h3,
.accessibility-contrast .h3,
.accessibility-contrast h5,
.accessibility-contrast .h5,
.accessibility-contrast h6,
.accessibility-contrast .h6,
.accessibility-contrast p,
.accessibility-contrast svg,
.accessibility-contrast span,
.accessibility-contrast textarea {
  color: var(--lightContentColor) !important;
}

.accessibility-dyslexia {
  font-family: open-dyslexic !important;
}
.accessibility-dyslexia .Toastify__toast {
  font-family: open-dyslexic !important;
}
.accessibility-dyslexia.accessibility-font-size-s .button-in-action-column.btn, .accessibility-dyslexia.accessibility-font-size-xs .button-in-action-column.btn, .accessibility-dyslexia.accessibility-font-size-2xs .button-in-action-column.btn, .accessibility-dyslexia.accessibility-font-size-3xs .button-in-action-column.btn {
  padding: 20px !important;
}
.accessibility-dyslexia .form-switch .form-check-input {
  width: 68px !important;
}
.accessibility-dyslexia.accessibility-font-size-s .form-switch .form-check-input {
  width: 62px !important;
}
.accessibility-dyslexia.accessibility-font-size-xs .form-switch .form-check-input {
  width: 60px !important;
}
.accessibility-dyslexia.accessibility-font-size-2xs .form-switch .form-check-input {
  width: 58px !important;
}
.accessibility-dyslexia.accessibility-font-size-3xs .form-switch .form-check-input {
  width: 54px !important;
}
.accessibility-dyslexia.accessibility-font-size-l .form-switch .form-check-input {
  width: 76px !important;
}
.accessibility-dyslexia.accessibility-font-size-xl .form-switch .form-check-input {
  width: 80px !important;
}
.accessibility-dyslexia.accessibility-font-size-2xl .form-switch .form-check-input {
  width: 84px !important;
}
.accessibility-dyslexia.accessibility-font-size-3xl .form-switch .form-check-input {
  width: 88px !important;
}
.accessibility-dyslexia .footer .row span {
  margin-top: 17px !important;
}
.accessibility-dyslexia.accessibility-font-size-s .footer .row span {
  margin-top: 18px !important;
}
.accessibility-dyslexia.accessibility-font-size-xs .footer .row span, .accessibility-dyslexia.accessibility-font-size-2xs .footer .row span {
  margin-top: 20px !important;
}
.accessibility-dyslexia.accessibility-font-size-3xs .footer .row span {
  margin-top: 21px !important;
}

.accessibility-font-size-s {
  font-size: 0.875rem;
}
.accessibility-font-size-s #egradjani #filter_slideout h3, .accessibility-font-size-s #egradjani #filter_slideout .h3 {
  font-size: 1.075rem !important;
}
.accessibility-font-size-s #egradjani #filter_slideout h4, .accessibility-font-size-s #egradjani #filter_slideout .h4 {
  font-size: 1rem !important;
}
.accessibility-font-size-s #egradjani #filter_slideout .filter_results.p {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s #egradjani .zgl-inputfield {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s #egradjani .zgl-searchbutton {
  font-size: 1.325rem !important;
}
.accessibility-font-size-s #egradjani #user_slideout p {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s #egradjani #user_slideout a.action {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s #egradjani #user_slideout .zgl-icon {
  font-size: 33px !important;
}
.accessibility-font-size-s .alert {
  line-height: 18px !important;
}
.accessibility-font-size-s .bm-subitem {
  font-size: 0.785rem !important;
}
.accessibility-font-size-s .btn {
  font-size: 0.825rem !important;
  height: 30px !important;
}
.accessibility-font-size-s .btn.btn-lg, .accessibility-font-size-s .btn-group-lg > .btn {
  font-size: 0.95rem !important;
  height: 32px !important;
}
.accessibility-font-size-s .button-in-action-column.btn {
  font-size: 0.75rem !important;
  min-height: 24px !important;
}
.accessibility-font-size-s .case-header-column > .case-header-label, .accessibility-font-size-s .case-header-text {
  font-size: 1.05rem !important;
}
.accessibility-font-size-s .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 11px !important;
  padding-right: 36px !important;
}
.accessibility-font-size-s .custom-toggle-wrapper {
  height: 26px !important;
}
.accessibility-font-size-s .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 12px !important;
  padding: 0 11px 0 36px !important;
}
.accessibility-font-size-s .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 22px !important;
  height: 22px !important;
}
.accessibility-font-size-s .footer .row span {
  margin-top: 16px !important;
}
.accessibility-font-size-s .form-control {
  font-size: 0.95rem !important;
}
.accessibility-font-size-s .form-control:not(textarea) {
  height: 32px !important;
}
.accessibility-font-size-s .form-switch .form-check-input {
  width: 54px !important;
  height: 22px !important;
  margin-left: -3em !important;
}
.accessibility-font-size-s .form-header {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s .icon-table, .accessibility-font-size-s .icon-table-header {
  font-size: 0.95rem !important;
}
.accessibility-font-size-s .input-group input[type=text] {
  height: 32px !important;
}
.accessibility-font-size-s .input-group-text {
  height: 32px !important;
}
.accessibility-font-size-s .input-group-text svg {
  width: 15px !important;
  height: 15px !important;
}
.accessibility-font-size-s .label label,
.accessibility-font-size-s .invalid-feedback,
.accessibility-font-size-s .sidebar a {
  font-size: 0.775rem !important;
}
.accessibility-font-size-s .lead {
  font-size: 1.2rem !important;
}
.accessibility-font-size-s .modal-content .modal-body {
  font-size: 0.825rem !important;
}
.accessibility-font-size-s .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-s .pagination-wrapper .edozvola-select {
  font-size: 0.9rem !important;
  height: 32px !important;
}
.accessibility-font-size-s .rdt .rdtPicker table {
  font-size: 0.925rem !important;
}
.accessibility-font-size-s .table thead {
  font-size: 0.7rem !important;
}
.accessibility-font-size-s .table thead th .table-sort {
  font-size: 0.95rem !important;
}
.accessibility-font-size-s .table tbody {
  font-size: 0.7rem !important;
}
.accessibility-font-size-s .toggle-text.false:after {
  left: 25px !important;
}
.accessibility-font-size-s .toggle-text.true:after {
  left: 8px !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .btn {
  min-height: 32px !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 0.95rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 0.95rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 0.825rem !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 0.825rem !important;
}
.accessibility-font-size-s h3, .accessibility-font-size-s .h3 {
  font-size: 1.625rem !important;
}
.accessibility-font-size-s h4, .accessibility-font-size-s .h4 {
  font-size: 1.375rem !important;
}
.accessibility-font-size-s h5, .accessibility-font-size-s .h5 {
  font-size: 1.125rem !important;
}
.accessibility-font-size-s h6, .accessibility-font-size-s .h6 {
  font-size: 0.875rem !important;
}
.accessibility-font-size-s p {
  font-size: 0.825rem !important;
}

.accessibility-font-size-xs {
  font-size: 0.825rem;
}
.accessibility-font-size-xs #egradjani #filter_slideout h3, .accessibility-font-size-xs #egradjani #filter_slideout .h3 {
  font-size: 1.025rem !important;
}
.accessibility-font-size-xs #egradjani #filter_slideout h4, .accessibility-font-size-xs #egradjani #filter_slideout .h4 {
  font-size: 0.95rem !important;
}
.accessibility-font-size-xs #egradjani #filter_slideout .filter_results.p {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs #egradjani .zgl-inputfield {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs #egradjani .zgl-searchbutton {
  font-size: 1.275rem !important;
}
.accessibility-font-size-xs #egradjani #user_slideout p {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs #egradjani #user_slideout a.action {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs #egradjani #user_slideout .zgl-icon {
  font-size: 31px !important;
}
.accessibility-font-size-xs .alert {
  line-height: 16px !important;
}
.accessibility-font-size-xs .bm-subitem {
  font-size: 0.725rem !important;
}
.accessibility-font-size-xs .btn {
  font-size: 0.775rem !important;
  height: 29px !important;
}
.accessibility-font-size-xs .btn.btn-lg, .accessibility-font-size-xs .btn-group-lg > .btn {
  font-size: 0.9rem !important;
  min-height: 30px !important;
}
.accessibility-font-size-xs .button-in-action-column.btn {
  font-size: 0.75rem !important;
  min-height: 23px !important;
}
.accessibility-font-size-xs .case-header-column > .case-header-label, .accessibility-font-size-xs .case-header-text {
  font-size: 1rem !important;
}
.accessibility-font-size-xs .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 10px !important;
  padding-right: 34px !important;
}
.accessibility-font-size-xs .custom-toggle-wrapper {
  height: 24px !important;
}
.accessibility-font-size-xs .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 11px !important;
  padding: 0 10px 0 34px !important;
}
.accessibility-font-size-xs .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 20px !important;
  height: 20px !important;
}
.accessibility-font-size-xs .footer .row span {
  margin-top: 17px !important;
}
.accessibility-font-size-xs .form-control {
  font-size: 0.9rem !important;
}
.accessibility-font-size-xs .form-control:not(textarea) {
  height: 30px !important;
}
.accessibility-font-size-xs .form-header {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs .form-switch .form-check-input {
  width: 52px !important;
  height: 22px !important;
  margin-left: -3.2em !important;
}
.accessibility-font-size-xs .icon-table, .accessibility-font-size-xs .icon-table-header {
  font-size: 0.9rem !important;
}
.accessibility-font-size-xs .input-group {
  height: 30px !important;
}
.accessibility-font-size-xs .input-group-text {
  height: 30px !important;
}
.accessibility-font-size-xs .input-group-text svg {
  width: 14px !important;
  height: 14px !important;
}
.accessibility-font-size-xs .label label,
.accessibility-font-size-xs .invalid-feedback,
.accessibility-font-size-xs .sidebar a {
  font-size: 0.725rem !important;
}
.accessibility-font-size-xs .lead {
  font-size: 1.15rem !important;
}
.accessibility-font-size-xs .modal-content .modal-body {
  font-size: 0.775rem !important;
}
.accessibility-font-size-xs .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-xs .pagination-wrapper .edozvola-select {
  font-size: 0.8rem !important;
  height: 30px !important;
}
.accessibility-font-size-xs .rdt .rdtPicker table {
  font-size: 0.875rem !important;
}
.accessibility-font-size-xs .table thead {
  font-size: 0.65rem !important;
}
.accessibility-font-size-xs .table thead th .table-sort {
  font-size: 0.9rem !important;
}
.accessibility-font-size-xs .table tbody {
  font-size: 0.65rem !important;
}
.accessibility-font-size-xs .toggle-text.false:after {
  left: 25px !important;
}
.accessibility-font-size-xs .toggle-text.true:after {
  left: 6px !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .btn {
  min-height: 30px !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 0.9rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 0.9rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 0.775rem !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 0.775rem !important;
}
.accessibility-font-size-xs h3, .accessibility-font-size-xs .h3 {
  font-size: 1.575rem !important;
}
.accessibility-font-size-xs h4, .accessibility-font-size-xs .h4 {
  font-size: 1.325rem !important;
}
.accessibility-font-size-xs h5, .accessibility-font-size-xs .h5 {
  font-size: 1.075rem !important;
}
.accessibility-font-size-xs h6, .accessibility-font-size-xs .h6 {
  font-size: 0.825rem !important;
}
.accessibility-font-size-xs p {
  font-size: 0.775rem !important;
}

.accessibility-font-size-2xs {
  font-size: 0.775rem;
}
.accessibility-font-size-2xs #egradjani #filter_slideout h3, .accessibility-font-size-2xs #egradjani #filter_slideout .h3 {
  font-size: 0.975rem !important;
}
.accessibility-font-size-2xs #egradjani #filter_slideout h4, .accessibility-font-size-2xs #egradjani #filter_slideout .h4 {
  font-size: 0.9rem !important;
}
.accessibility-font-size-2xs #egradjani #filter_slideout .filter_results.p {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs #egradjani .zgl-inputfield {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs #egradjani .zgl-searchbutton {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xs #egradjani #user_slideout p {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs #egradjani #user_slideout a.action {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs #egradjani #user_slideout .zgl-icon {
  font-size: 29px !important;
}
.accessibility-font-size-2xs .alert {
  line-height: 14px !important;
}
.accessibility-font-size-2xs .bm-subitem {
  font-size: 0.675rem !important;
}
.accessibility-font-size-2xs .btn {
  font-size: 0.725rem !important;
  height: 28px !important;
}
.accessibility-font-size-2xs .btn.btn-lg, .accessibility-font-size-2xs .btn-group-lg > .btn {
  font-size: 0.85rem !important;
  height: 28px !important;
}
.accessibility-font-size-2xs .button-in-action-column.btn {
  font-size: 0.7rem !important;
  min-height: 22px !important;
}
.accessibility-font-size-2xs .case-header-column > .case-header-label, .accessibility-font-size-2xs .case-header-text {
  font-size: 0.95rem !important;
}
.accessibility-font-size-2xs .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 9px !important;
  padding-right: 32px !important;
}
.accessibility-font-size-2xs .custom-toggle-wrapper {
  height: 22px !important;
}
.accessibility-font-size-2xs .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 10px !important;
  padding: 0 9px 0 32px !important;
}
.accessibility-font-size-2xs .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 18px !important;
  height: 18px !important;
}
.accessibility-font-size-2xs .footer .row span {
  margin-top: 18px !important;
}
.accessibility-font-size-2xs .form-control {
  font-size: 0.85rem !important;
}
.accessibility-font-size-2xs .form-control:not(textarea) {
  height: 28px !important;
}
.accessibility-font-size-2xs .form-header {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs .form-switch .form-check-input {
  width: 48px !important;
  height: 20px !important;
  margin-left: -3.4em !important;
}
.accessibility-font-size-2xs .icon-table, .accessibility-font-size-2xs .icon-table-header {
  font-size: 0.85rem !important;
}
.accessibility-font-size-2xs .input-group input[type=text] {
  height: 28px !important;
}
.accessibility-font-size-2xs .input-group-text {
  height: 28px !important;
}
.accessibility-font-size-2xs .input-group-text svg {
  width: 13px !important;
  height: 13px !important;
}
.accessibility-font-size-2xs .label label,
.accessibility-font-size-2xs .invalid-feedback,
.accessibility-font-size-2xs .sidebar a {
  font-size: 0.675rem !important;
}
.accessibility-font-size-2xs .lead {
  font-size: 1.1rem !important;
}
.accessibility-font-size-2xs .modal-content .modal-body {
  font-size: 0.725rem !important;
}
.accessibility-font-size-2xs .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-2xs .pagination-wrapper .edozvola-select {
  font-size: 0.7rem !important;
  height: 28px !important;
}
.accessibility-font-size-2xs .rdt .rdtPicker table {
  font-size: 0.825rem !important;
}
.accessibility-font-size-2xs .table thead {
  font-size: 0.6rem !important;
}
.accessibility-font-size-2xs .table thead th .table-sort {
  font-size: 0.85rem !important;
}
.accessibility-font-size-2xs .table tbody {
  font-size: 0.6rem !important;
}
.accessibility-font-size-2xs .toggle-text.false:after {
  left: 25px !important;
}
.accessibility-font-size-2xs .toggle-text.true:after {
  left: 6px !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .btn {
  min-height: 28px !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 0.85rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 0.85rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 0.725rem !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 0.725rem !important;
}
.accessibility-font-size-2xs h3, .accessibility-font-size-2xs .h3 {
  font-size: 1.525rem !important;
}
.accessibility-font-size-2xs h4, .accessibility-font-size-2xs .h4 {
  font-size: 1.275rem !important;
}
.accessibility-font-size-2xs h5, .accessibility-font-size-2xs .h5 {
  font-size: 1.025rem !important;
}
.accessibility-font-size-2xs h6, .accessibility-font-size-2xs .h6 {
  font-size: 0.775rem !important;
}
.accessibility-font-size-2xs p {
  font-size: 0.725rem !important;
}

.accessibility-font-size-3xs {
  font-size: 0.725rem;
}
.accessibility-font-size-3xs #egradjani #filter_slideout h3, .accessibility-font-size-3xs #egradjani #filter_slideout .h3 {
  font-size: 0.925rem !important;
}
.accessibility-font-size-3xs #egradjani #filter_slideout h4, .accessibility-font-size-3xs #egradjani #filter_slideout .h4 {
  font-size: 0.85rem !important;
}
.accessibility-font-size-3xs #egradjani #filter_slideout .filter_results.p {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs #egradjani .zgl-inputfield {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs #egradjani .zgl-searchbutton {
  font-size: 1.175rem !important;
}
.accessibility-font-size-3xs #egradjani #user_slideout p {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs #egradjani #user_slideout a.action {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs #egradjani #user_slideout .zgl-icon {
  font-size: 27px !important;
}
.accessibility-font-size-3xs .alert {
  line-height: 12px !important;
}
.accessibility-font-size-3xs .bm-subitem {
  font-size: 0.625rem !important;
}
.accessibility-font-size-3xs .btn {
  font-size: 0.675rem !important;
  height: 28px !important;
}
.accessibility-font-size-3xs .btn.btn-lg, .accessibility-font-size-3xs .btn-group-lg > .btn {
  font-size: 0.8rem !important;
  height: 26px !important;
}
.accessibility-font-size-3xs .button-in-action-column.btn {
  font-size: 0.65rem !important;
  min-height: 21px !important;
}
.accessibility-font-size-3xs .case-header-column > .case-header-label, .accessibility-font-size-3xs .case-header-text {
  font-size: 0.9rem !important;
}
.accessibility-font-size-3xs .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 8px !important;
  padding-right: 30px !important;
}
.accessibility-font-size-3xs .custom-toggle-wrapper {
  height: 20px !important;
}
.accessibility-font-size-3xs .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 9px !important;
  padding: 0 8px 0 32px !important;
}
.accessibility-font-size-3xs .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 16px !important;
  height: 16px !important;
}
.accessibility-font-size-3xs .footer .row span {
  margin-top: 19px !important;
}
.accessibility-font-size-3xs .form-control {
  font-size: 0.8rem !important;
}
.accessibility-font-size-3xs .form-control:not(textarea) {
  height: 26px !important;
}
.accessibility-font-size-3xs .form-header {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs .form-switch .form-check-input {
  width: 44px !important;
  height: 19px !important;
  margin-left: -3.5em !important;
}
.accessibility-font-size-3xs .icon-table, .accessibility-font-size-3xs .icon-table-header {
  font-size: 0.8rem !important;
}
.accessibility-font-size-3xs .input-group input[type=text] {
  height: 26px !important;
}
.accessibility-font-size-3xs .input-group-text {
  height: 26px !important;
}
.accessibility-font-size-3xs .input-group-text svg {
  width: 12px !important;
  height: 12px !important;
}
.accessibility-font-size-3xs .label label,
.accessibility-font-size-3xs .invalid-feedback,
.accessibility-font-size-3xs .sidebar a {
  font-size: 0.625rem !important;
}
.accessibility-font-size-3xs .lead {
  font-size: 1.05rem !important;
}
.accessibility-font-size-3xs .modal-content .modal-body {
  font-size: 0.675rem !important;
}
.accessibility-font-size-3xs .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-3xs .pagination-wrapper .edozvola-select {
  font-size: 0.6rem !important;
  height: 26px !important;
}
.accessibility-font-size-3xs .rdt .rdtPicker table {
  font-size: 0.775rem !important;
}
.accessibility-font-size-3xs .table thead {
  font-size: 0.55rem !important;
}
.accessibility-font-size-3xs .table thead th .table-sort {
  font-size: 0.8rem !important;
}
.accessibility-font-size-3xs .table tbody {
  font-size: 0.55rem !important;
}
.accessibility-font-size-3xs .toggle-text.false:after {
  left: 20px !important;
}
.accessibility-font-size-3xs .toggle-text.true:after {
  left: 4px !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .btn {
  min-height: 26px !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 0.8rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 0.8rem !important;
  margin-top: -2px !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 0.675rem !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 0.675rem !important;
}
.accessibility-font-size-3xs h3, .accessibility-font-size-3xs .h3 {
  font-size: 1.475rem !important;
}
.accessibility-font-size-3xs h4, .accessibility-font-size-3xs .h4 {
  font-size: 1.225rem !important;
}
.accessibility-font-size-3xs h5, .accessibility-font-size-3xs .h5 {
  font-size: 0.975rem !important;
}
.accessibility-font-size-3xs h6, .accessibility-font-size-3xs .h6 {
  font-size: 0.725rem !important;
}
.accessibility-font-size-3xs p {
  font-size: 0.675rem !important;
}

.accessibility-font-size-l {
  font-size: 1.125rem;
}
.accessibility-font-size-l #egradjani #filter_slideout h3, .accessibility-font-size-l #egradjani #filter_slideout .h3 {
  font-size: 1.25rem !important;
}
.accessibility-font-size-l #egradjani #filter_slideout h4, .accessibility-font-size-l #egradjani #filter_slideout .h4 {
  font-size: 1.15rem !important;
}
.accessibility-font-size-l #egradjani #filter_slideout p.filter_results {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l #egradjani .zgl-inputfield {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l #egradjani .zgl-searchbutton {
  font-size: 1.5rem !important;
}
.accessibility-font-size-l #egradjani #user_slideout p {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l #egradjani #user_slideout a.action {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l #egradjani #user_slideout .zgl-icon {
  font-size: 37px !important;
}
.accessibility-font-size-l .bm-subitem {
  font-size: 0.875rem !important;
}
.accessibility-font-size-l .btn {
  font-size: 1rem !important;
  min-height: 36px !important;
}
.accessibility-font-size-l .btn.btn-lg, .accessibility-font-size-l .btn-group-lg > .btn {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l .button-in-action-column.btn {
  font-size: 0.9rem !important;
  min-height: 26px !important;
}
.accessibility-font-size-l .case-header-column > .case-header-label, .accessibility-font-size-l .case-header-text {
  font-size: 1.15rem !important;
}
.accessibility-font-size-l .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 13px !important;
  padding-right: 40px !important;
}
.accessibility-font-size-l .custom-toggle-wrapper {
  min-height: 30px !important;
}
.accessibility-font-size-l .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 16px !important;
  padding: 0 13px 0 40px !important;
}
.accessibility-font-size-l .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 26px !important;
  height: 26px !important;
}
.accessibility-font-size-l .form-control {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l .form-header {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l .form-switch .form-check-input {
  width: 68px !important;
  height: 28px !important;
  margin-left: -2em !important;
}
.accessibility-font-size-l .icon-table, .accessibility-font-size-l .icon-table-header {
  font-size: 1.25rem !important;
}
.accessibility-font-size-l .input-group input[type=text] {
  height: 36px !important;
}
.accessibility-font-size-l .input-group-text svg {
  width: 17px !important;
  height: 17px !important;
}
.accessibility-font-size-l .label label,
.accessibility-font-size-l .invalid-feedback,
.accessibility-font-size-l .sidebar a {
  font-size: 0.975rem !important;
}
.accessibility-font-size-l .lead {
  font-size: 1.3rem !important;
}
.accessibility-font-size-l .modal-content .modal-body {
  font-size: 1rem !important;
}
.accessibility-font-size-l .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-l .pagination-wrapper .edozvola-select {
  font-size: 1.1rem !important;
  height: 36px !important;
}
.accessibility-font-size-l .rdt .rdtPicker table {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l .table thead {
  font-size: 0.8rem !important;
}
.accessibility-font-size-l .table thead th .table-sort {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l .table tbody {
  font-size: 0.8rem !important;
}
.accessibility-font-size-l .toggle-text.false:after {
  left: 32px !important;
}
.accessibility-font-size-l .toggle-text.true:after {
  left: 12px !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 1.05rem !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 1rem !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 1rem !important;
}
.accessibility-font-size-l h3, .accessibility-font-size-l .h3 {
  font-size: 1.875rem !important;
}
.accessibility-font-size-l h4, .accessibility-font-size-l .h4 {
  font-size: 1.625rem !important;
}
.accessibility-font-size-l h5, .accessibility-font-size-l .h5 {
  font-size: 1.375rem !important;
}
.accessibility-font-size-l h6, .accessibility-font-size-l .h6 {
  font-size: 1.125rem !important;
}
.accessibility-font-size-l p {
  font-size: 0.925rem !important;
}

.accessibility-font-size-xl {
  font-size: 1.175rem;
}
.accessibility-font-size-xl #egradjani #filter_slideout h3, .accessibility-font-size-xl #egradjani #filter_slideout .h3 {
  font-size: 1.3rem !important;
}
.accessibility-font-size-xl #egradjani #filter_slideout h4, .accessibility-font-size-xl #egradjani #filter_slideout .h4 {
  font-size: 1.2rem !important;
}
.accessibility-font-size-xl #egradjani #filter_slideout .filter_results.p {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl #egradjani .zgl-inputfield {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl #egradjani .zgl-searchbutton {
  font-size: 1.55rem !important;
}
.accessibility-font-size-xl #egradjani #user_slideout p {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl #egradjani #user_slideout a.action {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl #egradjani #user_slideout .zgl-icon {
  font-size: 39px !important;
}
.accessibility-font-size-xl .bm-subitem {
  font-size: 0.925rem !important;
}
.accessibility-font-size-xl .btn {
  font-size: 1.05rem !important;
  min-height: 38px !important;
}
.accessibility-font-size-xl .btn.btn-lg, .accessibility-font-size-xl .btn-group-lg > .btn {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl .button-in-action-column.btn {
  font-size: 0.95rem !important;
  min-height: 27px !important;
}
.accessibility-font-size-xl .case-header-column > .case-header-label, .accessibility-font-size-xl .case-header-text {
  font-size: 1.2rem !important;
}
.accessibility-font-size-xl .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 14px !important;
  padding-right: 42px !important;
}
.accessibility-font-size-xl .custom-toggle-wrapper {
  min-height: 32px !important;
}
.accessibility-font-size-xl .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 17px !important;
  padding: 0 14px 0 42px !important;
}
.accessibility-font-size-xl .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 28px !important;
  height: 28px !important;
}
.accessibility-font-size-xl .form-control {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl .form-header {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl .form-switch .form-check-input {
  width: 72px !important;
  height: 30px !important;
  margin-left: -1.8em !important;
}
.accessibility-font-size-xl .icon-table, .accessibility-font-size-xl .icon-table-header {
  font-size: 1.3rem !important;
}
.accessibility-font-size-xl .input-group input[type=text] {
  height: 38px !important;
}
.accessibility-font-size-xl .input-group-text svg {
  width: 18px !important;
  height: 18px !important;
}
.accessibility-font-size-xl .label label,
.accessibility-font-size-xl .invalid-feedback,
.accessibility-font-size-xl .sidebar a {
  font-size: 1.025rem !important;
}
.accessibility-font-size-xl .lead {
  font-size: 1.35rem !important;
}
.accessibility-font-size-xl .modal-content .modal-body {
  font-size: 1.125rem !important;
}
.accessibility-font-size-xl .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-xl .pagination-wrapper .edozvola-select {
  font-size: 1.2rem !important;
  height: 38px !important;
}
.accessibility-font-size-xl .rdt .rdtPicker table {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl .table thead {
  font-size: 0.85rem !important;
}
.accessibility-font-size-xl .table thead th .table-sort {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl .table tbody {
  font-size: 0.85rem !important;
}
.accessibility-font-size-xl .toggle-text.false:after {
  left: 34px !important;
}
.accessibility-font-size-xl .toggle-text.true:after {
  left: 14px !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 1.1rem !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 1.05rem !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 1.05rem !important;
}
.accessibility-font-size-xl h3, .accessibility-font-size-xl .h3 {
  font-size: 1.925rem !important;
}
.accessibility-font-size-xl h4, .accessibility-font-size-xl .h4 {
  font-size: 1.675rem !important;
}
.accessibility-font-size-xl h5, .accessibility-font-size-xl .h5 {
  font-size: 1.425rem !important;
}
.accessibility-font-size-xl h6, .accessibility-font-size-xl .h6 {
  font-size: 1.175rem !important;
}
.accessibility-font-size-xl p {
  font-size: 0.975rem !important;
}

.accessibility-font-size-2xl {
  font-size: 1.225rem;
}
.accessibility-font-size-2xl #egradjani #filter_slideout h3, .accessibility-font-size-2xl #egradjani #filter_slideout .h3 {
  font-size: 1.35rem !important;
}
.accessibility-font-size-2xl #egradjani #filter_slideout h4, .accessibility-font-size-2xl #egradjani #filter_slideout .h4 {
  font-size: 1.25rem !important;
}
.accessibility-font-size-2xl #egradjani #filter_slideout .filter_results.p {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl #egradjani .zgl-inputfield {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl #egradjani .zgl-searchbutton {
  font-size: 1.6rem !important;
}
.accessibility-font-size-2xl #egradjani #user_slideout p {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl #egradjani #user_slideout a.action {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl #egradjani #user_slideout .zgl-icon {
  font-size: 41px !important;
}
.accessibility-font-size-2xl .bm-subitem {
  font-size: 0.975rem !important;
}
.accessibility-font-size-2xl .btn {
  font-size: 1.1rem !important;
  min-height: 40px !important;
}
.accessibility-font-size-2xl .btn.btn-lg, .accessibility-font-size-2xl .btn-group-lg > .btn {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl .button-in-action-column.btn {
  font-size: 1rem !important;
  min-height: 28px !important;
}
.accessibility-font-size-2xl .case-header-column > .case-header-label, .accessibility-font-size-2xl .case-header-text {
  font-size: 1.25rem !important;
}
.accessibility-font-size-2xl .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 15px !important;
  padding-right: 44px !important;
}
.accessibility-font-size-2xl .custom-toggle-wrapper {
  min-height: 34px !important;
}
.accessibility-font-size-2xl .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 18px !important;
  padding: 0 15px 0 44px !important;
}
.accessibility-font-size-2xl .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 30px !important;
  height: 30px !important;
}
.accessibility-font-size-2xl .form-control {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl .form-header {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl .form-switch .form-check-input {
  width: 76px !important;
  height: 32px !important;
  margin-left: -1.6em !important;
}
.accessibility-font-size-2xl .input-group input[type=text] {
  height: 40px !important;
}
.accessibility-font-size-2xl .icon-table, .accessibility-font-size-2xl .icon-table-header {
  font-size: 1.35rem !important;
}
.accessibility-font-size-2xl .input-group-text svg {
  width: 19px !important;
  height: 19px !important;
}
.accessibility-font-size-2xl .label label,
.accessibility-font-size-2xl .invalid-feedback,
.accessibility-font-size-2xl .sidebar a {
  font-size: 1.075rem !important;
}
.accessibility-font-size-2xl .lead {
  font-size: 1.4rem !important;
}
.accessibility-font-size-2xl .modal-content .modal-body {
  font-size: 1.25rem !important;
}
.accessibility-font-size-2xl .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-2xl .pagination-wrapper .edozvola-select {
  font-size: 1.3rem !important;
  height: 40px !important;
}
.accessibility-font-size-2xl .rdt .rdtPicker table {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl .table thead {
  font-size: 0.9rem !important;
}
.accessibility-font-size-2xl .table thead th .table-sort {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl .table tbody {
  font-size: 0.9rem !important;
}
.accessibility-font-size-2xl .toggle-text.false:after {
  left: 36px !important;
}
.accessibility-font-size-2xl .toggle-text.true:after {
  left: 16px !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 1.15rem !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 1.1rem !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 1.1rem !important;
}
.accessibility-font-size-2xl h3, .accessibility-font-size-2xl .h3 {
  font-size: 1.975rem !important;
}
.accessibility-font-size-2xl h4, .accessibility-font-size-2xl .h4 {
  font-size: 1.725rem !important;
}
.accessibility-font-size-2xl h5, .accessibility-font-size-2xl .h5 {
  font-size: 1.475rem !important;
}
.accessibility-font-size-2xl h6, .accessibility-font-size-2xl .h6 {
  font-size: 1.225rem !important;
}
.accessibility-font-size-2xl p {
  font-size: 1.025rem !important;
}

.accessibility-font-size-3xl {
  font-size: 1.275rem;
}
.accessibility-font-size-3xl #egradjani #filter_slideout h3, .accessibility-font-size-3xl #egradjani #filter_slideout .h3 {
  font-size: 1.4rem !important;
}
.accessibility-font-size-3xl #egradjani #filter_slideout h4, .accessibility-font-size-3xl #egradjani #filter_slideout .h4 {
  font-size: 1.3rem !important;
}
.accessibility-font-size-3xl #egradjani #filter_slideout .filter_results.p {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl #egradjani .zgl-inputfield {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl #egradjani .zgl-searchbutton {
  font-size: 1.65rem !important;
}
.accessibility-font-size-3xl #egradjani #user_slideout p {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl #egradjani #user_slideout a.action {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl #egradjani #user_slideout .zgl-icon {
  font-size: 43px !important;
}
.accessibility-font-size-3xl .bm-subitem {
  font-size: 1.025rem !important;
}
.accessibility-font-size-3xl .btn {
  font-size: 1.15rem !important;
  min-height: 42px !important;
}
.accessibility-font-size-3xl .btn.btn-lg, .accessibility-font-size-3xl .btn-group-lg > .btn {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl .button-in-action-column.btn {
  font-size: 1.05rem !important;
  min-height: 29px !important;
}
.accessibility-font-size-3xl .case-header-column > .case-header-label, .accessibility-font-size-3xl .case-header-text {
  font-size: 1.3rem !important;
}
.accessibility-font-size-3xl .custom-toggle-checkbox:checked + .custom-toggle-slider {
  padding-left: 16px !important;
  padding-right: 46px !important;
}
.accessibility-font-size-3xl .custom-toggle-wrapper {
  min-height: 36px !important;
}
.accessibility-font-size-3xl .custom-toggle-wrapper .custom-toggle-slider {
  font-size: 19px !important;
  padding: 0 16px 0 46px !important;
}
.accessibility-font-size-3xl .custom-toggle-wrapper .custom-toggle-slider .custom-toggle-ball {
  width: 32px !important;
  height: 32px !important;
}
.accessibility-font-size-3xl .form-control {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl .form-header {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl .form-switch .form-check-input {
  width: 80px !important;
  height: 34px !important;
  margin-left: -1.4em !important;
}
.accessibility-font-size-3xl .icon-table, .accessibility-font-size-3xl .icon-table-header {
  font-size: 1.4rem !important;
}
.accessibility-font-size-3xl .input-group input[type=text] {
  height: 42px !important;
}
.accessibility-font-size-3xl .input-group-text svg {
  width: 20px !important;
  height: 20px !important;
}
.accessibility-font-size-3xl .label label,
.accessibility-font-size-3xl .invalid-feedback,
.accessibility-font-size-3xl .sidebar a {
  font-size: 1.125rem !important;
}
.accessibility-font-size-3xl .lead {
  font-size: 1.45rem !important;
}
.accessibility-font-size-3xl .modal-content .modal-body {
  font-size: 1.375rem !important;
}
.accessibility-font-size-3xl .pagination-wrapper .pagination .page-item .page-link,
.accessibility-font-size-3xl .pagination-wrapper .edozvola-select {
  font-size: 1.4rem !important;
  height: 42px !important;
}
.accessibility-font-size-3xl .rdt .rdtPicker table {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl .table thead {
  font-size: 0.95rem !important;
}
.accessibility-font-size-3xl .table thead th .table-sort {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl .table tbody {
  font-size: 0.95rem !important;
}
.accessibility-font-size-3xl .toggle-text.false:after {
  left: 38px !important;
}
.accessibility-font-size-3xl .toggle-text.true:after {
  left: 16px !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .btn .dropdown-toggle-item {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .btn .multiple {
  font-size: 1.2rem !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .dropdown-item {
  font-size: 1.15rem !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .icon {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .hint, .accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .close {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl div[id\$=-paginated-dropdown].dropdown .no-value-text {
  font-size: 1.15rem !important;
}
.accessibility-font-size-3xl h3, .accessibility-font-size-3xl .h3 {
  font-size: 2.025rem !important;
}
.accessibility-font-size-3xl h4, .accessibility-font-size-3xl .h4 {
  font-size: 1.775rem !important;
}
.accessibility-font-size-3xl h5, .accessibility-font-size-3xl .h5 {
  font-size: 1.525rem !important;
}
.accessibility-font-size-3xl h6, .accessibility-font-size-3xl .h6 {
  font-size: 1.275rem !important;
}
.accessibility-font-size-3xl p {
  font-size: 1.075rem !important;
}

@font-face {
  font-family: "open-dyslexic";
  src: url("../content/fonts/open-dyslexic/OpenDyslexic-Regular.eot");
  src: url("../content/fonts/open-dyslexic/OpenDyslexic-Regular.eot?#iefix") format("embedded-opentype"), url("../content/fonts/open-dyslexic/OpenDyslexic-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
body {
  background: #fafafa;
  margin: 0;
}

::-webkit-scrollbar {
  display: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

a {
  color: #533f03;
  font-weight: bold;
}

* {
  box-sizing: border-box;
}
*:after, *::before {
  box-sizing: border-box;
}

.app-container {
  height: 100vh;
  box-sizing: border-box;
}
.app-container .view-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-x: hidden;
  padding: 25px 1rem 1rem;
}
.app-container .view-container .card {
  padding: 1rem;
}

.view-routes {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.view-routes > main {
  width: 100%;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

main > .page-content {
  z-index: 0;
}

.btn-danger {
  background-color: #960C0C;
  border-color: #960C0C;
}
.btn-danger:hover, .btn-danger:active, .btn-danger:focus, .btn-danger:focus:active, .btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled):active {
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-secondary:not(:has(.dropdown-toggle-item)), .btn-outline-secondary:not(:has(.dropdown-toggle-item)) {
  border-color: #6c757d;
  color: #343a40;
}
.btn-secondary:not(:has(.dropdown-toggle-item)):not(.disabled) .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):not(.disabled) .btn-label {
  color: #343a40;
}
.btn-secondary:not(:has(.dropdown-toggle-item)):hover, .btn-secondary:not(:has(.dropdown-toggle-item)):active, .btn-secondary:not(:has(.dropdown-toggle-item)):focus, .btn-secondary:not(:has(.dropdown-toggle-item)):focus:active, .btn-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled).active, .btn-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):hover, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):active, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):focus, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):focus:active, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled).active, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled):active {
  background-color: #6c757d;
}
.btn-secondary:not(:has(.dropdown-toggle-item)):hover .btn-label, .btn-secondary:not(:has(.dropdown-toggle-item)):active .btn-label, .btn-secondary:not(:has(.dropdown-toggle-item)):focus .btn-label, .btn-secondary:not(:has(.dropdown-toggle-item)):focus:active .btn-label, .btn-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled).active .btn-label, .btn-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled):active .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):hover .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):active .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):focus .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):focus:active .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled).active .btn-label, .btn-outline-secondary:not(:has(.dropdown-toggle-item)):not(:disabled):not(.disabled):active .btn-label {
  color: #fff;
}

.red-addon-append .input-group-text {
  border-color: #960C0C !important;
  color: white;
  background-color: #960C0C !important;
}
.red-addon-append .input-group-text:hover {
  border-color: #dc3545 !important;
  color: white;
  background-color: #dc3545 !important;
}

.fullscreen {
  text-align: center;
  z-index: 9999;
  padding: 5px 25px 50px 25px !important;
  height: 100vh !important;
  width: 100%;
  position: absolute;
  top: -100px;
}

.loader-animation {
  width: 15% !important;
  position: absolute;
  top: 50%;
}

/* ==========================================================================
Browser Upgrade Prompt
========================================================================== */
.browserupgrade {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

/* ==========================================================================
Custom button styles
========================================================================== */
.icon-button > .btn {
  background-color: transparent;
  border-color: transparent;
  padding: 0.5rem;
  line-height: 1rem;
}
.icon-button > .btn:hover {
  background-color: transparent;
  border-color: transparent;
}
.icon-button > .btn:focus {
  box-shadow: none;
}

/* ==========================================================================
Generic styles
========================================================================== */
/* Temporary workaround for availity-reactstrap-validation */
.invalid-feedback {
  display: inline;
}

/* other generic styles */
.title {
  font-size: 1.25em;
  margin: 1px 10px 1px 10px;
}

.description {
  font-size: 0.9em;
  margin: 1px 10px 1px 10px;
}

input:disabled {
  color: #828a90 !important;
}

.shadow {
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  border-radius: 2px;
}

.error {
  color: white;
  background-color: red;
}

.break {
  white-space: normal;
  word-break: break-all;
}

.break-word {
  white-space: normal;
  word-break: keep-all;
}

.preserve-space {
  white-space: pre-wrap;
}

/* padding helpers */
.pad {
  padding: 10px !important;
}

.pad-2 {
  padding: 2px !important;
}

.pad-3 {
  padding: 3px !important;
}

.pad-5 {
  padding: 5px !important;
}

.pad-10 {
  padding: 10px !important;
}

.pad-20 {
  padding: 20px !important;
}

.pad-25 {
  padding: 25px !important;
}

.pad-30 {
  padding: 30px !important;
}

.pad-50 {
  padding: 50px !important;
}

.pad-75 {
  padding: 75px !important;
}

.pad-100 {
  padding: 100px !important;
}

.pad-top-4 {
  padding-top: 4px !important;
}

.pad-top-5 {
  padding-top: 5px !important;
}

.pad-top-10 {
  padding-top: 10px !important;
}

.pad-top-20 {
  padding-top: 20px !important;
}

.pad-top-25 {
  padding-top: 25px !important;
}

.pad-top-30 {
  padding-top: 30px !important;
}

.pad-top-50 {
  padding-top: 50px !important;
}

.pad-top-75 {
  padding-top: 75px !important;
}

.pad-top-100 {
  padding-top: 100px !important;
}

.pad-bottom-4 {
  padding-bottom: 4px !important;
}

.pad-bottom-5 {
  padding-bottom: 5px !important;
}

.pad-bottom-10 {
  padding-bottom: 10px !important;
}

.pad-bottom-20 {
  padding-bottom: 20px !important;
}

.pad-bottom-25 {
  padding-bottom: 25px !important;
}

.pad-bottom-30 {
  padding-bottom: 30px !important;
}

.pad-bottom-50 {
  padding-bottom: 50px !important;
}

.pad-bottom-75 {
  padding-bottom: 75px !important;
}

.pad-bottom-100 {
  padding-bottom: 100px !important;
}

.pad-right-5 {
  padding-right: 5px !important;
}

.pad-right-10 {
  padding-right: 10px !important;
}

.pad-right-20 {
  padding-right: 20px !important;
}

.pad-right-25 {
  padding-right: 25px !important;
}

.pad-right-30 {
  padding-right: 30px !important;
}

.pad-right-50 {
  padding-right: 50px !important;
}

.pad-right-75 {
  padding-right: 75px !important;
}

.pad-right-100 {
  padding-right: 100px !important;
}

.pad-left-5 {
  padding-left: 5px !important;
}

.pad-left-10 {
  padding-left: 10px !important;
}

.pad-left-20 {
  padding-left: 20px !important;
}

.pad-left-25 {
  padding-left: 25px !important;
}

.pad-left-30 {
  padding-left: 30px !important;
}

.pad-left-50 {
  padding-left: 50px !important;
}

.pad-left-75 {
  padding-left: 75px !important;
}

.pad-left-100 {
  padding-left: 100px !important;
}

.no-padding-left {
  padding-left: 0 !important;
}

.no-padding-right {
  padding-right: 0 !important;
}

.no-padding-top {
  padding-top: 0 !important;
}

.no-padding-bottom {
  padding-bottom: 0 !important;
}

.no-padding {
  padding: 0 !important;
}

/* end of padding helpers */
.no-margin {
  margin: 0px;
}

.voffset {
  margin-top: 2px !important;
}

.voffset-5 {
  margin-top: 5px !important;
}

.voffset-10 {
  margin-top: 10px !important;
}

.voffset-15 {
  margin-top: 15px !important;
}

.voffset-30 {
  margin-top: 30px !important;
}

.voffset-40 {
  margin-top: 40px !important;
}

.voffset-60 {
  margin-top: 60px !important;
}

.voffset-80 {
  margin-top: 80px !important;
}

.voffset-100 {
  margin-top: 100px !important;
}

.voffset-150 {
  margin-top: 150px !important;
}

.readonly {
  background-color: #eee;
  opacity: 1;
}

/* ==========================================================================
make sure browsers use the pointer cursor for anchors, even with no href
========================================================================== */
a:hover {
  cursor: pointer;
}

.hand {
  cursor: pointer;
}

button.anchor-btn {
  background: none;
  border: none;
  padding: 0;
  align-items: initial;
  text-align: initial;
  width: 100%;
}

a.anchor-btn:hover {
  text-decoration: none;
}

/* ==========================================================================
Metrics and Health styles
========================================================================== */
#threadDump .popover,
#healthCheck .popover {
  top: inherit;
  display: block;
  font-size: 10px;
  max-width: 1024px;
}

.thread-dump-modal-lock {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#healthCheck .popover {
  margin-left: -50px;
}

.health-details {
  min-width: 400px;
}

/* bootstrap 3 input-group 100% width
http://stackoverflow.com/questions/23436430/bootstrap-3-input-group-100-width */
.width-min {
  width: 1% !important;
}

/* jhipster-needle-scss-add-main JHipster will add new css style */
.hidden-upload {
  display: none;
}

.readonly-upload-input {
  background-color: #fff !important;
  cursor: pointer;
}

.modal-footer {
  justify-content: space-between !important;
}

.input-invalid {
  border-radius: 5px !important;
  border: 1px #ca1820 solid !important;
}

.paragraph-header {
  color: #000000;
  font-weight: bold;
  margin-bottom: 20px;
}

.input-group .input-group-text {
  border-color: #199cb4;
  color: white;
  background-color: #199cb4;
}
.input-group input[disabled] ~ .input-group-text, .input-group input[readonly] ~ .input-group-text {
  border-color: #adb5bd;
  color: white;
  pointer-events: none;
  background-color: #adb5bd;
}
.input-group .input-group-text:has(~ input[disabled], ~ input[readonly]) {
  border-color: #adb5bd;
  color: white;
  pointer-events: none;
  background-color: #adb5bd;
}
.input-group .input-group-text:hover {
  border-color: #5fcde2;
  color: white;
  background-color: #5fcde2;
}
.input-group .input-group-text:has(.svg-inline--fa[aria-disabled=true]) {
  border-color: #adb5bd;
  color: white;
  pointer-events: none;
  background-color: #adb5bd;
}

.icon-table {
  font-size: 18px;
  font-weight: bold;
  color: #343a40;
}

.button-in-action-column {
  height: 100% !important;
  margin-top: 0.5rem !important;
}
.button-in-action-column > .btn-label {
  text-wrap: initial !important;
}

.button-in-action-column:hover {
  transform: scale(1.1);
  transition: transform 0.15s ease-in-out;
  color: #5fcde2;
}

.icon-table:hover:not([aria-disabled=true]) {
  transform: scale(1.4);
  transition: transform 0.15s ease-in-out;
  color: #5fcde2;
}

.icon-table[aria-disabled=true] {
  color: #adb5bd;
}

.icon-table-header {
  font-size: 18px;
  font-weight: 500;
  color: white;
}

.icon-table-header:hover {
  transform: scale(1.4);
  transition: transform 0.15s ease-in-out;
  color: #5fcde2;
}

.invalid-table-row .icon-table {
  color: white;
}

.actions-container {
  height: 40px;
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(min-content, 30px);
  justify-content: center;
  align-items: center;
}

.form-check {
  min-height: 0 !important;
  margin-bottom: 0 !important;
}

.form-header {
  font-weight: bold;
  font-size: 16px;
  color: #3a516e !important;
  margin-bottom: 20px;
}

.form-switch {
  padding-left: 1.5rem !important;
}

.custom-checkbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.invalid-table-row {
  background-color: #d85b61;
  color: white !important;
}

.table-striped tbody tr:nth-of-type(odd).invalid-table-row > * {
  background-color: #d85b61;
  color: white;
}

.delete-button {
  width: 30px;
  height: 30px;
}

.ispu-input-wrapper input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ispu-input-wrapper .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: 0;
  max-height: 34px;
}

.sidebar-statement-link {
  background-color: #343a40;
  padding: 15px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.sidebar-statement-link .bm-item {
  margin-bottom: unset !important;
  text-align: center !important;
}

.act-error-icon {
  font-size: 18px;
  font-weight: bold;
  color: #ca1820;
}

.act-error-icon:hover {
  transform: scale(1.4);
  transition: transform 0.15s ease-in-out;
  cursor: pointer;
}

.act-error-toast {
  width: 500px;
}

.acts-error-line-break {
  padding-left: 2rem; /* space for wrapped lines */
  white-space: normal; /* allow wrapping */
  word-break: break-word;
}

.case-copy-from-other-case {
  width: 300px;
  height: 50px;
}
.case-copy-from-other-case .input-group .input-group-text {
  border-color: #199cb4 !important;
  color: white;
  background-color: #199cb4;
}
.case-copy-from-other-case .input-group .input-group-text:hover {
  border-color: #5fcde2;
  color: white;
  background-color: #5fcde2;
}
.case-copy-from-other-case .input-group .input-group-text:has(.svg-inline--fa[aria-disabled=true]) {
  border-color: #adb5bd;
  color: white;
  pointer-events: none;
  background-color: #adb5bd;
}

.btn-group .btn {
  height: 100% !important;
}

.fit-content-modal {
  min-width: -moz-fit-content;
  min-width: fit-content;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}

.custom-btn-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.custom-btn-group .btn {
  height: 100% !important;
  margin: 0;
}

.custom-btn-group .btn-group-first-button,
.custom-btn-group span .btn-group-first-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-btn-group .btn-group-last-button,
.custom-btn-group span .btn-group-last-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-full-width {
  width: 160px;
}

.btn-primary-width {
  width: 130px;
}

.btn-secondary-width {
  width: 30px;
}

td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/app.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/main/webapp/content/css/dark-colors.scss","webpack://./src/main/webapp/content/css/accessibility/contrast.scss","webpack://./src/main/webapp/content/css/accessibility/dyslexia.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/small/font-size-s.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/small/font-size-xs.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/small/font-size-2xs.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/small/font-size-3xs.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/large/font-size-l.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/large/font-size-xl.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/large/font-size-2xl.scss","webpack://./src/main/webapp/content/css/accessibility/font-size/large/font-size-3xl.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;;EAAA;ACDF;EAQI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC4PI,yBALI;EDrPR,0BAAA;EACA,0BAAA;EACA,wBAAA;EAIA,kBAAA;EAIA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAGA,wBAAA;EACA,8BAAA;EAEA,wBAAA;EAEA,0BAAA;AFGF;;AI3DA;;;EAGE,sBAAA;AJ8DF;;AI/CI;EANJ;IAOM,uBAAA;EJmDJ;AACF;;AItCA;EACE,SAAA;EACA,uCAAA;EDmPI,mCALI;EC5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AJyCF;;AIhCA;EACE,cAAA;EACA,cCijB4B;EDhjB5B,SAAA;EACA,qBAAA;EACA,aCujB4B;ALphB9B;;AIzBA;EACE,aAAA;EACA,qBCwf4B;EDrf5B,gBCwf4B;EDvf5B,gBCwf4B;AL9d9B;;AItBA;ED6MQ,iCAAA;AHnLR;AGiBI;EC3CJ;IDoNQ,iBAAA;EHtLN;AACF;;AI1BA;EDwMQ,iCAAA;AH1KR;AGQI;ECtCJ;ID+MQ,eAAA;EH7KN;AACF;;AI9BA;EDmMQ,+BAAA;AHjKR;AGDI;ECjCJ;ID0MQ,kBAAA;EHpKN;AACF;;AIlCA;ED8LQ,iCAAA;AHxJR;AGVI;EC5BJ;IDqMQ,iBAAA;EH3JN;AACF;;AItCA;EDqLM,kBALI;AHtIV;;AIrCA;EDgLM,eALI;AHlIV;;AI9BA;EACE,aAAA;EACA,mBCmS0B;ALlQ5B;;AIvBA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AJ0BF;;AIpBA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJuBF;;AIjBA;;EAEE,kBAAA;AJoBF;;AIjBA;;;EAGE,aAAA;EACA,mBAAA;AJoBF;;AIjBA;;;;EAIE,gBAAA;AJoBF;;AIjBA;EACE,gBC6X4B;ALzW9B;;AIfA;EACE,qBAAA;EACA,cAAA;AJkBF;;AIZA;EACE,gBAAA;AJeF;;AIPA;;EAEE,mBCsW4B;AL5V9B;;AIFA;EDmFM,kBALI;AHxEV;;AICA;EACE,iBC+a4B;ED9a5B,wCAAA;AJEF;;AIOA;;EAEE,kBAAA;ED+DI,iBALI;ECxDR,cAAA;EACA,wBAAA;AJJF;;AIOA;EAAM,eAAA;AJHN;;AIIA;EAAM,WAAA;AJAN;;AIKA;EACE,2BAAA;EACA,0BCqKwC;ALvK1C;AIIE;EACE,iCAAA;AJFJ;;AIaE;EAEE,cAAA;EACA,qBAAA;AJXJ;;AIkBA;;;;EAIE,qCCkR4B;EF7PxB,cALI;AH9BV;;AIsBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDSI,kBALI;AHtBV;AIuBE;EDII,kBALI;ECGN,cAAA;EACA,kBAAA;AJrBJ;;AIyBA;EDHM,kBALI;ECUR,2BAAA;EACA,qBAAA;AJtBF;AIyBE;EACE,cAAA;AJvBJ;;AI2BA;EACE,2BAAA;EDfI,kBALI;ECsBR,wBCsyCkC;EDryClC,sCCsyCkC;EC1kDhC,sBAAA;AN6QJ;AI0BE;EACE,UAAA;EDtBE,cALI;AHIV;;AIkCA;EACE,gBAAA;AJ/BF;;AIqCA;;EAEE,sBAAA;AJlCF;;AI0CA;EACE,oBAAA;EACA,yBAAA;AJvCF;;AI0CA;EACE,mBCsT4B;EDrT5B,sBCqT4B;EDpT5B,cCjVS;EDkVT,gBAAA;AJvCF;;AI8CA;EAEE,mBAAA;EACA,gCAAA;AJ5CF;;AI+CA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJ5CF;;AIoDA;EACE,qBAAA;AJjDF;;AIuDA;EAEE,gBAAA;AJrDF;;AI6DA;EACE,UAAA;AJ1DF;;AI+DA;;;;;EAKE,SAAA;EACA,oBAAA;EDrHI,kBALI;EC4HR,oBAAA;AJ5DF;;AIgEA;;EAEE,oBAAA;AJ7DF;;AIkEA;EACE,eAAA;AJ/DF;;AIkEA;EAGE,iBAAA;AJjEF;AIoEE;EACE,UAAA;AJlEJ;;AIyEA;EACE,wBAAA;AJtEF;;AI8EA;;;;EAIE,0BAAA;AJ3EF;AI8EI;;;;EACE,eAAA;AJzEN;;AIgFA;EACE,UAAA;EACA,kBAAA;AJ7EF;;AIkFA;EACE,gBAAA;AJ/EF;;AIyFA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJtFF;;AI8FA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC8I4B;EFxVtB,iCAAA;EC6MN,oBAAA;AJ5FF;AGnRI;ECwWJ;ID/LQ,iBAAA;EH8GN;AACF;AIyFE;EACE,WAAA;AJvFJ;;AI8FA;;;;;;;EAOE,UAAA;AJ3FF;;AI8FA;EACE,YAAA;AJ3FF;;AIoGA;EACE,oBAAA;EACA,6BAAA;AJjGF;;AIyGA;;;;;;;CAAA;AAWA;EACE,wBAAA;AJzGF;;AI8GA;EACE,UAAA;AJ3GF;;AIkHA;EACE,aAAA;EACA,0BAAA;AJ/GF;;AIoHA;EACE,qBAAA;AJjHF;;AIsHA;EACE,SAAA;AJnHF;;AI0HA;EACE,kBAAA;EACA,eAAA;AJvHF;;AI+HA;EACE,wBAAA;AJ5HF;;AIoIA;EACE,wBAAA;AJjIF;;AOncA;EJyQM,kBALI;EIlQR,gBFwkB4B;ALlI9B;;AOjcE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;ALtG9B;AGnWI;EIpGF;IJ6QM,eAAA;EH8LN;AACF;;AO5cE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;AL3F9B;AG9WI;EIpGF;IJ6QM,iBAAA;EHyMN;AACF;;AOvdE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;ALhF9B;AGzXI;EIpGF;IJ6QM,eAAA;EHoNN;AACF;;AOleE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;ALrE9B;AGpYI;EIpGF;IJ6QM,iBAAA;EH+NN;AACF;;AO7eE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;AL1D9B;AG/YI;EIpGF;IJ6QM,eAAA;EH0ON;AACF;;AOxfE;EJsQM,iCAAA;EIlQJ,gBFyjBkB;EExjBlB,gBFwiB0B;AL/C9B;AG1ZI;EIpGF;IJ6QM,iBAAA;EHqPN;AACF;;AO3eA;ECvDE,eAAA;EACA,gBAAA;ARsiBF;;AO3eA;EC5DE,eAAA;EACA,gBAAA;AR2iBF;;AO7eA;EACE,qBAAA;APgfF;AO9eE;EACE,oBFgkB0B;ALhF9B;;AOteA;EJoNM,kBALI;EI7MR,yBAAA;APyeF;;AOreA;EACE,mBF6RO;EFhFH,kBALI;AHiSV;AOteE;EACE,gBAAA;APweJ;;AOpeA;EACE,iBAAA;EACA,mBFmRO;EFhFH,kBALI;EI5LR,cFtFS;AL6jBX;AOreE;EACE,aAAA;APueJ;;ASvkBA;ECIE,eAAA;EAGA,YAAA;AVqkBF;;AStkBA;EACE,gBJ68CkC;EI58ClC,sBJPS;EIQT,wCAAA;EHGE,uBAAA;EIRF,eAAA;EAGA,YAAA;AV8kBF;;AShkBA;EAEE,qBAAA;ATkkBF;;AS/jBA;EACE,qBAAA;EACA,cAAA;ATkkBF;;AS/jBA;EN+PM,kBALI;EMxPR,cJ1BS;AL4lBX;;AWpmBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AZinBF;;Aa3jBI;EF5CE;IACE,gBN6ae;EL8LrB;AACF;AajkBI;EF5CE;IACE,gBN6ae;ELmMrB;AACF;AatkBI;EF5CE;IACE,gBN6ae;ELwMrB;AACF;Aa3kBI;EF5CE;IACE,iBN6ae;EL6MrB;AACF;AahlBI;EF5CE;IACE,iBN6ae;ELkNrB;AACF;Ac/oBE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AfipBF;AcrpBI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;Af2oBF;;Ae5lBM;EACE,YAAA;Af+lBR;;Ae5lBM;EApCJ,cAAA;EACA,WAAA;AfooBF;;AetnBE;EACE,cAAA;EACA,WAAA;AfynBJ;;Ae3nBE;EACE,cAAA;EACA,UAAA;Af8nBJ;;AehoBE;EACE,cAAA;EACA,qBAAA;AfmoBJ;;AeroBE;EACE,cAAA;EACA,UAAA;AfwoBJ;;Ae1oBE;EACE,cAAA;EACA,UAAA;Af6oBJ;;Ae/oBE;EACE,cAAA;EACA,qBAAA;AfkpBJ;;AennBM;EAhDJ,cAAA;EACA,WAAA;AfuqBF;;AelnBU;EAhEN,cAAA;EACA,kBAAA;AfsrBJ;;AevnBU;EAhEN,cAAA;EACA,mBAAA;Af2rBJ;;Ae5nBU;EAhEN,cAAA;EACA,UAAA;AfgsBJ;;AejoBU;EAhEN,cAAA;EACA,mBAAA;AfqsBJ;;AetoBU;EAhEN,cAAA;EACA,mBAAA;Af0sBJ;;Ae3oBU;EAhEN,cAAA;EACA,UAAA;Af+sBJ;;AehpBU;EAhEN,cAAA;EACA,mBAAA;AfotBJ;;AerpBU;EAhEN,cAAA;EACA,mBAAA;AfytBJ;;Ae1pBU;EAhEN,cAAA;EACA,UAAA;Af8tBJ;;Ae/pBU;EAhEN,cAAA;EACA,mBAAA;AfmuBJ;;AepqBU;EAhEN,cAAA;EACA,mBAAA;AfwuBJ;;AezqBU;EAhEN,cAAA;EACA,WAAA;Af6uBJ;;AetqBY;EAxDV,wBAAA;AfkuBF;;Ae1qBY;EAxDV,yBAAA;AfsuBF;;Ae9qBY;EAxDV,gBAAA;Af0uBF;;AelrBY;EAxDV,yBAAA;Af8uBF;;AetrBY;EAxDV,yBAAA;AfkvBF;;Ae1rBY;EAxDV,gBAAA;AfsvBF;;Ae9rBY;EAxDV,yBAAA;Af0vBF;;AelsBY;EAxDV,yBAAA;Af8vBF;;AetsBY;EAxDV,gBAAA;AfkwBF;;Ae1sBY;EAxDV,yBAAA;AfswBF;;Ae9sBY;EAxDV,yBAAA;Af0wBF;;AevsBQ;;EAEE,gBAAA;Af0sBV;;AevsBQ;;EAEE,gBAAA;Af0sBV;;AejtBQ;;EAEE,sBAAA;AfotBV;;AejtBQ;;EAEE,sBAAA;AfotBV;;Ae3tBQ;;EAEE,qBAAA;Af8tBV;;Ae3tBQ;;EAEE,qBAAA;Af8tBV;;AeruBQ;;EAEE,mBAAA;AfwuBV;;AeruBQ;;EAEE,mBAAA;AfwuBV;;Ae/uBQ;;EAEE,qBAAA;AfkvBV;;Ae/uBQ;;EAEE,qBAAA;AfkvBV;;AezvBQ;;EAEE,mBAAA;Af4vBV;;AezvBQ;;EAEE,mBAAA;Af4vBV;;AatzBI;EEUE;IACE,YAAA;EfgzBN;Ee7yBI;IApCJ,cAAA;IACA,WAAA;Efo1BA;Eet0BA;IACE,cAAA;IACA,WAAA;Efw0BF;Ee10BA;IACE,cAAA;IACA,UAAA;Ef40BF;Ee90BA;IACE,cAAA;IACA,qBAAA;Efg1BF;Eel1BA;IACE,cAAA;IACA,UAAA;Efo1BF;Eet1BA;IACE,cAAA;IACA,UAAA;Efw1BF;Ee11BA;IACE,cAAA;IACA,qBAAA;Ef41BF;Ee7zBI;IAhDJ,cAAA;IACA,WAAA;Efg3BA;Ee3zBQ;IAhEN,cAAA;IACA,kBAAA;Ef83BF;Ee/zBQ;IAhEN,cAAA;IACA,mBAAA;Efk4BF;Een0BQ;IAhEN,cAAA;IACA,UAAA;Efs4BF;Eev0BQ;IAhEN,cAAA;IACA,mBAAA;Ef04BF;Ee30BQ;IAhEN,cAAA;IACA,mBAAA;Ef84BF;Ee/0BQ;IAhEN,cAAA;IACA,UAAA;Efk5BF;Een1BQ;IAhEN,cAAA;IACA,mBAAA;Efs5BF;Eev1BQ;IAhEN,cAAA;IACA,mBAAA;Ef05BF;Ee31BQ;IAhEN,cAAA;IACA,UAAA;Ef85BF;Ee/1BQ;IAhEN,cAAA;IACA,mBAAA;Efk6BF;Een2BQ;IAhEN,cAAA;IACA,mBAAA;Efs6BF;Eev2BQ;IAhEN,cAAA;IACA,WAAA;Ef06BF;Een2BU;IAxDV,cAAA;Ef85BA;Eet2BU;IAxDV,wBAAA;Efi6BA;Eez2BU;IAxDV,yBAAA;Efo6BA;Ee52BU;IAxDV,gBAAA;Efu6BA;Ee/2BU;IAxDV,yBAAA;Ef06BA;Eel3BU;IAxDV,yBAAA;Ef66BA;Eer3BU;IAxDV,gBAAA;Efg7BA;Eex3BU;IAxDV,yBAAA;Efm7BA;Ee33BU;IAxDV,yBAAA;Efs7BA;Ee93BU;IAxDV,gBAAA;Efy7BA;Eej4BU;IAxDV,yBAAA;Ef47BA;Eep4BU;IAxDV,yBAAA;Ef+7BA;Ee53BM;;IAEE,gBAAA;Ef83BR;Ee33BM;;IAEE,gBAAA;Ef63BR;Eep4BM;;IAEE,sBAAA;Efs4BR;Een4BM;;IAEE,sBAAA;Efq4BR;Ee54BM;;IAEE,qBAAA;Ef84BR;Ee34BM;;IAEE,qBAAA;Ef64BR;Eep5BM;;IAEE,mBAAA;Efs5BR;Een5BM;;IAEE,mBAAA;Efq5BR;Ee55BM;;IAEE,qBAAA;Ef85BR;Ee35BM;;IAEE,qBAAA;Ef65BR;Eep6BM;;IAEE,mBAAA;Efs6BR;Een6BM;;IAEE,mBAAA;Efq6BR;AACF;Aah+BI;EEUE;IACE,YAAA;Efy9BN;Eet9BI;IApCJ,cAAA;IACA,WAAA;Ef6/BA;Ee/+BA;IACE,cAAA;IACA,WAAA;Efi/BF;Een/BA;IACE,cAAA;IACA,UAAA;Efq/BF;Eev/BA;IACE,cAAA;IACA,qBAAA;Efy/BF;Ee3/BA;IACE,cAAA;IACA,UAAA;Ef6/BF;Ee//BA;IACE,cAAA;IACA,UAAA;EfigCF;EengCA;IACE,cAAA;IACA,qBAAA;EfqgCF;Eet+BI;IAhDJ,cAAA;IACA,WAAA;EfyhCA;Eep+BQ;IAhEN,cAAA;IACA,kBAAA;EfuiCF;Eex+BQ;IAhEN,cAAA;IACA,mBAAA;Ef2iCF;Ee5+BQ;IAhEN,cAAA;IACA,UAAA;Ef+iCF;Eeh/BQ;IAhEN,cAAA;IACA,mBAAA;EfmjCF;Eep/BQ;IAhEN,cAAA;IACA,mBAAA;EfujCF;Eex/BQ;IAhEN,cAAA;IACA,UAAA;Ef2jCF;Ee5/BQ;IAhEN,cAAA;IACA,mBAAA;Ef+jCF;EehgCQ;IAhEN,cAAA;IACA,mBAAA;EfmkCF;EepgCQ;IAhEN,cAAA;IACA,UAAA;EfukCF;EexgCQ;IAhEN,cAAA;IACA,mBAAA;Ef2kCF;Ee5gCQ;IAhEN,cAAA;IACA,mBAAA;Ef+kCF;EehhCQ;IAhEN,cAAA;IACA,WAAA;EfmlCF;Ee5gCU;IAxDV,cAAA;EfukCA;Ee/gCU;IAxDV,wBAAA;Ef0kCA;EelhCU;IAxDV,yBAAA;Ef6kCA;EerhCU;IAxDV,gBAAA;EfglCA;EexhCU;IAxDV,yBAAA;EfmlCA;Ee3hCU;IAxDV,yBAAA;EfslCA;Ee9hCU;IAxDV,gBAAA;EfylCA;EejiCU;IAxDV,yBAAA;Ef4lCA;EepiCU;IAxDV,yBAAA;Ef+lCA;EeviCU;IAxDV,gBAAA;EfkmCA;Ee1iCU;IAxDV,yBAAA;EfqmCA;Ee7iCU;IAxDV,yBAAA;EfwmCA;EeriCM;;IAEE,gBAAA;EfuiCR;EepiCM;;IAEE,gBAAA;EfsiCR;Ee7iCM;;IAEE,sBAAA;Ef+iCR;Ee5iCM;;IAEE,sBAAA;Ef8iCR;EerjCM;;IAEE,qBAAA;EfujCR;EepjCM;;IAEE,qBAAA;EfsjCR;Ee7jCM;;IAEE,mBAAA;Ef+jCR;Ee5jCM;;IAEE,mBAAA;Ef8jCR;EerkCM;;IAEE,qBAAA;EfukCR;EepkCM;;IAEE,qBAAA;EfskCR;Ee7kCM;;IAEE,mBAAA;Ef+kCR;Ee5kCM;;IAEE,mBAAA;Ef8kCR;AACF;AazoCI;EEUE;IACE,YAAA;EfkoCN;Ee/nCI;IApCJ,cAAA;IACA,WAAA;EfsqCA;EexpCA;IACE,cAAA;IACA,WAAA;Ef0pCF;Ee5pCA;IACE,cAAA;IACA,UAAA;Ef8pCF;EehqCA;IACE,cAAA;IACA,qBAAA;EfkqCF;EepqCA;IACE,cAAA;IACA,UAAA;EfsqCF;EexqCA;IACE,cAAA;IACA,UAAA;Ef0qCF;Ee5qCA;IACE,cAAA;IACA,qBAAA;Ef8qCF;Ee/oCI;IAhDJ,cAAA;IACA,WAAA;EfksCA;Ee7oCQ;IAhEN,cAAA;IACA,kBAAA;EfgtCF;EejpCQ;IAhEN,cAAA;IACA,mBAAA;EfotCF;EerpCQ;IAhEN,cAAA;IACA,UAAA;EfwtCF;EezpCQ;IAhEN,cAAA;IACA,mBAAA;Ef4tCF;Ee7pCQ;IAhEN,cAAA;IACA,mBAAA;EfguCF;EejqCQ;IAhEN,cAAA;IACA,UAAA;EfouCF;EerqCQ;IAhEN,cAAA;IACA,mBAAA;EfwuCF;EezqCQ;IAhEN,cAAA;IACA,mBAAA;Ef4uCF;Ee7qCQ;IAhEN,cAAA;IACA,UAAA;EfgvCF;EejrCQ;IAhEN,cAAA;IACA,mBAAA;EfovCF;EerrCQ;IAhEN,cAAA;IACA,mBAAA;EfwvCF;EezrCQ;IAhEN,cAAA;IACA,WAAA;Ef4vCF;EerrCU;IAxDV,cAAA;EfgvCA;EexrCU;IAxDV,wBAAA;EfmvCA;Ee3rCU;IAxDV,yBAAA;EfsvCA;Ee9rCU;IAxDV,gBAAA;EfyvCA;EejsCU;IAxDV,yBAAA;Ef4vCA;EepsCU;IAxDV,yBAAA;Ef+vCA;EevsCU;IAxDV,gBAAA;EfkwCA;Ee1sCU;IAxDV,yBAAA;EfqwCA;Ee7sCU;IAxDV,yBAAA;EfwwCA;EehtCU;IAxDV,gBAAA;Ef2wCA;EentCU;IAxDV,yBAAA;Ef8wCA;EettCU;IAxDV,yBAAA;EfixCA;Ee9sCM;;IAEE,gBAAA;EfgtCR;Ee7sCM;;IAEE,gBAAA;Ef+sCR;EettCM;;IAEE,sBAAA;EfwtCR;EertCM;;IAEE,sBAAA;EfutCR;Ee9tCM;;IAEE,qBAAA;EfguCR;Ee7tCM;;IAEE,qBAAA;Ef+tCR;EetuCM;;IAEE,mBAAA;EfwuCR;EeruCM;;IAEE,mBAAA;EfuuCR;Ee9uCM;;IAEE,qBAAA;EfgvCR;Ee7uCM;;IAEE,qBAAA;Ef+uCR;EetvCM;;IAEE,mBAAA;EfwvCR;EervCM;;IAEE,mBAAA;EfuvCR;AACF;AalzCI;EEUE;IACE,YAAA;Ef2yCN;EexyCI;IApCJ,cAAA;IACA,WAAA;Ef+0CA;Eej0CA;IACE,cAAA;IACA,WAAA;Efm0CF;Eer0CA;IACE,cAAA;IACA,UAAA;Efu0CF;Eez0CA;IACE,cAAA;IACA,qBAAA;Ef20CF;Ee70CA;IACE,cAAA;IACA,UAAA;Ef+0CF;Eej1CA;IACE,cAAA;IACA,UAAA;Efm1CF;Eer1CA;IACE,cAAA;IACA,qBAAA;Efu1CF;EexzCI;IAhDJ,cAAA;IACA,WAAA;Ef22CA;EetzCQ;IAhEN,cAAA;IACA,kBAAA;Efy3CF;Ee1zCQ;IAhEN,cAAA;IACA,mBAAA;Ef63CF;Ee9zCQ;IAhEN,cAAA;IACA,UAAA;Efi4CF;Eel0CQ;IAhEN,cAAA;IACA,mBAAA;Efq4CF;Eet0CQ;IAhEN,cAAA;IACA,mBAAA;Efy4CF;Ee10CQ;IAhEN,cAAA;IACA,UAAA;Ef64CF;Ee90CQ;IAhEN,cAAA;IACA,mBAAA;Efi5CF;Eel1CQ;IAhEN,cAAA;IACA,mBAAA;Efq5CF;Eet1CQ;IAhEN,cAAA;IACA,UAAA;Efy5CF;Ee11CQ;IAhEN,cAAA;IACA,mBAAA;Ef65CF;Ee91CQ;IAhEN,cAAA;IACA,mBAAA;Efi6CF;Eel2CQ;IAhEN,cAAA;IACA,WAAA;Efq6CF;Ee91CU;IAxDV,cAAA;Efy5CA;Eej2CU;IAxDV,wBAAA;Ef45CA;Eep2CU;IAxDV,yBAAA;Ef+5CA;Eev2CU;IAxDV,gBAAA;Efk6CA;Ee12CU;IAxDV,yBAAA;Efq6CA;Ee72CU;IAxDV,yBAAA;Efw6CA;Eeh3CU;IAxDV,gBAAA;Ef26CA;Een3CU;IAxDV,yBAAA;Ef86CA;Eet3CU;IAxDV,yBAAA;Efi7CA;Eez3CU;IAxDV,gBAAA;Efo7CA;Ee53CU;IAxDV,yBAAA;Efu7CA;Ee/3CU;IAxDV,yBAAA;Ef07CA;Eev3CM;;IAEE,gBAAA;Efy3CR;Eet3CM;;IAEE,gBAAA;Efw3CR;Ee/3CM;;IAEE,sBAAA;Efi4CR;Ee93CM;;IAEE,sBAAA;Efg4CR;Eev4CM;;IAEE,qBAAA;Efy4CR;Eet4CM;;IAEE,qBAAA;Efw4CR;Ee/4CM;;IAEE,mBAAA;Efi5CR;Ee94CM;;IAEE,mBAAA;Efg5CR;Eev5CM;;IAEE,qBAAA;Efy5CR;Eet5CM;;IAEE,qBAAA;Efw5CR;Ee/5CM;;IAEE,mBAAA;Efi6CR;Ee95CM;;IAEE,mBAAA;Efg6CR;AACF;Aa39CI;EEUE;IACE,YAAA;Efo9CN;Eej9CI;IApCJ,cAAA;IACA,WAAA;Efw/CA;Ee1+CA;IACE,cAAA;IACA,WAAA;Ef4+CF;Ee9+CA;IACE,cAAA;IACA,UAAA;Efg/CF;Eel/CA;IACE,cAAA;IACA,qBAAA;Efo/CF;Eet/CA;IACE,cAAA;IACA,UAAA;Efw/CF;Ee1/CA;IACE,cAAA;IACA,UAAA;Ef4/CF;Ee9/CA;IACE,cAAA;IACA,qBAAA;EfggDF;Eej+CI;IAhDJ,cAAA;IACA,WAAA;EfohDA;Ee/9CQ;IAhEN,cAAA;IACA,kBAAA;EfkiDF;Een+CQ;IAhEN,cAAA;IACA,mBAAA;EfsiDF;Eev+CQ;IAhEN,cAAA;IACA,UAAA;Ef0iDF;Ee3+CQ;IAhEN,cAAA;IACA,mBAAA;Ef8iDF;Ee/+CQ;IAhEN,cAAA;IACA,mBAAA;EfkjDF;Een/CQ;IAhEN,cAAA;IACA,UAAA;EfsjDF;Eev/CQ;IAhEN,cAAA;IACA,mBAAA;Ef0jDF;Ee3/CQ;IAhEN,cAAA;IACA,mBAAA;Ef8jDF;Ee//CQ;IAhEN,cAAA;IACA,UAAA;EfkkDF;EengDQ;IAhEN,cAAA;IACA,mBAAA;EfskDF;EevgDQ;IAhEN,cAAA;IACA,mBAAA;Ef0kDF;Ee3gDQ;IAhEN,cAAA;IACA,WAAA;Ef8kDF;EevgDU;IAxDV,cAAA;EfkkDA;Ee1gDU;IAxDV,wBAAA;EfqkDA;Ee7gDU;IAxDV,yBAAA;EfwkDA;EehhDU;IAxDV,gBAAA;Ef2kDA;EenhDU;IAxDV,yBAAA;Ef8kDA;EethDU;IAxDV,yBAAA;EfilDA;EezhDU;IAxDV,gBAAA;EfolDA;Ee5hDU;IAxDV,yBAAA;EfulDA;Ee/hDU;IAxDV,yBAAA;Ef0lDA;EeliDU;IAxDV,gBAAA;Ef6lDA;EeriDU;IAxDV,yBAAA;EfgmDA;EexiDU;IAxDV,yBAAA;EfmmDA;EehiDM;;IAEE,gBAAA;EfkiDR;Ee/hDM;;IAEE,gBAAA;EfiiDR;EexiDM;;IAEE,sBAAA;Ef0iDR;EeviDM;;IAEE,sBAAA;EfyiDR;EehjDM;;IAEE,qBAAA;EfkjDR;Ee/iDM;;IAEE,qBAAA;EfijDR;EexjDM;;IAEE,mBAAA;Ef0jDR;EevjDM;;IAEE,mBAAA;EfyjDR;EehkDM;;IAEE,qBAAA;EfkkDR;Ee/jDM;;IAEE,qBAAA;EfikDR;EexkDM;;IAEE,mBAAA;Ef0kDR;EevkDM;;IAEE,mBAAA;EfykDR;AACF;AgB/rDA;EACE,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,0CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EAEA,WAAA;EACA,mBXoWO;EWnWP,4BAAA;EACA,mBXqoB4B;EWpoB5B,0CAAA;AhBgsDF;AgBzrDE;EACE,sBAAA;EACA,oCAAA;EACA,wBXic0B;EWhc1B,wDAAA;AhB2rDJ;AgBxrDE;EACE,uBAAA;AhB0rDJ;AgBvrDE;EACE,sBAAA;AhByrDJ;;AgBrrDA;EACE,kCAAA;AhBwrDF;;AgBjrDA;EACE,iBAAA;AhBorDF;;AgB1qDE;EACE,wBAAA;AhB6qDJ;;AgB9pDE;EACE,mBAAA;AhBiqDJ;AgB9pDI;EACE,mBAAA;AhBgqDN;;AgBzpDE;EACE,sBAAA;AhB4pDJ;AgBzpDE;EACE,mBAAA;AhB2pDJ;;AgBjpDE;EACE,gDAAA;EACA,oCAAA;AhBopDJ;;AgB9oDE;EACE,gDAAA;EACA,oCAAA;AhBipDJ;;AgBzoDA;EACE,+CAAA;EACA,mCAAA;AhB4oDF;;AgBpoDE;EACE,8CAAA;EACA,kCAAA;AhBuoDJ;;AiB5wDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBwwDJ;;AiB1xDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBsxDJ;;AiBxyDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBoyDJ;;AiBtzDE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBkzDJ;;AiBp0DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjBg0DJ;;AiBl1DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB80DJ;;AiBh2DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB41DJ;;AiB92DE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AjB02DJ;;AgBhuDI;EACE,gBAAA;EACA,iCAAA;AhBmuDN;;AavzDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EhByuDJ;AACF;Aa9zDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EhB+uDJ;AACF;Aap0DI;EGkFA;IACE,gBAAA;IACA,iCAAA;EhBqvDJ;AACF;Aa10DI;EGkFA;IACE,gBAAA;IACA,iCAAA;EhB2vDJ;AACF;Aah1DI;EGkFA;IACE,gBAAA;IACA,iCAAA;EhBiwDJ;AACF;AkB95DA;EACE,qBb8xBsC;ALkoCxC;;AkBv5DA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EfoRI,kBALI;Ee3QR,gBb+hB4B;ALy3C9B;;AkBp5DA;EACE,+BAAA;EACA,kCAAA;Ef0QI,kBALI;AHmpDV;;AkBp5DA;EACE,gCAAA;EACA,mCAAA;EfoQI,mBALI;AHypDV;;AmBr7DA;EACE,mBdsxBsC;EFtflC,kBALI;EgBvRR,cdKS;ALi7DX;;AoB37DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EjB8RI,eALI;EiBtRR,gBfmiB4B;EeliB5B,gBfyiB4B;EexiB5B,cfKS;EeJT,sBfLS;EeMT,4BAAA;EACA,yBAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EdGE,uBAAA;EeHE,wEDMJ;ApBy7DF;AqB37DM;EDhBN;ICiBQ,gBAAA;ErB87DN;AACF;AoB57DE;EACE,gBAAA;ApB87DJ;AoB57DI;EACE,eAAA;ApB87DN;AoBz7DE;EACE,cfjBO;EekBP,sBf3BO;Ee4BP,qBfqyBoC;EepyBpC,UAAA;EAKE,kDf6qB0B;AL0wChC;AoBh7DE;EAEE,aAAA;ApBi7DJ;AoB76DE;EACE,cf1CO;Ee4CP,UAAA;ApB86DJ;AoBj7DE;EACE,cf1CO;Ee4CP,UAAA;ApB86DJ;AoBt6DE;EAEE,yBf1DO;Ee6DP,UAAA;ApBq6DJ;AoBj6DE;EACE,yBAAA;EACA,0BAAA;EACA,0BfgoB0B;Ee/nB1B,cf9DO;EiBbT,yBjBMS;EeuEP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf0Y0B;EezY1B,gBAAA;ECtEE,qIDuEF;ApBm6DJ;AqBt+DM;EDuDJ;ICtDM,gBAAA;ErBy+DN;AACF;AoBr6DE;EACE,yBfs4B8B;ALiiClC;;AoB95DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBf2c4B;Ee1c5B,cfzFS;Ee0FT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApBi6DF;AoB/5DE;EACE,UAAA;ApBi6DJ;AoB95DE;EAEE,gBAAA;EACA,eAAA;ApB+5DJ;;AoBp5DA;EACE,sCfstBsC;EertBtC,uBAAA;EjBkKI,mBALI;EG7QN,sBAAA;ANygEJ;AoBr5DE;EACE,uBAAA;EACA,wBAAA;EACA,yBfglB0B;ALu0C9B;;AoBn5DA;EACE,oCf0sBsC;EezsBtC,oBAAA;EjBqJI,kBALI;EG7QN,qBAAA;ANqhEJ;AoBp5DE;EACE,oBAAA;EACA,qBAAA;EACA,uBfukB0B;AL+0C9B;;AoB94DE;EACE,uCfurBoC;AL0tCxC;AoB94DE;EACE,sCforBoC;AL4tCxC;AoB74DE;EACE,oCfirBoC;AL8tCxC;;AoB14DA;EACE,Wf+qBsC;Ee9qBtC,mCfwqBsC;EevqBtC,iBf6hB4B;ALg3C9B;AoB34DE;EACE,eAAA;ApB64DJ;AoB14DE;EACE,oBAAA;EdpKA,uBAAA;ANijEJ;AoBz4DE;EdxKE,uBAAA;ANojEJ;AoBx4DE;EAAoB,kCfypBkB;ALkvCxC;AoB14DE;EAAoB,gCfypBkB;ALovCxC;;AuBxkEA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EpB4RI,eALI;EoBpRR,gBlBiiB4B;EkBhiB5B,gBlBuiB4B;EkBtiB5B,clBGS;EkBFT,sBlBPS;EkBQT,iPAAA;EACA,4BAAA;EACA,yClBw5BkC;EkBv5BlC,0BlBw5BkC;EkBv5BlC,yBAAA;EjBDE,uBAAA;EeHE,wEEOJ;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;AvBykEF;AqB7kEM;EEfN;IFgBQ,gBAAA;ErBglEN;AACF;AuB5kEE;EACE,qBlB8yBoC;EkB7yBpC,UAAA;EAKE,kDlBy5B4B;ALirClC;AuBtkEE;EAEE,sBlBuqB0B;EkBtqB1B,sBAAA;AvBukEJ;AuBpkEE;EAEE,yBlBnCO;ALwmEX;AuBhkEE;EACE,kBAAA;EACA,0BAAA;AvBkkEJ;;AuB9jEA;EACE,oBlBgqB4B;EkB/pB5B,uBlB+pB4B;EkB9pB5B,oBlB+pB4B;EFrbxB,mBALI;EG7QN,sBAAA;AN2mEJ;;AuB9jEA;EACE,mBlB4pB4B;EkB3pB5B,sBlB2pB4B;EkB1pB5B,kBlB2pB4B;EFzbxB,kBALI;EG7QN,qBAAA;ANmnEJ;;AwBloEA;EACE,cAAA;EACA,kBnB41BwC;EmB31BxC,mBnB41BwC;EmB31BxC,uBnB41BwC;ALyyC1C;AwBnoEE;EACE,WAAA;EACA,mBAAA;AxBqoEJ;;AwBjoEA;EACE,oBnBk1BwC;EmBj1BxC,eAAA;EACA,iBAAA;AxBooEF;AwBloEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AxBooEJ;;AwBhoEA;EACE,UnBo0BwC;EmBn0BxC,WnBm0BwC;EmBl0BxC,kBAAA;EACA,mBAAA;EACA,sBnBzBS;EmB0BT,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCnBu0BwC;EmBt0BxC,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,iCAAA;UAAA,yBAAA;AxBmoEF;AwBhoEE;ElBvBE,qBAAA;AN0pEJ;AwB/nEE;EAEE,kBnB8zBsC;ALk0C1C;AwB7nEE;EACE,uBnBqzBsC;AL00C1C;AwB5nEE;EACE,qBnBixBoC;EmBhxBpC,UAAA;EACA,kDnB6pB4B;ALi+ChC;AwB3nEE;EACE,yBnBxBM;EmByBN,qBnBzBM;ALspEV;AwB3nEI;EAII,+OAAA;AxB0nER;AwBtnEI;EAII,uJAAA;AxBqnER;AwBhnEE;EACE,yBnB7CM;EmB8CN,qBnB9CM;EmBmDJ,yOAAA;AxB8mEN;AwB1mEE;EACE,oBAAA;EACA,YAAA;EACA,YnB6xBuC;AL+0C3C;AwBrmEI;EACE,eAAA;EACA,YnBoxBqC;ALm1C3C;;AwBzlEA;EACE,mBnB+wBgC;AL60ClC;AwB1lEE;EACE,UnB2wB8B;EmB1wB9B,mBAAA;EACA,wKAAA;EACA,gCAAA;ElB3GA,kBAAA;EeHE,iDGgHF;AxB4lEJ;AqBxsEM;EGsGJ;IHrGM,gBAAA;ErB2sEN;AACF;AwB/lEI;EACE,0JAAA;AxBimEN;AwB9lEI;EACE,iCnB0wB4B;EmBrwB1B,uJAAA;AxB4lER;AwBvlEE;EACE,oBnBqvB8B;EmBpvB9B,eAAA;AxBylEJ;AwBvlEI;EACE,oBAAA;EACA,cAAA;AxBylEN;;AwBplEA;EACE,qBAAA;EACA,kBnBmuBgC;ALo3ClC;;AwBplEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AxBulEF;AwBnlEI;EACE,oBAAA;EACA,YAAA;EACA,anBolBwB;ALigD9B;;AyB1vEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;AzB6vEF;AyB3vEE;EACE,UAAA;AzB6vEJ;AyBzvEI;EAA0B,kEpBq8Ba;ALuzC3C;AyB3vEI;EAA0B,kEpBo8Ba;AL0zC3C;AyB3vEE;EACE,SAAA;AzB6vEJ;AyB1vEE;EACE,WpBs7BuC;EoBr7BvC,YpBq7BuC;EoBp7BvC,oBAAA;EHzBF,yBjBkCQ;EoBPN,SpBq7BuC;ECj8BvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;EACA,wBAAA;UAAA,gBAAA;AzB2vEJ;AqB1wEM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ErB6wEN;AACF;AyB9vEI;EHjCF,yBjBq9ByC;AL60C3C;AyB5vEE;EACE,WpB+5B8B;EoB95B9B,cpB+5B8B;EoB95B9B,kBAAA;EACA,epB85B8B;EoB75B9B,yBpBpCO;EoBqCP,yBAAA;EnB7BA,mBAAA;AN4xEJ;AyB1vEE;EACE,WpB25BuC;EoB15BvC,YpB05BuC;EiB78BzC,yBjBkCQ;EoBmBN,SpB25BuC;ECj8BvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;EACA,qBAAA;OAAA,gBAAA;AzB2vEJ;AqBpyEM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ErBuyEN;AACF;AyB9vEI;EH3DF,yBjBq9ByC;ALu2C3C;AyB5vEE;EACE,WpBq4B8B;EoBp4B9B,cpBq4B8B;EoBp4B9B,kBAAA;EACA,epBo4B8B;EoBn4B9B,yBpB9DO;EoB+DP,yBAAA;EnBvDA,mBAAA;ANszEJ;AyB1vEE;EACE,oBAAA;AzB4vEJ;AyB1vEI;EACE,yBpBtEK;ALk0EX;AyBzvEI;EACE,yBpB1EK;ALq0EX;;A0Bl1EA;EACE,kBAAA;A1Bq1EF;A0Bn1EE;;;EAGE,0BrB+9B8B;EqB99B9B,iBrB+9B8B;ALs3ClC;A0Bl1EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELNE,gEKOF;A1Bo1EJ;AqBv1EM;EKVJ;ILWM,gBAAA;ErB01EN;AACF;A0Bt1EE;;EAEE,qBAAA;A1Bw1EJ;A0Bt1EI;EACE,kBAAA;A1By1EN;A0B11EI;;EACE,kBAAA;A1By1EN;A0Bt1EI;EAEE,qBrBq8B4B;EqBp8B5B,wBrBq8B4B;ALo5ClC;A0B51EI;;;EAEE,qBrBq8B4B;EqBp8B5B,wBrBq8B4B;ALo5ClC;A0Bt1EI;;EACE,qBrBg8B4B;EqB/7B5B,wBrBg8B4B;ALy5ClC;A0Br1EE;EACE,qBrB07B8B;EqBz7B9B,wBrB07B8B;AL65ClC;A0Bh1EI;EACE,arBm7B4B;EqBl7B5B,8DrBm7B4B;ALk6ClC;A0Bv1EI;;;;EACE,arBm7B4B;EqBl7B5B,8DrBm7B4B;ALk6ClC;A0Bh1EI;EACE,arB46B4B;EqB36B5B,8DrB46B4B;ALs6ClC;A0B70EI;EACE,mBAAA;A1B+0EN;;A2Bj5EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A3Bo5EF;A2Bl5EE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A3Bo5EJ;A2Bh5EE;;;EAGE,UAAA;A3Bk5EJ;A2B54EE;EACE,kBAAA;EACA,UAAA;A3B84EJ;A2B54EI;EACE,UAAA;A3B84EN;;A2Bn4EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;ExBoPI,eALI;EwB7OR,gBtB0f4B;EsBzf5B,gBtBggB4B;EsB/f5B,ctBpCS;EsBqCT,kBAAA;EACA,mBAAA;EACA,yBtB9CS;EsB+CT,yBAAA;ErBtCE,uBAAA;AN66EJ;;A2B73EA;;;;EAIE,oBAAA;ExB8NI,kBALI;EG7QN,qBAAA;ANs7EJ;;A2B73EA;;;;EAIE,uBAAA;ExBqNI,mBALI;EG7QN,sBAAA;AN+7EJ;;A2B73EA;;EAEE,mBAAA;A3Bg4EF;;A2Bn3EI;;;;ErBjEA,0BAAA;EACA,6BAAA;AN27EJ;A2Bl3EI;;;;ErB1EA,0BAAA;EACA,6BAAA;ANk8EJ;A2B52EE;;;EAGE,iBAAA;ErB5EA,yBAAA;EACA,4BAAA;AN27EJ;;A4Bp9EE;EACE,aAAA;EACA,WAAA;EACA,mBvB+vBoC;EFtflC,kBALI;EyBjQN,cvBi+BqB;ALq/CzB;;A4Bn9EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EzB4PE,mBALI;EyBpPN,WAvBc;EAwBd,wCAvBiB;EtBHjB,uBAAA;ANg/EJ;;A4Bj9EI;;;;EAEE,cAAA;A5Bs9EN;;A4BpgFI;EAoDE,qBvBs8BmB;EuBn8BjB,oCvBsxBgC;EuBrxBhC,2PAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5Bk9ER;A4B/8EM;EACE,qBvB27BiB;EuB17BjB,iDA/Ca;A5BggFrB;;A4BjhFI;EAyEI,oCvBowBgC;EuBnwBhC,kFAAA;A5B48ER;;A4BthFI;EAiFE,qBvBy6BmB;ALgiDzB;A4Bt8EQ;EAEE,uBvBm1B8B;EuBl1B9B,4dAAA;EACA,+DAAA;EACA,2EAAA;A5Bu8EV;A4Bn8EM;EACE,qBvB45BiB;EuB35BjB,iDA9Ea;A5BmhFrB;;A4BpiFI;EAuGI,yCAAA;A5Bi8ER;;A4BxiFI;EA8GE,qBvB44BmB;ALkjDzB;A4B57EM;EACE,yBvBy4BiB;ALqjDzB;A4B37EM;EACE,iDApGa;A5BiiFrB;A4B17EM;EACE,cvBi4BiB;AL2jDzB;;A4Bv7EI;EACE,kBAAA;A5B07EN;;A4BzjFI;;;EAuII,UAAA;A5Bw7ER;A4Bp7EM;;;EACE,UAAA;A5Bw7ER;;A4BjjFE;EACE,aAAA;EACA,WAAA;EACA,mBvB+vBoC;EFtflC,kBALI;EyBjQN,cvBi+BqB;ALklDzB;;A4BhjFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EzB4PE,mBALI;EyBpPN,WAvBc;EAwBd,wCAvBiB;EtBHjB,uBAAA;AN6kFJ;;A4B9iFI;;;;EAEE,cAAA;A5BmjFN;;A4BjmFI;EAoDE,qBvBs8BmB;EuBn8BjB,oCvBsxBgC;EuBrxBhC,4UAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5B+iFR;A4B5iFM;EACE,qBvB27BiB;EuB17BjB,iDA/Ca;A5B6lFrB;;A4B9mFI;EAyEI,oCvBowBgC;EuBnwBhC,kFAAA;A5ByiFR;;A4BnnFI;EAiFE,qBvBy6BmB;AL6nDzB;A4BniFQ;EAEE,uBvBm1B8B;EuBl1B9B,6iBAAA;EACA,+DAAA;EACA,2EAAA;A5BoiFV;A4BhiFM;EACE,qBvB45BiB;EuB35BjB,iDA9Ea;A5BgnFrB;;A4BjoFI;EAuGI,yCAAA;A5B8hFR;;A4BroFI;EA8GE,qBvB44BmB;AL+oDzB;A4BzhFM;EACE,yBvBy4BiB;ALkpDzB;A4BxhFM;EACE,iDApGa;A5B8nFrB;A4BvhFM;EACE,cvBi4BiB;ALwpDzB;;A4BphFI;EACE,kBAAA;A5BuhFN;;A4BtpFI;;;EAyII,UAAA;A5BmhFR;A4BjhFM;;;EACE,UAAA;A5BqhFR;;A6BnqFA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E1B6RI,wBALI;E0BtRR,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E1B6QI,kCALI;E0BtQR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,mEAAA;EvBhBE,0CAAA;EgBfF,kCOiCqB;ERrBjB,qIQuBJ;A7BiqFF;AqBprFM;EQhBN;IRiBQ,gBAAA;ErBurFN;AACF;A6BpqFE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A7BqqFJ;A6BlqFE;EAEE,gCAAA;EP9CF,wCO+CuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A7B+pFN;A6B3pFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A7BupFJ;A6BppFI;EAKI,0CAAA;A7BkpFR;A6B7oFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A7B4oFJ;;A6BhoFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9BwtFF;;A6BjpFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9ByuFF;;A6BlqFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B0vFF;;A6BnrFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B2wFF;;A6BpsFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B4xFF;;A6BrtFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B6yFF;;A6BtuFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B8zFF;;A6BvvFE;ECpFA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A9B+0FF;;A6B9uFE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bu0FF;;A6B/vFE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9Bw1FF;;A6BhxFE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9By2FF;;A6BjyFE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9B03FF;;A6BlzFE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9B24FF;;A6Bn0FE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9B45FF;;A6Bp1FE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9B66FF;;A6Br2FE;ECrFA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A9B87FF;;A6B12FA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,uCAAA;EAEA,0BxB6PwC;AL+mF1C;A6Br2FE;EACE,0BAAA;A7Bu2FJ;A6Bp2FE;EACE,gCAAA;A7Bs2FJ;;A6B31FA;ECnHE,0BAAA;EACA,wBAAA;E3BoOI,2BALI;E2B7NR,8BAAA;A9Bk9FF;;A6B91FA;ECvHE,2BAAA;EACA,0BAAA;E3BoOI,4BALI;E2B7NR,+BAAA;A9By9FF;;A+B5hGA;EVgBM,gCUfJ;A/B+hGF;AqB5gGM;EUpBN;IVqBQ,gBAAA;ErB+gGN;AACF;A+BliGE;EACE,UAAA;A/BoiGJ;;A+B9hGE;EACE,aAAA;A/BiiGJ;;A+B7hGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A/BgiGF;AqB9hGM;EULN;IVMQ,gBAAA;ErBiiGN;AACF;A+BniGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;A/BqiGJ;AqBxiGM;EUAJ;IVCM,gBAAA;ErB2iGN;AACF;;AgChkGA;;;;;;EAME,kBAAA;AhCmkGF;;AgChkGA;EACE,mBAAA;AhCmkGF;AiChjGI;EACE,qBAAA;EACA,oB5BmewB;E4BlexB,uB5BiewB;E4BhexB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AjCmlGF;AiC9hGI;EACE,cAAA;AjCgiGN;;AgCzkGA;EAEE,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E7B8QI,6BALI;E6BvQR,4BAAA;EACA,sBAAA;EACA,8DAAA;EACA,qCAAA;EACA,+BAAA;EACA,uDAAA;EACA,4DAAA;EACA,sCAAA;EACA,2DAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,a3Bk+BkC;E2Bj+BlC,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E7BiPI,uCALI;E6B1OR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BxCE,+CAAA;ANknGJ;AgCtkGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AhCwkGJ;;AgChjGI;EACE,oBAAA;AhCmjGN;AgCjjGM;EACE,WAAA;EACA,OAAA;AhCmjGR;;AgC/iGI;EACE,kBAAA;AhCkjGN;AgChjGM;EACE,QAAA;EACA,UAAA;AhCkjGR;;Aa3lGI;EmB2BA;IACE,oBAAA;EhCokGJ;EgClkGI;IACE,WAAA;IACA,OAAA;EhCokGN;EgChkGE;IACE,kBAAA;EhCkkGJ;EgChkGI;IACE,QAAA;IACA,UAAA;EhCkkGN;AACF;Aa5mGI;EmB2BA;IACE,oBAAA;EhColGJ;EgCllGI;IACE,WAAA;IACA,OAAA;EhColGN;EgChlGE;IACE,kBAAA;EhCklGJ;EgChlGI;IACE,QAAA;IACA,UAAA;EhCklGN;AACF;Aa5nGI;EmB2BA;IACE,oBAAA;EhComGJ;EgClmGI;IACE,WAAA;IACA,OAAA;EhComGN;EgChmGE;IACE,kBAAA;EhCkmGJ;EgChmGI;IACE,QAAA;IACA,UAAA;EhCkmGN;AACF;Aa5oGI;EmB2BA;IACE,oBAAA;EhConGJ;EgClnGI;IACE,WAAA;IACA,OAAA;EhConGN;EgChnGE;IACE,kBAAA;EhCknGJ;EgChnGI;IACE,QAAA;IACA,UAAA;EhCknGN;AACF;Aa5pGI;EmB2BA;IACE,oBAAA;EhCooGJ;EgCloGI;IACE,WAAA;IACA,OAAA;EhCooGN;EgChoGE;IACE,kBAAA;EhCkoGJ;EgChoGI;IACE,QAAA;IACA,UAAA;EhCkoGN;AACF;AgCznGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AhC2nGJ;AiCntGI;EACE,qBAAA;EACA,oB5BmewB;E4BlexB,uB5BiewB;E4BhexB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AjC+uGF;AiCjsGI;EACE,cAAA;AjCmsGN;;AgC/nGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AhCkoGJ;AiCxuGI;EACE,qBAAA;EACA,oB5BmewB;E4BlexB,uB5BiewB;E4BhexB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AjC6vGF;AiCttGI;EACE,cAAA;AjCwtGN;AgC1oGI;EACE,iBAAA;AhC4oGN;;AgCtoGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AhCyoGJ;AiChwGI;EACE,qBAAA;EACA,oB5BmewB;E4BlexB,uB5BiewB;E4BhexB,WAAA;AjCkwGN;AiCvvGM;EACE,aAAA;AjCyvGR;AiCtvGM;EACE,qBAAA;EACA,qB5BgdsB;E4B/ctB,uB5B8csB;E4B7ctB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AjCuxGF;AiCtvGI;EACE,cAAA;AjCwvGN;AgCzpGI;EACE,iBAAA;AhC2pGN;;AgCppGA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AhCupGF;;AgCjpGA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3B2X4B;E2B1X5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AhCopGF;AgClpGE;EAEE,0CAAA;EVxLF,kDU0LuB;AhCkpGzB;AgC/oGE;EAEE,2CAAA;EACA,qBAAA;EVhMF,mDUiMuB;AhCgpGzB;AgC7oGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AhC8oGJ;;AgCxoGA;EACE,cAAA;AhC2oGF;;AgCvoGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E7B2EI,mBALI;E6BpER,sCAAA;EACA,mBAAA;AhC0oGF;;AgCtoGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AhCyoGF;;AgCroGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AhCuoGF;;AkC33GA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlC83GF;AkC53GE;;EACE,kBAAA;EACA,cAAA;AlC+3GJ;AkC13GE;;;;;;;;;;;;EAME,UAAA;AlCk4GJ;;AkC73GA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlCg4GF;AkC93GE;EACE,WAAA;AlCg4GJ;;AkC53GA;E5BhBI,uBAAA;ANg5GJ;AkC53GE;;EAEE,iBAAA;AlC83GJ;AkC13GE;;;E5BVE,0BAAA;EACA,6BAAA;ANy4GJ;AkCt3GE;;;E5BNE,yBAAA;EACA,4BAAA;ANi4GJ;;AkCz2GA;EACE,wBAAA;EACA,uBAAA;AlC42GF;AkC12GE;EAGE,cAAA;AlC02GJ;AkCv2GE;EACE,eAAA;AlCy2GJ;;AkCr2GA;EACE,uBAAA;EACA,sBAAA;AlCw2GF;;AkCr2GA;EACE,sBAAA;EACA,qBAAA;AlCw2GF;;AkCp1GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlCu1GF;AkCr1GE;;EAEE,WAAA;AlCu1GJ;AkCp1GE;;EAEE,gBAAA;AlCs1GJ;AkCl1GE;;E5B1FE,6BAAA;EACA,4BAAA;ANg7GJ;AkCl1GE;;E5B7GE,yBAAA;EACA,0BAAA;ANm8GJ;;AmC39GA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnC09GF;;AmCv9GA;EACE,cAAA;EACA,kEAAA;EhC4QI,uCALI;EgCrQR,2CAAA;EACA,+BAAA;EACA,qBAAA;EdbI,uGccJ;AnC09GF;AqBp+GM;EcGN;IdFQ,gBAAA;ErBu+GN;AACF;AmC79GE;EAEE,qCAAA;AnC89GJ;AmCz9GE;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;AnC29GJ;;AmCn9GA;EAEE,+BAAA;EACA,mCAAA;EACA,qCAAA;EACA,8DAAA;EACA,wCAAA;EACA,kCAAA;EACA,4DAAA;EAGA,oFAAA;AnCm9GF;AmCj9GE;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;E7BtCA,wDAAA;EACA,yDAAA;AN0/GJ;AmCl9GI;EAGE,kBAAA;EACA,wDAAA;AnCk9GN;AmC/8GI;EAEE,wCAAA;EACA,6BAAA;EACA,yBAAA;AnCg9GN;AmC58GE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AnC88GJ;AmC38GE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AN8gHJ;;AmCn8GA;EAEE,sCAAA;EACA,sCAAA;EACA,sCAAA;AnCq8GF;AmCl8GE;EACE,gBAAA;EACA,SAAA;E7B9FA,gDAAA;ANmiHJ;AmCl8GI;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AnCo8GN;AmCh8GE;;EAEE,4CAAA;EbzHF,oDa0HuB;AnCk8GzB;;AmCx7GE;;EAEE,cAAA;EACA,kBAAA;AnC27GJ;;AmCt7GE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AnCy7GJ;;AmCn7GE;;EACE,WAAA;AnCu7GJ;;AmC76GE;EACE,aAAA;AnCg7GJ;AmC96GE;EACE,cAAA;AnCg7GJ;;AoCplHA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,wQAAA;EACA,oDAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ApColHF;AoC9kHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ApCslHJ;AoClkHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EjCkOI,2CALI;EiC3NR,mCAAA;EACA,qBAAA;EACA,mBAAA;ApCokHF;AoClkHE;EAEE,yCAAA;ApCmkHJ;;AoCzjHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCwjHF;AoCtjHE;;EAEE,oCAAA;ApCwjHJ;AoCrjHE;EACE,gBAAA;ApCujHJ;;AoC9iHA;EACE,mB/B46BkC;E+B36BlC,sB/B26BkC;E+B16BlC,6BAAA;ApCijHF;AoC/iHE;;;EAGE,oCAAA;ApCijHJ;;AoCpiHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ApCqiHF;;AoCjiHA;EACE,8EAAA;EjCiJI,6CALI;EiC1IR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BtIE,qDAAA;EeHE,+Ce2IJ;ApCoiHF;AqB3qHM;Ee+HN;If9HQ,gBAAA;ErB8qHN;AACF;AoCviHE;EACE,qBAAA;ApCyiHJ;AoCtiHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ApCwiHJ;;AoCliHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ApCqiHF;;AoCliHA;EACE,yCAAA;EACA,gBAAA;ApCqiHF;;Aa7pHI;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EpC4hHN;EoC1hHM;IACE,mBAAA;EpC4hHR;EoC1hHQ;IACE,kBAAA;EpC4hHV;EoCzhHQ;IACE,kDAAA;IACA,iDAAA;EpC2hHV;EoCvhHM;IACE,iBAAA;EpCyhHR;EoCthHM;IACE,wBAAA;IACA,gBAAA;EpCwhHR;EoCrhHM;IACE,aAAA;EpCuhHR;EoCphHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If5NJ,gBe8NI;EpCohHR;EoCjhHQ;IACE,aAAA;EpCmhHV;EoChhHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCkhHV;AACF;Aa7sHI;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EpC2kHN;EoCzkHM;IACE,mBAAA;EpC2kHR;EoCzkHQ;IACE,kBAAA;EpC2kHV;EoCxkHQ;IACE,kDAAA;IACA,iDAAA;EpC0kHV;EoCtkHM;IACE,iBAAA;EpCwkHR;EoCrkHM;IACE,wBAAA;IACA,gBAAA;EpCukHR;EoCpkHM;IACE,aAAA;EpCskHR;EoCnkHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If5NJ,gBe8NI;EpCmkHR;EoChkHQ;IACE,aAAA;EpCkkHV;EoC/jHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCikHV;AACF;Aa5vHI;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EpC0nHN;EoCxnHM;IACE,mBAAA;EpC0nHR;EoCxnHQ;IACE,kBAAA;EpC0nHV;EoCvnHQ;IACE,kDAAA;IACA,iDAAA;EpCynHV;EoCrnHM;IACE,iBAAA;EpCunHR;EoCpnHM;IACE,wBAAA;IACA,gBAAA;EpCsnHR;EoCnnHM;IACE,aAAA;EpCqnHR;EoClnHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If5NJ,gBe8NI;EpCknHR;EoC/mHQ;IACE,aAAA;EpCinHV;EoC9mHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpCgnHV;AACF;Aa3yHI;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EpCyqHN;EoCvqHM;IACE,mBAAA;EpCyqHR;EoCvqHQ;IACE,kBAAA;EpCyqHV;EoCtqHQ;IACE,kDAAA;IACA,iDAAA;EpCwqHV;EoCpqHM;IACE,iBAAA;EpCsqHR;EoCnqHM;IACE,wBAAA;IACA,gBAAA;EpCqqHR;EoClqHM;IACE,aAAA;EpCoqHR;EoCjqHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If5NJ,gBe8NI;EpCiqHR;EoC9pHQ;IACE,aAAA;EpCgqHV;EoC7pHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpC+pHV;AACF;Aa11HI;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EpCwtHN;EoCttHM;IACE,mBAAA;EpCwtHR;EoCttHQ;IACE,kBAAA;EpCwtHV;EoCrtHQ;IACE,kDAAA;IACA,iDAAA;EpCutHV;EoCntHM;IACE,iBAAA;EpCqtHR;EoCltHM;IACE,wBAAA;IACA,gBAAA;EpCotHR;EoCjtHM;IACE,aAAA;EpCmtHR;EoChtHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If5NJ,gBe8NI;EpCgtHR;EoC7sHQ;IACE,aAAA;EpC+sHV;EoC5sHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EpC8sHV;AACF;AoCrwHI;EAEI,iBAAA;EACA,2BAAA;ApCswHR;AoCpwHQ;EACE,mBAAA;ApCswHV;AoCpwHU;EACE,kBAAA;ApCswHZ;AoCnwHU;EACE,kDAAA;EACA,iDAAA;ApCqwHZ;AoCjwHQ;EACE,iBAAA;ApCmwHV;AoChwHQ;EACE,wBAAA;EACA,gBAAA;ApCkwHV;AoC/vHQ;EACE,aAAA;ApCiwHV;AoC9vHQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef5NJ,gBe8NI;ApC8vHV;AoC3vHU;EACE,aAAA;ApC6vHZ;AoC1vHU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ApC4vHZ;;AoC3uHA;EACE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,8QAAA;ApC8uHF;;AqC5/HA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,2BAAA;EACA,0DAAA;EACA,iCAAA;EACA,sBAAA;EACA,mDAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BdE,2CAAA;AN2gIJ;AqCz/HE;EACE,eAAA;EACA,cAAA;ArC2/HJ;AqCx/HE;EACE,mBAAA;EACA,sBAAA;ArC0/HJ;AqCx/HI;EACE,mBAAA;E/BnBF,0DAAA;EACA,2DAAA;AN8gIJ;AqCx/HI;EACE,sBAAA;E/BVF,8DAAA;EACA,6DAAA;ANqgIJ;AqCr/HE;;EAEE,aAAA;ArCu/HJ;;AqCn/HA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;ArCo/HF;;AqCj/HA;EACE,4CAAA;ArCo/HF;;AqCj/HA;EACE,sDAAA;EACA,gBAAA;ArCo/HF;;AqCj/HA;EACE,gBAAA;ArCo/HF;;AqC5+HE;EACE,oCAAA;ArC++HJ;;AqCv+HA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;ArC0+HF;AqCx+HE;E/BxFE,wFAAA;ANmkIJ;;AqCt+HA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;ArCy+HF;AqCv+HE;E/BnGE,wFAAA;AN6kIJ;;AqCh+HA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;ArCm+HF;AqCj+HE;EACE,mCAAA;EACA,sCAAA;ArCm+HJ;;AqC/9HA;EACE,uDAAA;EACA,sDAAA;ArCk+HF;;AqC99HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/BrIE,iDAAA;ANumIJ;;AqC99HA;;;EAGE,WAAA;ArCi+HF;;AqC99HA;;E/BtII,0DAAA;EACA,2DAAA;ANymIJ;;AqC/9HA;;E/B7HI,8DAAA;EACA,6DAAA;ANimIJ;;AqCx9HE;EACE,0CAAA;ArC29HJ;AajlII;EwBkHJ;IAQI,aAAA;IACA,mBAAA;ErC29HF;EqCx9HE;IAEE,YAAA;IACA,gBAAA;ErCy9HJ;EqCv9HI;IACE,cAAA;IACA,cAAA;ErCy9HN;EqCp9HM;I/BtKJ,0BAAA;IACA,6BAAA;EN6nIF;EqCr9HQ;;IAGE,0BAAA;ErCs9HV;EqCp9HQ;;IAGE,6BAAA;ErCq9HV;EqCj9HM;I/BvKJ,yBAAA;IACA,4BAAA;EN2nIF;EqCl9HQ;;IAGE,yBAAA;ErCm9HV;EqCj9HQ;;IAGE,4BAAA;ErCk9HV;AACF;;AsClrIA;EAEE,0BAAA;EACA,uBAAA;EACA,8KAAA;EACA,mDAAA;EACA,gCAAA;EACA,sCAAA;EACA,wDAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,uTAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,+SAAA;EACA,8CAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;AtCorIF;;AsChrIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EnCiQI,eALI;EmC1PR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCtBE,gBAAA;EgCwBF,qBAAA;EjB3BI,0CiB4BJ;AtCmrIF;AqB3sIM;EiBWN;IjBVQ,gBAAA;ErB8sIN;AACF;AsCtrIE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AtCwrIJ;AsCtrII;EACE,qDAAA;EACA,iDAAA;AtCwrIN;AsCnrIE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AtCqrIJ;AqBpuIM;EiBsCJ;IjBrCM,gBAAA;ErBuuIN;AACF;AsCvrIE;EACE,UAAA;AtCyrIJ;AsCtrIE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AtCwrIJ;;AsCprIA;EACE,gBAAA;AtCurIF;;AsCprIA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AtCurIF;AsCrrIE;EhC/DE,yDAAA;EACA,0DAAA;ANuvIJ;AsCtrII;EhClEA,+DAAA;EACA,gEAAA;AN2vIJ;AsCrrIE;EACE,aAAA;AtCurIJ;AsCnrIE;EhC9DE,6DAAA;EACA,4DAAA;ANovIJ;AsCnrIM;EhClEF,mEAAA;EACA,kEAAA;ANwvIJ;AsClrII;EhCvEA,6DAAA;EACA,4DAAA;AN4vIJ;;AsChrIA;EACE,8EAAA;AtCmrIF;;AsC1qIE;EACE,eAAA;AtC6qIJ;AsC1qIE;EACE,eAAA;EACA,cAAA;EhCpHA,gBAAA;ANiyIJ;AsC1qII;EAAgB,aAAA;AtC6qIpB;AsC5qII;EAAe,gBAAA;AtC+qInB;AsC7qII;EhC1HA,gBAAA;AN0yIJ;;AuC7zIA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EpCqRI,yCALI;EoC9QR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AN6zIJ;;AuCvzIE;EACE,iDAAA;AvC0zIJ;AuCxzII;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AvC0zIN;AuCtzIE;EACE,6CAAA;AvCwzIJ;;AwC71IA;EAEE,kCAAA;EACA,mCAAA;ErCkSI,+BALI;EqC3RR,2CAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,uDAAA;EACA,iCAAA;EACA,2CAAA;EACA,uDAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;ARk3IF;;AwC31IA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ErCsQI,yCALI;EqC/PR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AxC81IF;AqB/2IM;EmBQN;InBPQ,gBAAA;ErBk3IN;AACF;AwCj2IE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AxCk2IJ;AwC/1IE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnCioCgC;EmChoChC,iDAAA;AxCi2IJ;AwC91IE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AxC+1IJ;AwC51IE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AxC61IJ;;AwCx1IE;EACE,iBnComCgC;ALuvGpC;AwCt1IM;ElC9BF,0DAAA;EACA,6DAAA;ANu3IJ;AwCp1IM;ElClDF,2DAAA;EACA,8DAAA;ANy4IJ;;AwCv0IA;EClGE,iCAAA;EACA,kCAAA;EtCgSI,kCALI;EsCzRR,qCAAA;AzC66IF;;AwC10IA;ECtGE,iCAAA;EACA,kCAAA;EtCgSI,mCALI;EsCzRR,sCAAA;AzCo7IF;;A0Ct7IA;EAEE,4BAAA;EACA,4BAAA;EvC6RI,4BALI;EuCtRR,2BAAA;EACA,sBAAA;EACA,kCAAA;EAGA,qBAAA;EACA,4DAAA;EvCqRI,oCALI;EuC9QR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;AN27IJ;A0Cl7IE;EACE,aAAA;A1Co7IJ;;A0C/6IA;EACE,kBAAA;EACA,SAAA;A1Ck7IF;;A2Cl9IA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,kCAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCFE,4CAAA;ANq9IJ;;A2C98IA;EAEE,cAAA;A3Cg9IF;;A2C58IA;EACE,gBtC8gB4B;ALi8H9B;;A2Cv8IA;EACE,mBtC63C8B;AL6kGhC;A2Cv8IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A3Cy8IJ;;A2Cz7IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5C6/IF;A4Cv/IE;EACE,cAAA;A5Cy/IJ;;A2Cl8IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5CsgJF;A4ChgJE;EACE,cAAA;A5CkgJJ;;A2C38IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5C+gJF;A4CzgJE;EACE,cAAA;A5C2gJJ;;A2Cp9IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5CwhJF;A4ClhJE;EACE,cAAA;A5CohJJ;;A2C79IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5CiiJF;A4C3hJE;EACE,cAAA;A5C6hJJ;;A2Ct+IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5C0iJF;A4CpiJE;EACE,cAAA;A5CsiJJ;;A2C/+IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5CmjJF;A4C7iJE;EACE,cAAA;A5C+iJJ;;A2Cx/IE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5C4jJF;A4CtjJE;EACE,cAAA;A5CwjJJ;;A6C/jJE;EACE;IAAK,2BxCy6C2B;EL0pGlC;AACF;A6C/jJA;EAEE,0BAAA;E1CyRI,gCALI;E0ClRR,yBAAA;EACA,qCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1C6QI,uCALI;E0CtQR,uCAAA;EvCPE,+CAAA;ANskJJ;;A6C1jJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;ExBvBI,6CwBwBJ;A7C6jJF;AqBjlJM;EwBWN;IxBVQ,gBAAA;ErBolJN;AACF;;A6C/jJA;EvBCE,qMAAA;EuBCA,oEAAA;A7CkkJF;;A6C9jJE;EACE,kDAAA;A7CikJJ;A6C9jJM;EAJJ;IAKM,eAAA;E7CikJN;AACF;;A8CpnJA;EAEE,8BAAA;EACA,wBAAA;EACA,kDAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCXE,iDAAA;AN8nJJ;;A8C/mJA;EACE,qBAAA;EACA,sBAAA;A9CknJF;A8ChnJE;EAEE,oCAAA;EACA,0BAAA;A9CinJJ;;A8CxmJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9C2mJF;A8CxmJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9CymJJ;A8CtmJE;EACE,+CAAA;EACA,uDAAA;A9CwmJJ;;A8ChmJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CmmJF;A8CjmJE;ExCvDE,+BAAA;EACA,gCAAA;AN2pJJ;A8CjmJE;ExC7CE,mCAAA;EACA,kCAAA;ANipJJ;A8CjmJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CkmJJ;A8C9lJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CgmJJ;A8C7lJE;EACE,mBAAA;A9C+lJJ;A8C7lJI;EACE,wDAAA;EACA,mDAAA;A9C+lJN;;A8CllJI;EACE,mBAAA;A9CqlJN;A8CllJQ;ExCtDJ,6DAAA;EAZA,0BAAA;ANwpJJ;A8CjlJQ;ExCvEJ,2DAAA;EAYA,4BAAA;ANgpJJ;A8ChlJQ;EACE,aAAA;A9CklJV;A8C/kJQ;EACE,mDAAA;EACA,oBAAA;A9CilJV;A8C/kJU;EACE,yDAAA;EACA,oDAAA;A9CilJZ;;AatqJI;EiC6DA;IACE,mBAAA;E9C6mJJ;E8C1mJM;IxCtDJ,6DAAA;IAZA,0BAAA;ENgrJF;E8CzmJM;IxCvEJ,2DAAA;IAYA,4BAAA;ENwqJF;E8CxmJM;IACE,aAAA;E9C0mJR;E8CvmJM;IACE,mDAAA;IACA,oBAAA;E9CymJR;E8CvmJQ;IACE,yDAAA;IACA,oDAAA;E9CymJV;AACF;Aa/rJI;EiC6DA;IACE,mBAAA;E9CqoJJ;E8CloJM;IxCtDJ,6DAAA;IAZA,0BAAA;ENwsJF;E8CjoJM;IxCvEJ,2DAAA;IAYA,4BAAA;ENgsJF;E8ChoJM;IACE,aAAA;E9CkoJR;E8C/nJM;IACE,mDAAA;IACA,oBAAA;E9CioJR;E8C/nJQ;IACE,yDAAA;IACA,oDAAA;E9CioJV;AACF;AavtJI;EiC6DA;IACE,mBAAA;E9C6pJJ;E8C1pJM;IxCtDJ,6DAAA;IAZA,0BAAA;ENguJF;E8CzpJM;IxCvEJ,2DAAA;IAYA,4BAAA;ENwtJF;E8CxpJM;IACE,aAAA;E9C0pJR;E8CvpJM;IACE,mDAAA;IACA,oBAAA;E9CypJR;E8CvpJQ;IACE,yDAAA;IACA,oDAAA;E9CypJV;AACF;Aa/uJI;EiC6DA;IACE,mBAAA;E9CqrJJ;E8ClrJM;IxCtDJ,6DAAA;IAZA,0BAAA;ENwvJF;E8CjrJM;IxCvEJ,2DAAA;IAYA,4BAAA;ENgvJF;E8ChrJM;IACE,aAAA;E9CkrJR;E8C/qJM;IACE,mDAAA;IACA,oBAAA;E9CirJR;E8C/qJQ;IACE,yDAAA;IACA,oDAAA;E9CirJV;AACF;AavwJI;EiC6DA;IACE,mBAAA;E9C6sJJ;E8C1sJM;IxCtDJ,6DAAA;IAZA,0BAAA;ENgxJF;E8CzsJM;IxCvEJ,2DAAA;IAYA,4BAAA;ENwwJF;E8CxsJM;IACE,aAAA;E9C0sJR;E8CvsJM;IACE,mDAAA;IACA,oBAAA;E9CysJR;E8CvsJQ;IACE,yDAAA;IACA,oDAAA;E9CysJV;AACF;A8C5rJA;ExC/II,gBAAA;AN80JJ;A8C5rJE;EACE,mDAAA;A9C8rJJ;A8C5rJI;EACE,sBAAA;A9C8rJN;;A+Cn2JE;EACE,cDkLyB;ECjLzB,yBDgLsB;A9CsrJ1B;A+Cn2JM;EAEE,cD4KqB;EC3KrB,yBAAA;A/Co2JR;A+Cj2JM;EACE,W1CRG;E0CSH,yBDsKqB;ECrKrB,qBDqKqB;A9C8rJ7B;;A+Cj3JE;EACE,cDkLyB;ECjLzB,yBDgLsB;A9CosJ1B;A+Cj3JM;EAEE,cD4KqB;EC3KrB,yBAAA;A/Ck3JR;A+C/2JM;EACE,W1CRG;E0CSH,yBDsKqB;ECrKrB,qBDqKqB;A9C4sJ7B;;A+C/3JE;EACE,cDkLyB;ECjLzB,yBDgLsB;A9CktJ1B;A+C/3JM;EAEE,cD4KqB;EC3KrB,yBAAA;A/Cg4JR;A+C73JM;EACE,W1CRG;E0CSH,yBDsKqB;ECrKrB,qBDqKqB;A9C0tJ7B;;A+C74JE;EACE,cDoL2B;ECnL3B,yBDgLsB;A9CguJ1B;A+C74JM;EAEE,cD8KuB;EC7KvB,yBAAA;A/C84JR;A+C34JM;EACE,W1CRG;E0CSH,yBDwKuB;ECvKvB,qBDuKuB;A9CsuJ/B;;A+C35JE;EACE,cDoL2B;ECnL3B,yBDgLsB;A9C8uJ1B;A+C35JM;EAEE,cD8KuB;EC7KvB,yBAAA;A/C45JR;A+Cz5JM;EACE,W1CRG;E0CSH,yBDwKuB;ECvKvB,qBDuKuB;A9CovJ/B;;A+Cz6JE;EACE,cDkLyB;ECjLzB,yBDgLsB;A9C4vJ1B;A+Cz6JM;EAEE,cD4KqB;EC3KrB,yBAAA;A/C06JR;A+Cv6JM;EACE,W1CRG;E0CSH,yBDsKqB;ECrKrB,qBDqKqB;A9CowJ7B;;A+Cv7JE;EACE,cDoL2B;ECnL3B,yBDgLsB;A9C0wJ1B;A+Cv7JM;EAEE,cD8KuB;EC7KvB,yBAAA;A/Cw7JR;A+Cr7JM;EACE,W1CRG;E0CSH,yBDwKuB;ECvKvB,qBDuKuB;A9CgxJ/B;;A+Cr8JE;EACE,cDkLyB;ECjLzB,yBDgLsB;A9CwxJ1B;A+Cr8JM;EAEE,cD4KqB;EC3KrB,yBAAA;A/Cs8JR;A+Cn8JM;EACE,W1CRG;E0CSH,yBDsKqB;ECrKrB,qBDqKqB;A9CgyJ7B;;AgDl9JA;EACE,uBAAA;EACA,U3C4iD2B;E2C3iD3B,W3C2iD2B;E2C1iD3B,sBAAA;EACA,W3CQS;E2CPT,mXAAA;EACA,SAAA;E1COE,uBAAA;E0CLF,Y3C4iD2B;ALy6G7B;AgDl9JE;EACE,WAAA;EACA,qBAAA;EACA,a3CuiDyB;AL66G7B;AgDj9JE;EACE,UAAA;EACA,kD3C8rB4B;E2C7rB5B,U3CkiDyB;ALi7G7B;AgDh9JE;EAEE,oBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,a3C4hDyB;ALq7G7B;;AgD78JA;EACE,kD3CwhD2B;ALw7G7B;;AiDt/JA;EAEE,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E9CgSI,8BALI;E8CzRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2DAAA;EACA,kCAAA;EACA,wDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E9CkRI,oCALI;E8C3QR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E3CPE,4CAAA;AN8/JJ;AiDp/JE;EACE,UAAA;AjDs/JJ;AiDn/JE;EACE,aAAA;AjDq/JJ;;AiDj/JA;EACE,kBAAA;EACA,a5Cm/BkC;E4Cl/BlC,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDo/JF;AiDl/JE;EACE,sCAAA;AjDo/JJ;;AiDh/JA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E3C7BE,0FAAA;EACA,2FAAA;ANihKJ;AiDl/JE;EACE,oDAAA;EACA,sCAAA;AjDo/JJ;;AiDh/JA;EACE,kCAAA;EACA,qBAAA;AjDm/JF;;AkD9iKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2DAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD4iKF;;AkDriKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlDuiKF;AkDpiKE;E7B5CI,mC6B6CF;EACA,8B7Co1CgC;ALktHpC;AqBhlKM;E6BwCJ;I7BvCM,gBAAA;ErBmlKN;AACF;AkDziKE;EACE,e7Ck1CgC;ALytHpC;AkDviKE;EACE,sB7C+0CgC;AL0tHpC;;AkDriKA;EACE,+CAAA;AlDwiKF;AkDtiKE;EACE,gBAAA;EACA,gBAAA;AlDwiKJ;AkDriKE;EACE,gBAAA;AlDuiKJ;;AkDniKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDsiKF;;AkDliKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E5CrFE,4CAAA;E4CyFF,UAAA;AlDkiKF;;AkD9hKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDoiK9D;AmDhpKE;EAAS,UAAA;AnDmpKX;AmDlpKE;EAAS,mCD2GiF;AlD0iK5F;;AkDriKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E5CtGE,2DAAA;EACA,4DAAA;AN+oKJ;AkDviKE;EACE,kGAAA;EACA,sJAAA;AlDyiKJ;;AkDpiKA;EACE,gBAAA;EACA,8CAAA;AlDuiKF;;AkDliKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlDmiKF;;AkD/hKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E5C1HE,+DAAA;EACA,8DAAA;AN6pKJ;AkD9hKE;EACE,8CAAA;AlDgiKJ;;Aa5oKI;EqCkHF;IACE,0BAAA;IACA,wDAAA;ElD8hKF;EkD1hKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElD4hKF;EkDzhKA;IACE,uBAAA;ElD2hKF;AACF;Aa3pKI;EqCoIF;;IAEE,uBAAA;ElD0hKF;AACF;AajqKI;EqC2IF;IACE,wBAAA;ElDyhKF;AACF;AkDhhKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDkhKN;AkDhhKM;EACE,YAAA;EACA,SAAA;E5C1MJ,gBAAA;AN6tKJ;AkD/gKM;;E5C9MF,gBAAA;ANiuKJ;AkD9gKM;EACE,gBAAA;AlDghKR;;Aa3qKI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDsiKJ;EkDpiKI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ENivKF;EkDniKI;;I5C9MF,gBAAA;ENqvKF;EkDliKI;IACE,gBAAA;ElDoiKN;AACF;AahsKI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD0jKJ;EkDxjKI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ENqwKF;EkDvjKI;;I5C9MF,gBAAA;ENywKF;EkDtjKI;IACE,gBAAA;ElDwjKN;AACF;AaptKI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD8kKJ;EkD5kKI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ENyxKF;EkD3kKI;;I5C9MF,gBAAA;EN6xKF;EkD1kKI;IACE,gBAAA;ElD4kKN;AACF;AaxuKI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDkmKJ;EkDhmKI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;EN6yKF;EkD/lKI;;I5C9MF,gBAAA;ENizKF;EkD9lKI;IACE,gBAAA;ElDgmKN;AACF;Aa5vKI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDsnKJ;EkDpnKI;IACE,YAAA;IACA,SAAA;I5C1MJ,gBAAA;ENi0KF;EkDnnKI;;I5C9MF,gBAAA;ENq0KF;EkDlnKI;IACE,gBAAA;ElDonKN;AACF;AoD31KA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EjD8RI,gCALI;EiDvRR,wBAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;ECnBA,sChDgiB4B;EgD9hB5B,kBAAA;EACA,gBhDyiB4B;EgDxiB5B,gBhD+iB4B;EgD9iB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDsRI,sCALI;EiDrQR,qBAAA;EACA,UAAA;ApDm2KF;AoDj2KE;EAAS,kCAAA;ApDo2KX;AoDl2KE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDo2KJ;AoDl2KI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDo2KN;;AoD/1KA;EACE,SAAA;ApDk2KF;AoDh2KE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDk2KJ;;AoD91KA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;ApDi2KF;AoD/1KE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApDi2KJ;;AoD71KA,mBAAA;AAEA;EACE,MAAA;ApD+1KF;AoD71KE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApD+1KJ;;AoD31KA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;ApD81KF;AoD51KE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApD81KJ;;AoD11KA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E9ClGE,8CAAA;AN+6KJ;;AsDl8KA;EAEE,yBAAA;EACA,6BAAA;EnDkSI,gCALI;EmD3RR,qBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kCAAA;EACA,oDAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;EnDyRI,mCALI;EmDlRR,kDAAA;EACA,+BAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sChDgiB4B;EgD9hB5B,kBAAA;EACA,gBhDyiB4B;EgDxiB5B,gBhD+iB4B;EgD9iB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDsRI,sCALI;EmDhQR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EhDhBE,8CAAA;AN69KJ;AsDz8KE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD28KJ;AsDz8KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtD08KN;;AsDp8KE;EACE,kFAAA;AtDu8KJ;AsDr8KI;EAEE,wFAAA;AtDs8KN;AsDn8KI;EACE,SAAA;EACA,gDAAA;AtDq8KN;AsDl8KI;EACE,sCAAA;EACA,sCAAA;AtDo8KN;;AsD/7KA,qBAAA;AAEE;EACE,gFAAA;EACA,qCAAA;EACA,qCAAA;AtDi8KJ;AsD/7KI;EAEE,kIAAA;AtDg8KN;AsD77KI;EACE,OAAA;EACA,kDAAA;AtD+7KN;AsD57KI;EACE,oCAAA;EACA,wCAAA;AtD87KN;;AsDz7KA,mBAAA;AAGE;EACE,+EAAA;AtD07KJ;AsDx7KI;EAEE,wFAAA;AtDy7KN;AsDt7KI;EACE,MAAA;EACA,mDAAA;AtDw7KN;AsDr7KI;EACE,mCAAA;EACA,yCAAA;AtDu7KN;AsDl7KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtDo7KJ;;AsDh7KA,qBAAA;AAEE;EACE,iFAAA;EACA,qCAAA;EACA,qCAAA;AtDk7KJ;AsDh7KI;EAEE,kIAAA;AtDi7KN;AsD96KI;EACE,QAAA;EACA,iDAAA;AtDg7KN;AsD76KI;EACE,qCAAA;EACA,uCAAA;AtD+6KN;;AsD16KA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EnDiHI,6CALI;EmD1GR,qCAAA;EACA,6CAAA;EACA,kFAAA;EhD5JE,6DAAA;EACA,8DAAA;ANyjLJ;AsD35KE;EACE,aAAA;AtD65KJ;;AsDz5KA;EACE,0EAAA;EACA,mCAAA;AtD45KF;;AuDjlLA;EACE,kBAAA;AvDolLF;;AuDjlLA;EACE,mBAAA;AvDolLF;;AuDjlLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDolLF;AwD1mLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD4mLJ;;AuDrlLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElClBI,sCkCmBJ;AvDwlLF;AqBvmLM;EkCQN;IlCPQ,gBAAA;ErB0mLN;AACF;;AuD1lLA;;;EAGE,cAAA;AvD6lLF;;AuD1lLA,qBAAA;AACA;;EAEE,2BAAA;AvD6lLF;;AuD1lLA;;EAEE,4BAAA;AvD6lLF;;AuD1lLA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDslLJ;AuDnlLE;;;EAGE,UAAA;EACA,UAAA;AvDqlLJ;AuDllLE;;EAEE,UAAA;EACA,UAAA;ElC/DE,2BkCgEF;AvDolLJ;AqBhpLM;EkCwDJ;;IlCvDM,gBAAA;ErBopLN;AACF;;AuDjlLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlD65CmC;EkD55CnC,UAAA;EACA,WlD7FS;EkD8FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlDw5CmC;EgBj/C/B,8BkC0FJ;AvDmlLF;AqBzqLM;EkCqEN;;IlCpEQ,gBAAA;ErB6qLN;AACF;AuDtlLE;;;EAEE,WlDvGO;EkDwGP,qBAAA;EACA,UAAA;EACA,YlDg5CiC;ALysIrC;;AuDtlLA;EACE,OAAA;AvDylLF;;AuDtlLA;EACE,QAAA;AvDylLF;;AuDplLA;;EAEE,qBAAA;EACA,WlDi5CmC;EkDh5CnC,YlDg5CmC;EkD/4CnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvDulLF;;AuDplLA;;;;;;;GAAA;AAQA;EACE,yQAAA;AvDulLF;;AuDrlLA;EACE,0QAAA;AvDwlLF;;AuDhlLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlDy1CmC;EkDx1CnC,mBAAA;EACA,gBlDu1CmC;EkDt1CnC,gBAAA;AvDklLF;AuDhlLE;EACE,uBAAA;EACA,cAAA;EACA,WlDs1CiC;EkDr1CjC,WlDs1CiC;EkDr1CjC,UAAA;EACA,iBlDs1CiC;EkDr1CjC,gBlDq1CiC;EkDp1CjC,mBAAA;EACA,eAAA;EACA,sBlD9KO;EkD+KP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlD60CiC;EgBz/C/B,6BkC6KF;AvDilLJ;AqB1vLM;EkCwJJ;IlCvJM,gBAAA;ErB6vLN;AACF;AuDnlLE;EACE,UlD00CiC;AL2wIrC;;AuD5kLA;EACE,kBAAA;EACA,UAAA;EACA,elDo0CmC;EkDn0CnC,SAAA;EACA,oBlDi0CmC;EkDh0CnC,uBlDg0CmC;EkD/zCnC,WlDzMS;EkD0MT,kBAAA;AvD+kLF;;AuDzkLE;;EAEE,gClDm0CiC;ALywIrC;AuDzkLE;EACE,sBlD5MO;ALuxLX;AuDxkLE;EACE,WlDhNO;AL0xLX;;AyDxyLA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzD0yLF;;AyDtyLA;EACE;IAAK,0CAAA;EzD0yLL;AACF;AyDvyLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzDsyLF;;AyDnyLA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzDqyLF;;AyD5xLA;EACE;IACE,mBAAA;EzD+xLF;EyD7xLA;IACE,UAAA;IACA,eAAA;EzD+xLF;AACF;AyD3xLA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzD0xLF;;AyDvxLA;EACE,wBAAA;EACA,yBAAA;AzD0xLF;;AyDtxLE;EACE;;IAEE,kCAAA;EzDyxLJ;AACF;A0Dz2LA;EAEE,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,+DAAA;EACA,kEAAA;A1D02LF;;Aa1yLI;E6C/CF;IAEI,eAAA;IACA,SAAA;IACA,arDq/B8B;IqDp/B9B,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IrCzBA,sCqC2BA;E1D21LJ;AACF;AqBn3LM;EqCSJ;IrCRM,gBAAA;ErBs3LN;AACF;Aah0LI;E6C/BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Dk2LN;AACF;Aaz0LI;E6CvBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Dm2LN;AACF;Aal1LI;E6CfE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Do2LN;AACF;Aa71LI;E6CLE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dq2LN;AACF;Aav2LI;E6CIE;IAEE,eAAA;E1Dq2LN;AACF;Aa52LI;E6CSE;IAGE,mBAAA;E1Do2LN;AACF;Aa93LI;E6ClCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Dm2LN;E0Dj2LM;IACE,aAAA;E1Dm2LR;E0Dh2LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Di2LR;AACF;;Aal4LI;E6C/CF;IAEI,eAAA;IACA,SAAA;IACA,arDq/B8B;IqDp/B9B,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IrCzBA,sCqC2BA;E1Dm7LJ;AACF;AqB38LM;EqCSJ;IrCRM,gBAAA;ErB88LN;AACF;Aax5LI;E6C/BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D07LN;AACF;Aaj6LI;E6CvBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D27LN;AACF;Aa16LI;E6CfE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D47LN;AACF;Aar7LI;E6CLE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D67LN;AACF;Aa/7LI;E6CIE;IAEE,eAAA;E1D67LN;AACF;Aap8LI;E6CSE;IAGE,mBAAA;E1D47LN;AACF;Aat9LI;E6ClCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D27LN;E0Dz7LM;IACE,aAAA;E1D27LR;E0Dx7LM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Dy7LR;AACF;;Aa19LI;E6C/CF;IAEI,eAAA;IACA,SAAA;IACA,arDq/B8B;IqDp/B9B,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IrCzBA,sCqC2BA;E1D2gMJ;AACF;AqBniMM;EqCSJ;IrCRM,gBAAA;ErBsiMN;AACF;Aah/LI;E6C/BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DkhMN;AACF;Aaz/LI;E6CvBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DmhMN;AACF;AalgMI;E6CfE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DohMN;AACF;Aa7gMI;E6CLE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DqhMN;AACF;AavhMI;E6CIE;IAEE,eAAA;E1DqhMN;AACF;Aa5hMI;E6CSE;IAGE,mBAAA;E1DohMN;AACF;Aa9iMI;E6ClCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DmhMN;E0DjhMM;IACE,aAAA;E1DmhMR;E0DhhMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DihMR;AACF;;AaljMI;E6C/CF;IAEI,eAAA;IACA,SAAA;IACA,arDq/B8B;IqDp/B9B,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IrCzBA,sCqC2BA;E1DmmMJ;AACF;AqB3nMM;EqCSJ;IrCRM,gBAAA;ErB8nMN;AACF;AaxkMI;E6C/BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D0mMN;AACF;AajlMI;E6CvBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D2mMN;AACF;Aa1lMI;E6CfE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D4mMN;AACF;AarmMI;E6CLE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D6mMN;AACF;Aa/mMI;E6CIE;IAEE,eAAA;E1D6mMN;AACF;AapnMI;E6CSE;IAGE,mBAAA;E1D4mMN;AACF;AatoMI;E6ClCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D2mMN;E0DzmMM;IACE,aAAA;E1D2mMR;E0DxmMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DymMR;AACF;;Aa1oMI;E6C/CF;IAEI,eAAA;IACA,SAAA;IACA,arDq/B8B;IqDp/B9B,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IrCzBA,sCqC2BA;E1D2rMJ;AACF;AqBntMM;EqCSJ;IrCRM,gBAAA;ErBstMN;AACF;AahqMI;E6C/BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DksMN;AACF;AazqMI;E6CvBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DmsMN;AACF;AalrMI;E6CfE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DosMN;AACF;Aa7rMI;E6CLE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DqsMN;AACF;AavsMI;E6CIE;IAEE,eAAA;E1DqsMN;AACF;Aa5sMI;E6CSE;IAGE,mBAAA;E1DosMN;AACF;Aa9tMI;E6ClCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DmsMN;E0DjsMM;IACE,aAAA;E1DmsMR;E0DhsMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DisMR;AACF;;A0DjxME;EAEI,eAAA;EACA,SAAA;EACA,arDq/B8B;EqDp/B9B,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;ErCzBA,sCqC2BA;A1DkxMN;AqBzyMM;EqCSJ;IrCRM,gBAAA;ErB4yMN;AACF;A0DrxMM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1DuxMR;A0DpxMM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1DsxMR;A0DnxMM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1DqxMR;A0DlxMM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1DoxMR;A0DjxMM;EAEE,eAAA;A1DkxMR;A0D/wMM;EAGE,mBAAA;A1D+wMR;;A0DpvMA;EPjHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9CghCkC;E8C/gClC,YAAA;EACA,aAAA;EACA,sB9CUS;AL+1MX;AmDt2ME;EAAS,UAAA;AnDy2MX;AmDx2ME;EAAS,Y9Cq3CyB;ALs/JpC;;A0DhwMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A1DmwMF;A0DjwME;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A1DmwMJ;;A0D/vMA;EACE,gBAAA;EACA,gBrD6a4B;ALq1L9B;;A0D/vMA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1DkwMF;;A2D/4MA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YtDssCkC;AL4sKpC;A2Dh5ME;EACE,qBAAA;EACA,WAAA;A3Dk5MJ;;A2D74MA;EACE,iBAAA;A3Dg5MF;;A2D74MA;EACE,iBAAA;A3Dg5MF;;A2D74MA;EACE,iBAAA;A3Dg5MF;;A2D34ME;EACE,mDAAA;A3D84MJ;;A2D14MA;EACE;IACE,YtDyqCgC;ELouKlC;AACF;A2D14MA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A3D44MF;;A2Dz4MA;EACE;IACE,+BAAA;YAAA,uBAAA;E3D44MF;AACF;AwD37ME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD67MJ;;A4D77ME;EACE,sBAAA;EACA,wEAAA;A5Dg8MJ;;A4Dl8ME;EACE,sBAAA;EACA,yEAAA;A5Dq8MJ;;A4Dv8ME;EACE,sBAAA;EACA,uEAAA;A5D08MJ;;A4D58ME;EACE,sBAAA;EACA,wEAAA;A5D+8MJ;;A4Dj9ME;EACE,sBAAA;EACA,uEAAA;A5Do9MJ;;A4Dt9ME;EACE,sBAAA;EACA,uEAAA;A5Dy9MJ;;A4D39ME;EACE,sBAAA;EACA,yEAAA;A5D89MJ;;A4Dh+ME;EACE,sBAAA;EACA,sEAAA;A5Dm+MJ;;A6Dz+ME;EACE,yBAAA;A7D4+MJ;A6Dz+MM;EAEE,yBAAA;A7D0+MR;;A6Dh/ME;EACE,yBAAA;A7Dm/MJ;A6Dh/MM;EAEE,yBAAA;A7Di/MR;;A6Dv/ME;EACE,yBAAA;A7D0/MJ;A6Dv/MM;EAEE,yBAAA;A7Dw/MR;;A6D9/ME;EACE,yBAAA;A7DigNJ;A6D9/MM;EAEE,yBAAA;A7D+/MR;;A6DrgNE;EACE,yBAAA;A7DwgNJ;A6DrgNM;EAEE,yBAAA;A7DsgNR;;A6D5gNE;EACE,yBAAA;A7D+gNJ;A6D5gNM;EAEE,yBAAA;A7D6gNR;;A6DnhNE;EACE,yBAAA;A7DshNJ;A6DnhNM;EAEE,yBAAA;A7DohNR;;A6D1hNE;EACE,yBAAA;A7D6hNJ;A6D1hNM;EAEE,yBAAA;A7D2hNR;;A8DhiNA;EACE,kBAAA;EACA,WAAA;A9DmiNF;A8DjiNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A9DmiNJ;A8DhiNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A9DkiNJ;;A8D7hNE;EACE,uBAAA;A9DgiNJ;;A8DjiNE;EACE,sBAAA;A9DoiNJ;;A8DriNE;EACE,yBAAA;A9DwiNJ;;A8DziNE;EACE,iCAAA;A9D4iNJ;;A+DjkNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1D6gCkC;ALujLpC;;A+DjkNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1DqgCkC;AL+jLpC;;A+D5jNI;EACE,gBAAA;EACA,MAAA;EACA,a1Dy/B8B;ALskLpC;;A+D5jNI;EACE,gBAAA;EACA,SAAA;EACA,a1Dm/B8B;AL4kLpC;;AahiNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dy/B8B;ELmlLlC;E+DzkNE;IACE,gBAAA;IACA,SAAA;IACA,a1Dm/B8B;ELwlLlC;AACF;Aa7iNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dy/B8B;EL+lLlC;E+DrlNE;IACE,gBAAA;IACA,SAAA;IACA,a1Dm/B8B;ELomLlC;AACF;AazjNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dy/B8B;EL2mLlC;E+DjmNE;IACE,gBAAA;IACA,SAAA;IACA,a1Dm/B8B;ELgnLlC;AACF;AarkNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dy/B8B;ELunLlC;E+D7mNE;IACE,gBAAA;IACA,SAAA;IACA,a1Dm/B8B;EL4nLlC;AACF;AajlNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1Dy/B8B;ELmoLlC;E+DznNE;IACE,gBAAA;IACA,SAAA;IACA,a1Dm/B8B;ELwoLlC;AACF;AgE3pNA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AhE6pNF;;AgE1pNA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AhE6pNF;;AiErqNA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AlEsqNF;;AmEjrNE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DoZsC;E8DnZtC,WAAA;AnEorNJ;;AoE5rNA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ArEgsNF;;AsEtsNA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,ajEynB4B;ALglM9B;;AuE7oNQ;EAOI,mCAAA;AvE0oNZ;;AuEjpNQ;EAOI,8BAAA;AvE8oNZ;;AuErpNQ;EAOI,iCAAA;AvEkpNZ;;AuEzpNQ;EAOI,iCAAA;AvEspNZ;;AuE7pNQ;EAOI,sCAAA;AvE0pNZ;;AuEjqNQ;EAOI,mCAAA;AvE8pNZ;;AuErqNQ;EAOI,sBAAA;AvEkqNZ;;AuEzqNQ;EAOI,uBAAA;AvEsqNZ;;AuE7qNQ;EAOI,sBAAA;AvE0qNZ;;AuEjrNQ;EAOI,qBAAA;AvE8qNZ;;AuErrNQ;EAOI,wBAAA;AvEkrNZ;;AuEzrNQ;EAOI,uBAAA;AvEsrNZ;;AuE7rNQ;EAOI,wBAAA;AvE0rNZ;;AuEjsNQ;EAOI,qBAAA;AvE8rNZ;;AuErsNQ;EAOI,yBAAA;AvEksNZ;;AuEzsNQ;EAOI,2BAAA;AvEssNZ;;AuE7sNQ;EAOI,4BAAA;AvE0sNZ;;AuEjtNQ;EAOI,2BAAA;AvE8sNZ;;AuErtNQ;EAOI,0BAAA;AvEktNZ;;AuEztNQ;EAOI,gCAAA;AvEstNZ;;AuE7tNQ;EAOI,yBAAA;AvE0tNZ;;AuEjuNQ;EAOI,wBAAA;AvE8tNZ;;AuEruNQ;EAOI,yBAAA;AvEkuNZ;;AuEzuNQ;EAOI,6BAAA;AvEsuNZ;;AuE7uNQ;EAOI,8BAAA;AvE0uNZ;;AuEjvNQ;EAOI,wBAAA;AvE8uNZ;;AuErvNQ;EAOI,+BAAA;AvEkvNZ;;AuEzvNQ;EAOI,wBAAA;AvEsvNZ;;AuE7vNQ;EAOI,wDAAA;AvE0vNZ;;AuEjwNQ;EAOI,8DAAA;AvE8vNZ;;AuErwNQ;EAOI,uDAAA;AvEkwNZ;;AuEzwNQ;EAOI,2BAAA;AvEswNZ;;AuE7wNQ;EAOI,2BAAA;AvE0wNZ;;AuEjxNQ;EAOI,6BAAA;AvE8wNZ;;AuErxNQ;EAOI,6BAAA;AvEkxNZ;;AuEzxNQ;EAOI,0BAAA;AvEsxNZ;;AuE7xNQ;EAOI,2BAAA;AvE0xNZ;;AuEjyNQ;EAOI,iBAAA;AvE8xNZ;;AuEryNQ;EAOI,mBAAA;AvEkyNZ;;AuEzyNQ;EAOI,oBAAA;AvEsyNZ;;AuE7yNQ;EAOI,oBAAA;AvE0yNZ;;AuEjzNQ;EAOI,sBAAA;AvE8yNZ;;AuErzNQ;EAOI,uBAAA;AvEkzNZ;;AuEzzNQ;EAOI,kBAAA;AvEszNZ;;AuE7zNQ;EAOI,oBAAA;AvE0zNZ;;AuEj0NQ;EAOI,qBAAA;AvE8zNZ;;AuEr0NQ;EAOI,mBAAA;AvEk0NZ;;AuEz0NQ;EAOI,qBAAA;AvEs0NZ;;AuE70NQ;EAOI,sBAAA;AvE00NZ;;AuEj1NQ;EAOI,2CAAA;AvE80NZ;;AuEr1NQ;EAOI,sCAAA;AvEk1NZ;;AuEz1NQ;EAOI,sCAAA;AvEs1NZ;;AuE71NQ;EAOI,uFAAA;AvE01NZ;;AuEj2NQ;EAOI,oBAAA;AvE81NZ;;AuEr2NQ;EAOI,2FAAA;AvEk2NZ;;AuEz2NQ;EAOI,wBAAA;AvEs2NZ;;AuE72NQ;EAOI,6FAAA;AvE02NZ;;AuEj3NQ;EAOI,0BAAA;AvE82NZ;;AuEr3NQ;EAOI,8FAAA;AvEk3NZ;;AuEz3NQ;EAOI,2BAAA;AvEs3NZ;;AuE73NQ;EAOI,4FAAA;AvE03NZ;;AuEj4NQ;EAOI,yBAAA;AvE83NZ;;AuEr4NQ;EAIQ,sBAAA;EAGJ,8EAAA;AvEm4NZ;;AuE14NQ;EAIQ,sBAAA;EAGJ,gFAAA;AvEw4NZ;;AuE/4NQ;EAIQ,sBAAA;EAGJ,8EAAA;AvE64NZ;;AuEp5NQ;EAIQ,sBAAA;EAGJ,2EAAA;AvEk5NZ;;AuEz5NQ;EAIQ,sBAAA;EAGJ,8EAAA;AvEu5NZ;;AuE95NQ;EAIQ,sBAAA;EAGJ,6EAAA;AvE45NZ;;AuEn6NQ;EAIQ,sBAAA;EAGJ,4EAAA;AvEi6NZ;;AuEx6NQ;EAIQ,sBAAA;EAGJ,2EAAA;AvEs6NZ;;AuE76NQ;EAIQ,sBAAA;EAGJ,4EAAA;AvE26NZ;;AuE57NQ;EACE,sBAAA;AvE+7NV;;AuEh8NQ;EACE,sBAAA;AvEm8NV;;AuEp8NQ;EACE,sBAAA;AvEu8NV;;AuEx8NQ;EACE,sBAAA;AvE28NV;;AuE58NQ;EACE,sBAAA;AvE+8NV;;AuEh9NQ;EACE,wBAAA;AvEm9NV;;AuEp9NQ;EACE,yBAAA;AvEu9NV;;AuEx9NQ;EACE,wBAAA;AvE29NV;;AuE59NQ;EACE,yBAAA;AvE+9NV;;AuEh+NQ;EACE,sBAAA;AvEm+NV;;AuE19NQ;EAOI,qBAAA;AvEu9NZ;;AuE99NQ;EAOI,qBAAA;AvE29NZ;;AuEl+NQ;EAOI,qBAAA;AvE+9NZ;;AuEt+NQ;EAOI,sBAAA;AvEm+NZ;;AuE1+NQ;EAOI,sBAAA;AvEu+NZ;;AuE9+NQ;EAOI,0BAAA;AvE2+NZ;;AuEl/NQ;EAOI,uBAAA;AvE++NZ;;AuEt/NQ;EAOI,2BAAA;AvEm/NZ;;AuE1/NQ;EAOI,sBAAA;AvEu/NZ;;AuE9/NQ;EAOI,sBAAA;AvE2/NZ;;AuElgOQ;EAOI,sBAAA;AvE+/NZ;;AuEtgOQ;EAOI,uBAAA;AvEmgOZ;;AuE1gOQ;EAOI,uBAAA;AvEugOZ;;AuE9gOQ;EAOI,2BAAA;AvE2gOZ;;AuElhOQ;EAOI,wBAAA;AvE+gOZ;;AuEthOQ;EAOI,4BAAA;AvEmhOZ;;AuE1hOQ;EAOI,yBAAA;AvEuhOZ;;AuE9hOQ;EAOI,8BAAA;AvE2hOZ;;AuEliOQ;EAOI,iCAAA;AvE+hOZ;;AuEtiOQ;EAOI,sCAAA;AvEmiOZ;;AuE1iOQ;EAOI,yCAAA;AvEuiOZ;;AuE9iOQ;EAOI,uBAAA;AvE2iOZ;;AuEljOQ;EAOI,uBAAA;AvE+iOZ;;AuEtjOQ;EAOI,yBAAA;AvEmjOZ;;AuE1jOQ;EAOI,yBAAA;AvEujOZ;;AuE9jOQ;EAOI,0BAAA;AvE2jOZ;;AuElkOQ;EAOI,4BAAA;AvE+jOZ;;AuEtkOQ;EAOI,kCAAA;AvEmkOZ;;AuE1kOQ;EAOI,sCAAA;AvEukOZ;;AuE9kOQ;EAOI,oCAAA;AvE2kOZ;;AuEllOQ;EAOI,kCAAA;AvE+kOZ;;AuEtlOQ;EAOI,yCAAA;AvEmlOZ;;AuE1lOQ;EAOI,wCAAA;AvEulOZ;;AuE9lOQ;EAOI,wCAAA;AvE2lOZ;;AuElmOQ;EAOI,kCAAA;AvE+lOZ;;AuEtmOQ;EAOI,gCAAA;AvEmmOZ;;AuE1mOQ;EAOI,8BAAA;AvEumOZ;;AuE9mOQ;EAOI,gCAAA;AvE2mOZ;;AuElnOQ;EAOI,+BAAA;AvE+mOZ;;AuEtnOQ;EAOI,oCAAA;AvEmnOZ;;AuE1nOQ;EAOI,kCAAA;AvEunOZ;;AuE9nOQ;EAOI,gCAAA;AvE2nOZ;;AuEloOQ;EAOI,uCAAA;AvE+nOZ;;AuEtoOQ;EAOI,sCAAA;AvEmoOZ;;AuE1oOQ;EAOI,iCAAA;AvEuoOZ;;AuE9oOQ;EAOI,2BAAA;AvE2oOZ;;AuElpOQ;EAOI,iCAAA;AvE+oOZ;;AuEtpOQ;EAOI,+BAAA;AvEmpOZ;;AuE1pOQ;EAOI,6BAAA;AvEupOZ;;AuE9pOQ;EAOI,+BAAA;AvE2pOZ;;AuElqOQ;EAOI,8BAAA;AvE+pOZ;;AuEtqOQ;EAOI,oBAAA;AvEmqOZ;;AuE1qOQ;EAOI,mBAAA;AvEuqOZ;;AuE9qOQ;EAOI,mBAAA;AvE2qOZ;;AuElrOQ;EAOI,mBAAA;AvE+qOZ;;AuEtrOQ;EAOI,mBAAA;AvEmrOZ;;AuE1rOQ;EAOI,mBAAA;AvEurOZ;;AuE9rOQ;EAOI,mBAAA;AvE2rOZ;;AuElsOQ;EAOI,mBAAA;AvE+rOZ;;AuEtsOQ;EAOI,oBAAA;AvEmsOZ;;AuE1sOQ;EAOI,0BAAA;AvEusOZ;;AuE9sOQ;EAOI,yBAAA;AvE2sOZ;;AuEltOQ;EAOI,uBAAA;AvE+sOZ;;AuEttOQ;EAOI,yBAAA;AvEmtOZ;;AuE1tOQ;EAOI,uBAAA;AvEutOZ;;AuE9tOQ;EAOI,uBAAA;AvE2tOZ;;AuEluOQ;EAOI,0BAAA;EAAA,yBAAA;AvEguOZ;;AuEvuOQ;EAOI,gCAAA;EAAA,+BAAA;AvEquOZ;;AuE5uOQ;EAOI,+BAAA;EAAA,8BAAA;AvE0uOZ;;AuEjvOQ;EAOI,6BAAA;EAAA,4BAAA;AvE+uOZ;;AuEtvOQ;EAOI,+BAAA;EAAA,8BAAA;AvEovOZ;;AuE3vOQ;EAOI,6BAAA;EAAA,4BAAA;AvEyvOZ;;AuEhwOQ;EAOI,6BAAA;EAAA,4BAAA;AvE8vOZ;;AuErwOQ;EAOI,wBAAA;EAAA,2BAAA;AvEmwOZ;;AuE1wOQ;EAOI,8BAAA;EAAA,iCAAA;AvEwwOZ;;AuE/wOQ;EAOI,6BAAA;EAAA,gCAAA;AvE6wOZ;;AuEpxOQ;EAOI,2BAAA;EAAA,8BAAA;AvEkxOZ;;AuEzxOQ;EAOI,6BAAA;EAAA,gCAAA;AvEuxOZ;;AuE9xOQ;EAOI,2BAAA;EAAA,8BAAA;AvE4xOZ;;AuEnyOQ;EAOI,2BAAA;EAAA,8BAAA;AvEiyOZ;;AuExyOQ;EAOI,wBAAA;AvEqyOZ;;AuE5yOQ;EAOI,8BAAA;AvEyyOZ;;AuEhzOQ;EAOI,6BAAA;AvE6yOZ;;AuEpzOQ;EAOI,2BAAA;AvEizOZ;;AuExzOQ;EAOI,6BAAA;AvEqzOZ;;AuE5zOQ;EAOI,2BAAA;AvEyzOZ;;AuEh0OQ;EAOI,2BAAA;AvE6zOZ;;AuEp0OQ;EAOI,0BAAA;AvEi0OZ;;AuEx0OQ;EAOI,gCAAA;AvEq0OZ;;AuE50OQ;EAOI,+BAAA;AvEy0OZ;;AuEh1OQ;EAOI,6BAAA;AvE60OZ;;AuEp1OQ;EAOI,+BAAA;AvEi1OZ;;AuEx1OQ;EAOI,6BAAA;AvEq1OZ;;AuE51OQ;EAOI,6BAAA;AvEy1OZ;;AuEh2OQ;EAOI,2BAAA;AvE61OZ;;AuEp2OQ;EAOI,iCAAA;AvEi2OZ;;AuEx2OQ;EAOI,gCAAA;AvEq2OZ;;AuE52OQ;EAOI,8BAAA;AvEy2OZ;;AuEh3OQ;EAOI,gCAAA;AvE62OZ;;AuEp3OQ;EAOI,8BAAA;AvEi3OZ;;AuEx3OQ;EAOI,8BAAA;AvEq3OZ;;AuE53OQ;EAOI,yBAAA;AvEy3OZ;;AuEh4OQ;EAOI,+BAAA;AvE63OZ;;AuEp4OQ;EAOI,8BAAA;AvEi4OZ;;AuEx4OQ;EAOI,4BAAA;AvEq4OZ;;AuE54OQ;EAOI,8BAAA;AvEy4OZ;;AuEh5OQ;EAOI,4BAAA;AvE64OZ;;AuEp5OQ;EAOI,4BAAA;AvEi5OZ;;AuEx5OQ;EAOI,qBAAA;AvEq5OZ;;AuE55OQ;EAOI,2BAAA;AvEy5OZ;;AuEh6OQ;EAOI,0BAAA;AvE65OZ;;AuEp6OQ;EAOI,wBAAA;AvEi6OZ;;AuEx6OQ;EAOI,0BAAA;AvEq6OZ;;AuE56OQ;EAOI,wBAAA;AvEy6OZ;;AuEh7OQ;EAOI,2BAAA;EAAA,0BAAA;AvE86OZ;;AuEr7OQ;EAOI,iCAAA;EAAA,gCAAA;AvEm7OZ;;AuE17OQ;EAOI,gCAAA;EAAA,+BAAA;AvEw7OZ;;AuE/7OQ;EAOI,8BAAA;EAAA,6BAAA;AvE67OZ;;AuEp8OQ;EAOI,gCAAA;EAAA,+BAAA;AvEk8OZ;;AuEz8OQ;EAOI,8BAAA;EAAA,6BAAA;AvEu8OZ;;AuE98OQ;EAOI,yBAAA;EAAA,4BAAA;AvE48OZ;;AuEn9OQ;EAOI,+BAAA;EAAA,kCAAA;AvEi9OZ;;AuEx9OQ;EAOI,8BAAA;EAAA,iCAAA;AvEs9OZ;;AuE79OQ;EAOI,4BAAA;EAAA,+BAAA;AvE29OZ;;AuEl+OQ;EAOI,8BAAA;EAAA,iCAAA;AvEg+OZ;;AuEv+OQ;EAOI,4BAAA;EAAA,+BAAA;AvEq+OZ;;AuE5+OQ;EAOI,yBAAA;AvEy+OZ;;AuEh/OQ;EAOI,+BAAA;AvE6+OZ;;AuEp/OQ;EAOI,8BAAA;AvEi/OZ;;AuEx/OQ;EAOI,4BAAA;AvEq/OZ;;AuE5/OQ;EAOI,8BAAA;AvEy/OZ;;AuEhgPQ;EAOI,4BAAA;AvE6/OZ;;AuEpgPQ;EAOI,2BAAA;AvEigPZ;;AuExgPQ;EAOI,iCAAA;AvEqgPZ;;AuE5gPQ;EAOI,gCAAA;AvEygPZ;;AuEhhPQ;EAOI,8BAAA;AvE6gPZ;;AuEphPQ;EAOI,gCAAA;AvEihPZ;;AuExhPQ;EAOI,8BAAA;AvEqhPZ;;AuE5hPQ;EAOI,4BAAA;AvEyhPZ;;AuEhiPQ;EAOI,kCAAA;AvE6hPZ;;AuEpiPQ;EAOI,iCAAA;AvEiiPZ;;AuExiPQ;EAOI,+BAAA;AvEqiPZ;;AuE5iPQ;EAOI,iCAAA;AvEyiPZ;;AuEhjPQ;EAOI,+BAAA;AvE6iPZ;;AuEpjPQ;EAOI,0BAAA;AvEijPZ;;AuExjPQ;EAOI,gCAAA;AvEqjPZ;;AuE5jPQ;EAOI,+BAAA;AvEyjPZ;;AuEhkPQ;EAOI,6BAAA;AvE6jPZ;;AuEpkPQ;EAOI,+BAAA;AvEikPZ;;AuExkPQ;EAOI,6BAAA;AvEqkPZ;;AuE5kPQ;EAOI,iBAAA;AvEykPZ;;AuEhlPQ;EAOI,uBAAA;AvE6kPZ;;AuEplPQ;EAOI,sBAAA;AvEilPZ;;AuExlPQ;EAOI,oBAAA;AvEqlPZ;;AuE5lPQ;EAOI,sBAAA;AvEylPZ;;AuEhmPQ;EAOI,oBAAA;AvE6lPZ;;AuEpmPQ;EAOI,gDAAA;AvEimPZ;;AuExmPQ;EAOI,4CAAA;AvEqmPZ;;AuE5mPQ;EAOI,4CAAA;AvEymPZ;;AuEhnPQ;EAOI,0CAAA;AvE6mPZ;;AuEpnPQ;EAOI,4CAAA;AvEinPZ;;AuExnPQ;EAOI,6BAAA;AvEqnPZ;;AuE5nPQ;EAOI,0BAAA;AvEynPZ;;AuEhoPQ;EAOI,6BAAA;AvE6nPZ;;AuEpoPQ;EAOI,6BAAA;AvEioPZ;;AuExoPQ;EAOI,2BAAA;AvEqoPZ;;AuE5oPQ;EAOI,+BAAA;AvEyoPZ;;AuEhpPQ;EAOI,2BAAA;AvE6oPZ;;AuEppPQ;EAOI,2BAAA;AvEipPZ;;AuExpPQ;EAOI,2BAAA;AvEqpPZ;;AuE5pPQ;EAOI,8BAAA;AvEypPZ;;AuEhqPQ;EAOI,yBAAA;AvE6pPZ;;AuEpqPQ;EAOI,4BAAA;AvEiqPZ;;AuExqPQ;EAOI,2BAAA;AvEqqPZ;;AuE5qPQ;EAOI,yBAAA;AvEyqPZ;;AuEhrPQ;EAOI,2BAAA;AvE6qPZ;;AuEprPQ;EAOI,4BAAA;AvEirPZ;;AuExrPQ;EAOI,6BAAA;AvEqrPZ;;AuE5rPQ;EAOI,gCAAA;AvEyrPZ;;AuEhsPQ;EAOI,qCAAA;AvE6rPZ;;AuEpsPQ;EAOI,wCAAA;AvEisPZ;;AuExsPQ;EAOI,oCAAA;AvEqsPZ;;AuE5sPQ;EAOI,oCAAA;AvEysPZ;;AuEhtPQ;EAOI,qCAAA;AvE6sPZ;;AuEptPQ;EAOI,8BAAA;AvEitPZ;;AuExtPQ;EAOI,8BAAA;AvEqtPZ;;AuE1uPQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AvE2tPZ;;AuExsPQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AvEiuPZ;;AuExuPQ;EAIQ,oBAAA;EAGJ,uEAAA;AvEsuPZ;;AuE7uPQ;EAIQ,oBAAA;EAGJ,qEAAA;AvE2uPZ;;AuElvPQ;EAIQ,oBAAA;EAGJ,kEAAA;AvEgvPZ;;AuEvvPQ;EAIQ,oBAAA;EAGJ,qEAAA;AvEqvPZ;;AuE5vPQ;EAIQ,oBAAA;EAGJ,oEAAA;AvE0vPZ;;AuEjwPQ;EAIQ,oBAAA;EAGJ,mEAAA;AvE+vPZ;;AuEtwPQ;EAIQ,oBAAA;EAGJ,kEAAA;AvEowPZ;;AuE3wPQ;EAIQ,oBAAA;EAGJ,mEAAA;AvEywPZ;;AuEhxPQ;EAIQ,oBAAA;EAGJ,mEAAA;AvE8wPZ;;AuErxPQ;EAIQ,oBAAA;EAGJ,wEAAA;AvEmxPZ;;AuE1xPQ;EAIQ,oBAAA;EAGJ,yBAAA;AvEwxPZ;;AuE/xPQ;EAIQ,oBAAA;EAGJ,oCAAA;AvE6xPZ;;AuEpyPQ;EAIQ,oBAAA;EAGJ,0CAAA;AvEkyPZ;;AuEzyPQ;EAIQ,oBAAA;EAGJ,yBAAA;AvEuyPZ;;AuExzPQ;EACE,uBAAA;AvE2zPV;;AuE5zPQ;EACE,sBAAA;AvE+zPV;;AuEh0PQ;EACE,uBAAA;AvEm0PV;;AuEp0PQ;EACE,oBAAA;AvEu0PV;;AuE9zPQ;EAIQ,kBAAA;EAGJ,8EAAA;AvE4zPZ;;AuEn0PQ;EAIQ,kBAAA;EAGJ,gFAAA;AvEi0PZ;;AuEx0PQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEs0PZ;;AuE70PQ;EAIQ,kBAAA;EAGJ,2EAAA;AvE20PZ;;AuEl1PQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEg1PZ;;AuEv1PQ;EAIQ,kBAAA;EAGJ,6EAAA;AvEq1PZ;;AuE51PQ;EAIQ,kBAAA;EAGJ,4EAAA;AvE01PZ;;AuEj2PQ;EAIQ,kBAAA;EAGJ,2EAAA;AvE+1PZ;;AuEt2PQ;EAIQ,kBAAA;EAGJ,4EAAA;AvEo2PZ;;AuE32PQ;EAIQ,kBAAA;EAGJ,4EAAA;AvEy2PZ;;AuEh3PQ;EAIQ,kBAAA;EAGJ,8EAAA;AvE82PZ;;AuEr3PQ;EAIQ,kBAAA;EAGJ,wCAAA;AvEm3PZ;;AuEp4PQ;EACE,oBAAA;AvEu4PV;;AuEx4PQ;EACE,qBAAA;AvE24PV;;AuE54PQ;EACE,oBAAA;AvE+4PV;;AuEh5PQ;EACE,qBAAA;AvEm5PV;;AuEp5PQ;EACE,kBAAA;AvEu5PV;;AuE94PQ;EAOI,+CAAA;AvE24PZ;;AuEl5PQ;EAOI,mCAAA;KAAA,gCAAA;UAAA,2BAAA;AvE+4PZ;;AuEt5PQ;EAOI,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AvEm5PZ;;AuE15PQ;EAOI,oCAAA;KAAA,iCAAA;UAAA,4BAAA;AvEu5PZ;;AuE95PQ;EAOI,+BAAA;AvE25PZ;;AuEl6PQ;EAOI,+BAAA;AvE+5PZ;;AuEt6PQ;EAOI,iDAAA;AvEm6PZ;;AuE16PQ;EAOI,2BAAA;AvEu6PZ;;AuE96PQ;EAOI,oDAAA;AvE26PZ;;AuEl7PQ;EAOI,iDAAA;AvE+6PZ;;AuEt7PQ;EAOI,oDAAA;AvEm7PZ;;AuE17PQ;EAOI,oDAAA;AvEu7PZ;;AuE97PQ;EAOI,qDAAA;AvE27PZ;;AuEl8PQ;EAOI,6BAAA;AvE+7PZ;;AuEt8PQ;EAOI,sDAAA;AvEm8PZ;;AuE18PQ;EAOI,0DAAA;EAAA,2DAAA;AvEw8PZ;;AuE/8PQ;EAOI,2DAAA;EAAA,8DAAA;AvE68PZ;;AuEp9PQ;EAOI,8DAAA;EAAA,6DAAA;AvEk9PZ;;AuEz9PQ;EAOI,6DAAA;EAAA,0DAAA;AvEu9PZ;;AuE99PQ;EAOI,8BAAA;AvE29PZ;;AuEl+PQ;EAOI,6BAAA;AvE+9PZ;;Aaz+PI;E0DGI;IAOI,sBAAA;EvEo+PV;EuE3+PM;IAOI,uBAAA;EvEu+PV;EuE9+PM;IAOI,sBAAA;EvE0+PV;EuEj/PM;IAOI,0BAAA;EvE6+PV;EuEp/PM;IAOI,gCAAA;EvEg/PV;EuEv/PM;IAOI,yBAAA;EvEm/PV;EuE1/PM;IAOI,wBAAA;EvEs/PV;EuE7/PM;IAOI,yBAAA;EvEy/PV;EuEhgQM;IAOI,6BAAA;EvE4/PV;EuEngQM;IAOI,8BAAA;EvE+/PV;EuEtgQM;IAOI,wBAAA;EvEkgQV;EuEzgQM;IAOI,+BAAA;EvEqgQV;EuE5gQM;IAOI,wBAAA;EvEwgQV;EuE/gQM;IAOI,yBAAA;EvE2gQV;EuElhQM;IAOI,8BAAA;EvE8gQV;EuErhQM;IAOI,iCAAA;EvEihQV;EuExhQM;IAOI,sCAAA;EvEohQV;EuE3hQM;IAOI,yCAAA;EvEuhQV;EuE9hQM;IAOI,uBAAA;EvE0hQV;EuEjiQM;IAOI,uBAAA;EvE6hQV;EuEpiQM;IAOI,yBAAA;EvEgiQV;EuEviQM;IAOI,yBAAA;EvEmiQV;EuE1iQM;IAOI,0BAAA;EvEsiQV;EuE7iQM;IAOI,4BAAA;EvEyiQV;EuEhjQM;IAOI,kCAAA;EvE4iQV;EuEnjQM;IAOI,sCAAA;EvE+iQV;EuEtjQM;IAOI,oCAAA;EvEkjQV;EuEzjQM;IAOI,kCAAA;EvEqjQV;EuE5jQM;IAOI,yCAAA;EvEwjQV;EuE/jQM;IAOI,wCAAA;EvE2jQV;EuElkQM;IAOI,wCAAA;EvE8jQV;EuErkQM;IAOI,kCAAA;EvEikQV;EuExkQM;IAOI,gCAAA;EvEokQV;EuE3kQM;IAOI,8BAAA;EvEukQV;EuE9kQM;IAOI,gCAAA;EvE0kQV;EuEjlQM;IAOI,+BAAA;EvE6kQV;EuEplQM;IAOI,oCAAA;EvEglQV;EuEvlQM;IAOI,kCAAA;EvEmlQV;EuE1lQM;IAOI,gCAAA;EvEslQV;EuE7lQM;IAOI,uCAAA;EvEylQV;EuEhmQM;IAOI,sCAAA;EvE4lQV;EuEnmQM;IAOI,iCAAA;EvE+lQV;EuEtmQM;IAOI,2BAAA;EvEkmQV;EuEzmQM;IAOI,iCAAA;EvEqmQV;EuE5mQM;IAOI,+BAAA;EvEwmQV;EuE/mQM;IAOI,6BAAA;EvE2mQV;EuElnQM;IAOI,+BAAA;EvE8mQV;EuErnQM;IAOI,8BAAA;EvEinQV;EuExnQM;IAOI,oBAAA;EvEonQV;EuE3nQM;IAOI,mBAAA;EvEunQV;EuE9nQM;IAOI,mBAAA;EvE0nQV;EuEjoQM;IAOI,mBAAA;EvE6nQV;EuEpoQM;IAOI,mBAAA;EvEgoQV;EuEvoQM;IAOI,mBAAA;EvEmoQV;EuE1oQM;IAOI,mBAAA;EvEsoQV;EuE7oQM;IAOI,mBAAA;EvEyoQV;EuEhpQM;IAOI,oBAAA;EvE4oQV;EuEnpQM;IAOI,0BAAA;EvE+oQV;EuEtpQM;IAOI,yBAAA;EvEkpQV;EuEzpQM;IAOI,uBAAA;EvEqpQV;EuE5pQM;IAOI,yBAAA;EvEwpQV;EuE/pQM;IAOI,uBAAA;EvE2pQV;EuElqQM;IAOI,uBAAA;EvE8pQV;EuErqQM;IAOI,0BAAA;IAAA,yBAAA;EvEkqQV;EuEzqQM;IAOI,gCAAA;IAAA,+BAAA;EvEsqQV;EuE7qQM;IAOI,+BAAA;IAAA,8BAAA;EvE0qQV;EuEjrQM;IAOI,6BAAA;IAAA,4BAAA;EvE8qQV;EuErrQM;IAOI,+BAAA;IAAA,8BAAA;EvEkrQV;EuEzrQM;IAOI,6BAAA;IAAA,4BAAA;EvEsrQV;EuE7rQM;IAOI,6BAAA;IAAA,4BAAA;EvE0rQV;EuEjsQM;IAOI,wBAAA;IAAA,2BAAA;EvE8rQV;EuErsQM;IAOI,8BAAA;IAAA,iCAAA;EvEksQV;EuEzsQM;IAOI,6BAAA;IAAA,gCAAA;EvEssQV;EuE7sQM;IAOI,2BAAA;IAAA,8BAAA;EvE0sQV;EuEjtQM;IAOI,6BAAA;IAAA,gCAAA;EvE8sQV;EuErtQM;IAOI,2BAAA;IAAA,8BAAA;EvEktQV;EuEztQM;IAOI,2BAAA;IAAA,8BAAA;EvEstQV;EuE7tQM;IAOI,wBAAA;EvEytQV;EuEhuQM;IAOI,8BAAA;EvE4tQV;EuEnuQM;IAOI,6BAAA;EvE+tQV;EuEtuQM;IAOI,2BAAA;EvEkuQV;EuEzuQM;IAOI,6BAAA;EvEquQV;EuE5uQM;IAOI,2BAAA;EvEwuQV;EuE/uQM;IAOI,2BAAA;EvE2uQV;EuElvQM;IAOI,0BAAA;EvE8uQV;EuErvQM;IAOI,gCAAA;EvEivQV;EuExvQM;IAOI,+BAAA;EvEovQV;EuE3vQM;IAOI,6BAAA;EvEuvQV;EuE9vQM;IAOI,+BAAA;EvE0vQV;EuEjwQM;IAOI,6BAAA;EvE6vQV;EuEpwQM;IAOI,6BAAA;EvEgwQV;EuEvwQM;IAOI,2BAAA;EvEmwQV;EuE1wQM;IAOI,iCAAA;EvEswQV;EuE7wQM;IAOI,gCAAA;EvEywQV;EuEhxQM;IAOI,8BAAA;EvE4wQV;EuEnxQM;IAOI,gCAAA;EvE+wQV;EuEtxQM;IAOI,8BAAA;EvEkxQV;EuEzxQM;IAOI,8BAAA;EvEqxQV;EuE5xQM;IAOI,yBAAA;EvEwxQV;EuE/xQM;IAOI,+BAAA;EvE2xQV;EuElyQM;IAOI,8BAAA;EvE8xQV;EuEryQM;IAOI,4BAAA;EvEiyQV;EuExyQM;IAOI,8BAAA;EvEoyQV;EuE3yQM;IAOI,4BAAA;EvEuyQV;EuE9yQM;IAOI,4BAAA;EvE0yQV;EuEjzQM;IAOI,qBAAA;EvE6yQV;EuEpzQM;IAOI,2BAAA;EvEgzQV;EuEvzQM;IAOI,0BAAA;EvEmzQV;EuE1zQM;IAOI,wBAAA;EvEszQV;EuE7zQM;IAOI,0BAAA;EvEyzQV;EuEh0QM;IAOI,wBAAA;EvE4zQV;EuEn0QM;IAOI,2BAAA;IAAA,0BAAA;EvEg0QV;EuEv0QM;IAOI,iCAAA;IAAA,gCAAA;EvEo0QV;EuE30QM;IAOI,gCAAA;IAAA,+BAAA;EvEw0QV;EuE/0QM;IAOI,8BAAA;IAAA,6BAAA;EvE40QV;EuEn1QM;IAOI,gCAAA;IAAA,+BAAA;EvEg1QV;EuEv1QM;IAOI,8BAAA;IAAA,6BAAA;EvEo1QV;EuE31QM;IAOI,yBAAA;IAAA,4BAAA;EvEw1QV;EuE/1QM;IAOI,+BAAA;IAAA,kCAAA;EvE41QV;EuEn2QM;IAOI,8BAAA;IAAA,iCAAA;EvEg2QV;EuEv2QM;IAOI,4BAAA;IAAA,+BAAA;EvEo2QV;EuE32QM;IAOI,8BAAA;IAAA,iCAAA;EvEw2QV;EuE/2QM;IAOI,4BAAA;IAAA,+BAAA;EvE42QV;EuEn3QM;IAOI,yBAAA;EvE+2QV;EuEt3QM;IAOI,+BAAA;EvEk3QV;EuEz3QM;IAOI,8BAAA;EvEq3QV;EuE53QM;IAOI,4BAAA;EvEw3QV;EuE/3QM;IAOI,8BAAA;EvE23QV;EuEl4QM;IAOI,4BAAA;EvE83QV;EuEr4QM;IAOI,2BAAA;EvEi4QV;EuEx4QM;IAOI,iCAAA;EvEo4QV;EuE34QM;IAOI,gCAAA;EvEu4QV;EuE94QM;IAOI,8BAAA;EvE04QV;EuEj5QM;IAOI,gCAAA;EvE64QV;EuEp5QM;IAOI,8BAAA;EvEg5QV;EuEv5QM;IAOI,4BAAA;EvEm5QV;EuE15QM;IAOI,kCAAA;EvEs5QV;EuE75QM;IAOI,iCAAA;EvEy5QV;EuEh6QM;IAOI,+BAAA;EvE45QV;EuEn6QM;IAOI,iCAAA;EvE+5QV;EuEt6QM;IAOI,+BAAA;EvEk6QV;EuEz6QM;IAOI,0BAAA;EvEq6QV;EuE56QM;IAOI,gCAAA;EvEw6QV;EuE/6QM;IAOI,+BAAA;EvE26QV;EuEl7QM;IAOI,6BAAA;EvE86QV;EuEr7QM;IAOI,+BAAA;EvEi7QV;EuEx7QM;IAOI,6BAAA;EvEo7QV;EuE37QM;IAOI,iBAAA;EvEu7QV;EuE97QM;IAOI,uBAAA;EvE07QV;EuEj8QM;IAOI,sBAAA;EvE67QV;EuEp8QM;IAOI,oBAAA;EvEg8QV;EuEv8QM;IAOI,sBAAA;EvEm8QV;EuE18QM;IAOI,oBAAA;EvEs8QV;EuE78QM;IAOI,2BAAA;EvEy8QV;EuEh9QM;IAOI,4BAAA;EvE48QV;EuEn9QM;IAOI,6BAAA;EvE+8QV;AACF;Aa19QI;E0DGI;IAOI,sBAAA;EvEo9QV;EuE39QM;IAOI,uBAAA;EvEu9QV;EuE99QM;IAOI,sBAAA;EvE09QV;EuEj+QM;IAOI,0BAAA;EvE69QV;EuEp+QM;IAOI,gCAAA;EvEg+QV;EuEv+QM;IAOI,yBAAA;EvEm+QV;EuE1+QM;IAOI,wBAAA;EvEs+QV;EuE7+QM;IAOI,yBAAA;EvEy+QV;EuEh/QM;IAOI,6BAAA;EvE4+QV;EuEn/QM;IAOI,8BAAA;EvE++QV;EuEt/QM;IAOI,wBAAA;EvEk/QV;EuEz/QM;IAOI,+BAAA;EvEq/QV;EuE5/QM;IAOI,wBAAA;EvEw/QV;EuE//QM;IAOI,yBAAA;EvE2/QV;EuElgRM;IAOI,8BAAA;EvE8/QV;EuErgRM;IAOI,iCAAA;EvEigRV;EuExgRM;IAOI,sCAAA;EvEogRV;EuE3gRM;IAOI,yCAAA;EvEugRV;EuE9gRM;IAOI,uBAAA;EvE0gRV;EuEjhRM;IAOI,uBAAA;EvE6gRV;EuEphRM;IAOI,yBAAA;EvEghRV;EuEvhRM;IAOI,yBAAA;EvEmhRV;EuE1hRM;IAOI,0BAAA;EvEshRV;EuE7hRM;IAOI,4BAAA;EvEyhRV;EuEhiRM;IAOI,kCAAA;EvE4hRV;EuEniRM;IAOI,sCAAA;EvE+hRV;EuEtiRM;IAOI,oCAAA;EvEkiRV;EuEziRM;IAOI,kCAAA;EvEqiRV;EuE5iRM;IAOI,yCAAA;EvEwiRV;EuE/iRM;IAOI,wCAAA;EvE2iRV;EuEljRM;IAOI,wCAAA;EvE8iRV;EuErjRM;IAOI,kCAAA;EvEijRV;EuExjRM;IAOI,gCAAA;EvEojRV;EuE3jRM;IAOI,8BAAA;EvEujRV;EuE9jRM;IAOI,gCAAA;EvE0jRV;EuEjkRM;IAOI,+BAAA;EvE6jRV;EuEpkRM;IAOI,oCAAA;EvEgkRV;EuEvkRM;IAOI,kCAAA;EvEmkRV;EuE1kRM;IAOI,gCAAA;EvEskRV;EuE7kRM;IAOI,uCAAA;EvEykRV;EuEhlRM;IAOI,sCAAA;EvE4kRV;EuEnlRM;IAOI,iCAAA;EvE+kRV;EuEtlRM;IAOI,2BAAA;EvEklRV;EuEzlRM;IAOI,iCAAA;EvEqlRV;EuE5lRM;IAOI,+BAAA;EvEwlRV;EuE/lRM;IAOI,6BAAA;EvE2lRV;EuElmRM;IAOI,+BAAA;EvE8lRV;EuErmRM;IAOI,8BAAA;EvEimRV;EuExmRM;IAOI,oBAAA;EvEomRV;EuE3mRM;IAOI,mBAAA;EvEumRV;EuE9mRM;IAOI,mBAAA;EvE0mRV;EuEjnRM;IAOI,mBAAA;EvE6mRV;EuEpnRM;IAOI,mBAAA;EvEgnRV;EuEvnRM;IAOI,mBAAA;EvEmnRV;EuE1nRM;IAOI,mBAAA;EvEsnRV;EuE7nRM;IAOI,mBAAA;EvEynRV;EuEhoRM;IAOI,oBAAA;EvE4nRV;EuEnoRM;IAOI,0BAAA;EvE+nRV;EuEtoRM;IAOI,yBAAA;EvEkoRV;EuEzoRM;IAOI,uBAAA;EvEqoRV;EuE5oRM;IAOI,yBAAA;EvEwoRV;EuE/oRM;IAOI,uBAAA;EvE2oRV;EuElpRM;IAOI,uBAAA;EvE8oRV;EuErpRM;IAOI,0BAAA;IAAA,yBAAA;EvEkpRV;EuEzpRM;IAOI,gCAAA;IAAA,+BAAA;EvEspRV;EuE7pRM;IAOI,+BAAA;IAAA,8BAAA;EvE0pRV;EuEjqRM;IAOI,6BAAA;IAAA,4BAAA;EvE8pRV;EuErqRM;IAOI,+BAAA;IAAA,8BAAA;EvEkqRV;EuEzqRM;IAOI,6BAAA;IAAA,4BAAA;EvEsqRV;EuE7qRM;IAOI,6BAAA;IAAA,4BAAA;EvE0qRV;EuEjrRM;IAOI,wBAAA;IAAA,2BAAA;EvE8qRV;EuErrRM;IAOI,8BAAA;IAAA,iCAAA;EvEkrRV;EuEzrRM;IAOI,6BAAA;IAAA,gCAAA;EvEsrRV;EuE7rRM;IAOI,2BAAA;IAAA,8BAAA;EvE0rRV;EuEjsRM;IAOI,6BAAA;IAAA,gCAAA;EvE8rRV;EuErsRM;IAOI,2BAAA;IAAA,8BAAA;EvEksRV;EuEzsRM;IAOI,2BAAA;IAAA,8BAAA;EvEssRV;EuE7sRM;IAOI,wBAAA;EvEysRV;EuEhtRM;IAOI,8BAAA;EvE4sRV;EuEntRM;IAOI,6BAAA;EvE+sRV;EuEttRM;IAOI,2BAAA;EvEktRV;EuEztRM;IAOI,6BAAA;EvEqtRV;EuE5tRM;IAOI,2BAAA;EvEwtRV;EuE/tRM;IAOI,2BAAA;EvE2tRV;EuEluRM;IAOI,0BAAA;EvE8tRV;EuEruRM;IAOI,gCAAA;EvEiuRV;EuExuRM;IAOI,+BAAA;EvEouRV;EuE3uRM;IAOI,6BAAA;EvEuuRV;EuE9uRM;IAOI,+BAAA;EvE0uRV;EuEjvRM;IAOI,6BAAA;EvE6uRV;EuEpvRM;IAOI,6BAAA;EvEgvRV;EuEvvRM;IAOI,2BAAA;EvEmvRV;EuE1vRM;IAOI,iCAAA;EvEsvRV;EuE7vRM;IAOI,gCAAA;EvEyvRV;EuEhwRM;IAOI,8BAAA;EvE4vRV;EuEnwRM;IAOI,gCAAA;EvE+vRV;EuEtwRM;IAOI,8BAAA;EvEkwRV;EuEzwRM;IAOI,8BAAA;EvEqwRV;EuE5wRM;IAOI,yBAAA;EvEwwRV;EuE/wRM;IAOI,+BAAA;EvE2wRV;EuElxRM;IAOI,8BAAA;EvE8wRV;EuErxRM;IAOI,4BAAA;EvEixRV;EuExxRM;IAOI,8BAAA;EvEoxRV;EuE3xRM;IAOI,4BAAA;EvEuxRV;EuE9xRM;IAOI,4BAAA;EvE0xRV;EuEjyRM;IAOI,qBAAA;EvE6xRV;EuEpyRM;IAOI,2BAAA;EvEgyRV;EuEvyRM;IAOI,0BAAA;EvEmyRV;EuE1yRM;IAOI,wBAAA;EvEsyRV;EuE7yRM;IAOI,0BAAA;EvEyyRV;EuEhzRM;IAOI,wBAAA;EvE4yRV;EuEnzRM;IAOI,2BAAA;IAAA,0BAAA;EvEgzRV;EuEvzRM;IAOI,iCAAA;IAAA,gCAAA;EvEozRV;EuE3zRM;IAOI,gCAAA;IAAA,+BAAA;EvEwzRV;EuE/zRM;IAOI,8BAAA;IAAA,6BAAA;EvE4zRV;EuEn0RM;IAOI,gCAAA;IAAA,+BAAA;EvEg0RV;EuEv0RM;IAOI,8BAAA;IAAA,6BAAA;EvEo0RV;EuE30RM;IAOI,yBAAA;IAAA,4BAAA;EvEw0RV;EuE/0RM;IAOI,+BAAA;IAAA,kCAAA;EvE40RV;EuEn1RM;IAOI,8BAAA;IAAA,iCAAA;EvEg1RV;EuEv1RM;IAOI,4BAAA;IAAA,+BAAA;EvEo1RV;EuE31RM;IAOI,8BAAA;IAAA,iCAAA;EvEw1RV;EuE/1RM;IAOI,4BAAA;IAAA,+BAAA;EvE41RV;EuEn2RM;IAOI,yBAAA;EvE+1RV;EuEt2RM;IAOI,+BAAA;EvEk2RV;EuEz2RM;IAOI,8BAAA;EvEq2RV;EuE52RM;IAOI,4BAAA;EvEw2RV;EuE/2RM;IAOI,8BAAA;EvE22RV;EuEl3RM;IAOI,4BAAA;EvE82RV;EuEr3RM;IAOI,2BAAA;EvEi3RV;EuEx3RM;IAOI,iCAAA;EvEo3RV;EuE33RM;IAOI,gCAAA;EvEu3RV;EuE93RM;IAOI,8BAAA;EvE03RV;EuEj4RM;IAOI,gCAAA;EvE63RV;EuEp4RM;IAOI,8BAAA;EvEg4RV;EuEv4RM;IAOI,4BAAA;EvEm4RV;EuE14RM;IAOI,kCAAA;EvEs4RV;EuE74RM;IAOI,iCAAA;EvEy4RV;EuEh5RM;IAOI,+BAAA;EvE44RV;EuEn5RM;IAOI,iCAAA;EvE+4RV;EuEt5RM;IAOI,+BAAA;EvEk5RV;EuEz5RM;IAOI,0BAAA;EvEq5RV;EuE55RM;IAOI,gCAAA;EvEw5RV;EuE/5RM;IAOI,+BAAA;EvE25RV;EuEl6RM;IAOI,6BAAA;EvE85RV;EuEr6RM;IAOI,+BAAA;EvEi6RV;EuEx6RM;IAOI,6BAAA;EvEo6RV;EuE36RM;IAOI,iBAAA;EvEu6RV;EuE96RM;IAOI,uBAAA;EvE06RV;EuEj7RM;IAOI,sBAAA;EvE66RV;EuEp7RM;IAOI,oBAAA;EvEg7RV;EuEv7RM;IAOI,sBAAA;EvEm7RV;EuE17RM;IAOI,oBAAA;EvEs7RV;EuE77RM;IAOI,2BAAA;EvEy7RV;EuEh8RM;IAOI,4BAAA;EvE47RV;EuEn8RM;IAOI,6BAAA;EvE+7RV;AACF;Aa18RI;E0DGI;IAOI,sBAAA;EvEo8RV;EuE38RM;IAOI,uBAAA;EvEu8RV;EuE98RM;IAOI,sBAAA;EvE08RV;EuEj9RM;IAOI,0BAAA;EvE68RV;EuEp9RM;IAOI,gCAAA;EvEg9RV;EuEv9RM;IAOI,yBAAA;EvEm9RV;EuE19RM;IAOI,wBAAA;EvEs9RV;EuE79RM;IAOI,yBAAA;EvEy9RV;EuEh+RM;IAOI,6BAAA;EvE49RV;EuEn+RM;IAOI,8BAAA;EvE+9RV;EuEt+RM;IAOI,wBAAA;EvEk+RV;EuEz+RM;IAOI,+BAAA;EvEq+RV;EuE5+RM;IAOI,wBAAA;EvEw+RV;EuE/+RM;IAOI,yBAAA;EvE2+RV;EuEl/RM;IAOI,8BAAA;EvE8+RV;EuEr/RM;IAOI,iCAAA;EvEi/RV;EuEx/RM;IAOI,sCAAA;EvEo/RV;EuE3/RM;IAOI,yCAAA;EvEu/RV;EuE9/RM;IAOI,uBAAA;EvE0/RV;EuEjgSM;IAOI,uBAAA;EvE6/RV;EuEpgSM;IAOI,yBAAA;EvEggSV;EuEvgSM;IAOI,yBAAA;EvEmgSV;EuE1gSM;IAOI,0BAAA;EvEsgSV;EuE7gSM;IAOI,4BAAA;EvEygSV;EuEhhSM;IAOI,kCAAA;EvE4gSV;EuEnhSM;IAOI,sCAAA;EvE+gSV;EuEthSM;IAOI,oCAAA;EvEkhSV;EuEzhSM;IAOI,kCAAA;EvEqhSV;EuE5hSM;IAOI,yCAAA;EvEwhSV;EuE/hSM;IAOI,wCAAA;EvE2hSV;EuEliSM;IAOI,wCAAA;EvE8hSV;EuEriSM;IAOI,kCAAA;EvEiiSV;EuExiSM;IAOI,gCAAA;EvEoiSV;EuE3iSM;IAOI,8BAAA;EvEuiSV;EuE9iSM;IAOI,gCAAA;EvE0iSV;EuEjjSM;IAOI,+BAAA;EvE6iSV;EuEpjSM;IAOI,oCAAA;EvEgjSV;EuEvjSM;IAOI,kCAAA;EvEmjSV;EuE1jSM;IAOI,gCAAA;EvEsjSV;EuE7jSM;IAOI,uCAAA;EvEyjSV;EuEhkSM;IAOI,sCAAA;EvE4jSV;EuEnkSM;IAOI,iCAAA;EvE+jSV;EuEtkSM;IAOI,2BAAA;EvEkkSV;EuEzkSM;IAOI,iCAAA;EvEqkSV;EuE5kSM;IAOI,+BAAA;EvEwkSV;EuE/kSM;IAOI,6BAAA;EvE2kSV;EuEllSM;IAOI,+BAAA;EvE8kSV;EuErlSM;IAOI,8BAAA;EvEilSV;EuExlSM;IAOI,oBAAA;EvEolSV;EuE3lSM;IAOI,mBAAA;EvEulSV;EuE9lSM;IAOI,mBAAA;EvE0lSV;EuEjmSM;IAOI,mBAAA;EvE6lSV;EuEpmSM;IAOI,mBAAA;EvEgmSV;EuEvmSM;IAOI,mBAAA;EvEmmSV;EuE1mSM;IAOI,mBAAA;EvEsmSV;EuE7mSM;IAOI,mBAAA;EvEymSV;EuEhnSM;IAOI,oBAAA;EvE4mSV;EuEnnSM;IAOI,0BAAA;EvE+mSV;EuEtnSM;IAOI,yBAAA;EvEknSV;EuEznSM;IAOI,uBAAA;EvEqnSV;EuE5nSM;IAOI,yBAAA;EvEwnSV;EuE/nSM;IAOI,uBAAA;EvE2nSV;EuEloSM;IAOI,uBAAA;EvE8nSV;EuEroSM;IAOI,0BAAA;IAAA,yBAAA;EvEkoSV;EuEzoSM;IAOI,gCAAA;IAAA,+BAAA;EvEsoSV;EuE7oSM;IAOI,+BAAA;IAAA,8BAAA;EvE0oSV;EuEjpSM;IAOI,6BAAA;IAAA,4BAAA;EvE8oSV;EuErpSM;IAOI,+BAAA;IAAA,8BAAA;EvEkpSV;EuEzpSM;IAOI,6BAAA;IAAA,4BAAA;EvEspSV;EuE7pSM;IAOI,6BAAA;IAAA,4BAAA;EvE0pSV;EuEjqSM;IAOI,wBAAA;IAAA,2BAAA;EvE8pSV;EuErqSM;IAOI,8BAAA;IAAA,iCAAA;EvEkqSV;EuEzqSM;IAOI,6BAAA;IAAA,gCAAA;EvEsqSV;EuE7qSM;IAOI,2BAAA;IAAA,8BAAA;EvE0qSV;EuEjrSM;IAOI,6BAAA;IAAA,gCAAA;EvE8qSV;EuErrSM;IAOI,2BAAA;IAAA,8BAAA;EvEkrSV;EuEzrSM;IAOI,2BAAA;IAAA,8BAAA;EvEsrSV;EuE7rSM;IAOI,wBAAA;EvEyrSV;EuEhsSM;IAOI,8BAAA;EvE4rSV;EuEnsSM;IAOI,6BAAA;EvE+rSV;EuEtsSM;IAOI,2BAAA;EvEksSV;EuEzsSM;IAOI,6BAAA;EvEqsSV;EuE5sSM;IAOI,2BAAA;EvEwsSV;EuE/sSM;IAOI,2BAAA;EvE2sSV;EuEltSM;IAOI,0BAAA;EvE8sSV;EuErtSM;IAOI,gCAAA;EvEitSV;EuExtSM;IAOI,+BAAA;EvEotSV;EuE3tSM;IAOI,6BAAA;EvEutSV;EuE9tSM;IAOI,+BAAA;EvE0tSV;EuEjuSM;IAOI,6BAAA;EvE6tSV;EuEpuSM;IAOI,6BAAA;EvEguSV;EuEvuSM;IAOI,2BAAA;EvEmuSV;EuE1uSM;IAOI,iCAAA;EvEsuSV;EuE7uSM;IAOI,gCAAA;EvEyuSV;EuEhvSM;IAOI,8BAAA;EvE4uSV;EuEnvSM;IAOI,gCAAA;EvE+uSV;EuEtvSM;IAOI,8BAAA;EvEkvSV;EuEzvSM;IAOI,8BAAA;EvEqvSV;EuE5vSM;IAOI,yBAAA;EvEwvSV;EuE/vSM;IAOI,+BAAA;EvE2vSV;EuElwSM;IAOI,8BAAA;EvE8vSV;EuErwSM;IAOI,4BAAA;EvEiwSV;EuExwSM;IAOI,8BAAA;EvEowSV;EuE3wSM;IAOI,4BAAA;EvEuwSV;EuE9wSM;IAOI,4BAAA;EvE0wSV;EuEjxSM;IAOI,qBAAA;EvE6wSV;EuEpxSM;IAOI,2BAAA;EvEgxSV;EuEvxSM;IAOI,0BAAA;EvEmxSV;EuE1xSM;IAOI,wBAAA;EvEsxSV;EuE7xSM;IAOI,0BAAA;EvEyxSV;EuEhySM;IAOI,wBAAA;EvE4xSV;EuEnySM;IAOI,2BAAA;IAAA,0BAAA;EvEgySV;EuEvySM;IAOI,iCAAA;IAAA,gCAAA;EvEoySV;EuE3ySM;IAOI,gCAAA;IAAA,+BAAA;EvEwySV;EuE/ySM;IAOI,8BAAA;IAAA,6BAAA;EvE4ySV;EuEnzSM;IAOI,gCAAA;IAAA,+BAAA;EvEgzSV;EuEvzSM;IAOI,8BAAA;IAAA,6BAAA;EvEozSV;EuE3zSM;IAOI,yBAAA;IAAA,4BAAA;EvEwzSV;EuE/zSM;IAOI,+BAAA;IAAA,kCAAA;EvE4zSV;EuEn0SM;IAOI,8BAAA;IAAA,iCAAA;EvEg0SV;EuEv0SM;IAOI,4BAAA;IAAA,+BAAA;EvEo0SV;EuE30SM;IAOI,8BAAA;IAAA,iCAAA;EvEw0SV;EuE/0SM;IAOI,4BAAA;IAAA,+BAAA;EvE40SV;EuEn1SM;IAOI,yBAAA;EvE+0SV;EuEt1SM;IAOI,+BAAA;EvEk1SV;EuEz1SM;IAOI,8BAAA;EvEq1SV;EuE51SM;IAOI,4BAAA;EvEw1SV;EuE/1SM;IAOI,8BAAA;EvE21SV;EuEl2SM;IAOI,4BAAA;EvE81SV;EuEr2SM;IAOI,2BAAA;EvEi2SV;EuEx2SM;IAOI,iCAAA;EvEo2SV;EuE32SM;IAOI,gCAAA;EvEu2SV;EuE92SM;IAOI,8BAAA;EvE02SV;EuEj3SM;IAOI,gCAAA;EvE62SV;EuEp3SM;IAOI,8BAAA;EvEg3SV;EuEv3SM;IAOI,4BAAA;EvEm3SV;EuE13SM;IAOI,kCAAA;EvEs3SV;EuE73SM;IAOI,iCAAA;EvEy3SV;EuEh4SM;IAOI,+BAAA;EvE43SV;EuEn4SM;IAOI,iCAAA;EvE+3SV;EuEt4SM;IAOI,+BAAA;EvEk4SV;EuEz4SM;IAOI,0BAAA;EvEq4SV;EuE54SM;IAOI,gCAAA;EvEw4SV;EuE/4SM;IAOI,+BAAA;EvE24SV;EuEl5SM;IAOI,6BAAA;EvE84SV;EuEr5SM;IAOI,+BAAA;EvEi5SV;EuEx5SM;IAOI,6BAAA;EvEo5SV;EuE35SM;IAOI,iBAAA;EvEu5SV;EuE95SM;IAOI,uBAAA;EvE05SV;EuEj6SM;IAOI,sBAAA;EvE65SV;EuEp6SM;IAOI,oBAAA;EvEg6SV;EuEv6SM;IAOI,sBAAA;EvEm6SV;EuE16SM;IAOI,oBAAA;EvEs6SV;EuE76SM;IAOI,2BAAA;EvEy6SV;EuEh7SM;IAOI,4BAAA;EvE46SV;EuEn7SM;IAOI,6BAAA;EvE+6SV;AACF;Aa17SI;E0DGI;IAOI,sBAAA;EvEo7SV;EuE37SM;IAOI,uBAAA;EvEu7SV;EuE97SM;IAOI,sBAAA;EvE07SV;EuEj8SM;IAOI,0BAAA;EvE67SV;EuEp8SM;IAOI,gCAAA;EvEg8SV;EuEv8SM;IAOI,yBAAA;EvEm8SV;EuE18SM;IAOI,wBAAA;EvEs8SV;EuE78SM;IAOI,yBAAA;EvEy8SV;EuEh9SM;IAOI,6BAAA;EvE48SV;EuEn9SM;IAOI,8BAAA;EvE+8SV;EuEt9SM;IAOI,wBAAA;EvEk9SV;EuEz9SM;IAOI,+BAAA;EvEq9SV;EuE59SM;IAOI,wBAAA;EvEw9SV;EuE/9SM;IAOI,yBAAA;EvE29SV;EuEl+SM;IAOI,8BAAA;EvE89SV;EuEr+SM;IAOI,iCAAA;EvEi+SV;EuEx+SM;IAOI,sCAAA;EvEo+SV;EuE3+SM;IAOI,yCAAA;EvEu+SV;EuE9+SM;IAOI,uBAAA;EvE0+SV;EuEj/SM;IAOI,uBAAA;EvE6+SV;EuEp/SM;IAOI,yBAAA;EvEg/SV;EuEv/SM;IAOI,yBAAA;EvEm/SV;EuE1/SM;IAOI,0BAAA;EvEs/SV;EuE7/SM;IAOI,4BAAA;EvEy/SV;EuEhgTM;IAOI,kCAAA;EvE4/SV;EuEngTM;IAOI,sCAAA;EvE+/SV;EuEtgTM;IAOI,oCAAA;EvEkgTV;EuEzgTM;IAOI,kCAAA;EvEqgTV;EuE5gTM;IAOI,yCAAA;EvEwgTV;EuE/gTM;IAOI,wCAAA;EvE2gTV;EuElhTM;IAOI,wCAAA;EvE8gTV;EuErhTM;IAOI,kCAAA;EvEihTV;EuExhTM;IAOI,gCAAA;EvEohTV;EuE3hTM;IAOI,8BAAA;EvEuhTV;EuE9hTM;IAOI,gCAAA;EvE0hTV;EuEjiTM;IAOI,+BAAA;EvE6hTV;EuEpiTM;IAOI,oCAAA;EvEgiTV;EuEviTM;IAOI,kCAAA;EvEmiTV;EuE1iTM;IAOI,gCAAA;EvEsiTV;EuE7iTM;IAOI,uCAAA;EvEyiTV;EuEhjTM;IAOI,sCAAA;EvE4iTV;EuEnjTM;IAOI,iCAAA;EvE+iTV;EuEtjTM;IAOI,2BAAA;EvEkjTV;EuEzjTM;IAOI,iCAAA;EvEqjTV;EuE5jTM;IAOI,+BAAA;EvEwjTV;EuE/jTM;IAOI,6BAAA;EvE2jTV;EuElkTM;IAOI,+BAAA;EvE8jTV;EuErkTM;IAOI,8BAAA;EvEikTV;EuExkTM;IAOI,oBAAA;EvEokTV;EuE3kTM;IAOI,mBAAA;EvEukTV;EuE9kTM;IAOI,mBAAA;EvE0kTV;EuEjlTM;IAOI,mBAAA;EvE6kTV;EuEplTM;IAOI,mBAAA;EvEglTV;EuEvlTM;IAOI,mBAAA;EvEmlTV;EuE1lTM;IAOI,mBAAA;EvEslTV;EuE7lTM;IAOI,mBAAA;EvEylTV;EuEhmTM;IAOI,oBAAA;EvE4lTV;EuEnmTM;IAOI,0BAAA;EvE+lTV;EuEtmTM;IAOI,yBAAA;EvEkmTV;EuEzmTM;IAOI,uBAAA;EvEqmTV;EuE5mTM;IAOI,yBAAA;EvEwmTV;EuE/mTM;IAOI,uBAAA;EvE2mTV;EuElnTM;IAOI,uBAAA;EvE8mTV;EuErnTM;IAOI,0BAAA;IAAA,yBAAA;EvEknTV;EuEznTM;IAOI,gCAAA;IAAA,+BAAA;EvEsnTV;EuE7nTM;IAOI,+BAAA;IAAA,8BAAA;EvE0nTV;EuEjoTM;IAOI,6BAAA;IAAA,4BAAA;EvE8nTV;EuEroTM;IAOI,+BAAA;IAAA,8BAAA;EvEkoTV;EuEzoTM;IAOI,6BAAA;IAAA,4BAAA;EvEsoTV;EuE7oTM;IAOI,6BAAA;IAAA,4BAAA;EvE0oTV;EuEjpTM;IAOI,wBAAA;IAAA,2BAAA;EvE8oTV;EuErpTM;IAOI,8BAAA;IAAA,iCAAA;EvEkpTV;EuEzpTM;IAOI,6BAAA;IAAA,gCAAA;EvEspTV;EuE7pTM;IAOI,2BAAA;IAAA,8BAAA;EvE0pTV;EuEjqTM;IAOI,6BAAA;IAAA,gCAAA;EvE8pTV;EuErqTM;IAOI,2BAAA;IAAA,8BAAA;EvEkqTV;EuEzqTM;IAOI,2BAAA;IAAA,8BAAA;EvEsqTV;EuE7qTM;IAOI,wBAAA;EvEyqTV;EuEhrTM;IAOI,8BAAA;EvE4qTV;EuEnrTM;IAOI,6BAAA;EvE+qTV;EuEtrTM;IAOI,2BAAA;EvEkrTV;EuEzrTM;IAOI,6BAAA;EvEqrTV;EuE5rTM;IAOI,2BAAA;EvEwrTV;EuE/rTM;IAOI,2BAAA;EvE2rTV;EuElsTM;IAOI,0BAAA;EvE8rTV;EuErsTM;IAOI,gCAAA;EvEisTV;EuExsTM;IAOI,+BAAA;EvEosTV;EuE3sTM;IAOI,6BAAA;EvEusTV;EuE9sTM;IAOI,+BAAA;EvE0sTV;EuEjtTM;IAOI,6BAAA;EvE6sTV;EuEptTM;IAOI,6BAAA;EvEgtTV;EuEvtTM;IAOI,2BAAA;EvEmtTV;EuE1tTM;IAOI,iCAAA;EvEstTV;EuE7tTM;IAOI,gCAAA;EvEytTV;EuEhuTM;IAOI,8BAAA;EvE4tTV;EuEnuTM;IAOI,gCAAA;EvE+tTV;EuEtuTM;IAOI,8BAAA;EvEkuTV;EuEzuTM;IAOI,8BAAA;EvEquTV;EuE5uTM;IAOI,yBAAA;EvEwuTV;EuE/uTM;IAOI,+BAAA;EvE2uTV;EuElvTM;IAOI,8BAAA;EvE8uTV;EuErvTM;IAOI,4BAAA;EvEivTV;EuExvTM;IAOI,8BAAA;EvEovTV;EuE3vTM;IAOI,4BAAA;EvEuvTV;EuE9vTM;IAOI,4BAAA;EvE0vTV;EuEjwTM;IAOI,qBAAA;EvE6vTV;EuEpwTM;IAOI,2BAAA;EvEgwTV;EuEvwTM;IAOI,0BAAA;EvEmwTV;EuE1wTM;IAOI,wBAAA;EvEswTV;EuE7wTM;IAOI,0BAAA;EvEywTV;EuEhxTM;IAOI,wBAAA;EvE4wTV;EuEnxTM;IAOI,2BAAA;IAAA,0BAAA;EvEgxTV;EuEvxTM;IAOI,iCAAA;IAAA,gCAAA;EvEoxTV;EuE3xTM;IAOI,gCAAA;IAAA,+BAAA;EvEwxTV;EuE/xTM;IAOI,8BAAA;IAAA,6BAAA;EvE4xTV;EuEnyTM;IAOI,gCAAA;IAAA,+BAAA;EvEgyTV;EuEvyTM;IAOI,8BAAA;IAAA,6BAAA;EvEoyTV;EuE3yTM;IAOI,yBAAA;IAAA,4BAAA;EvEwyTV;EuE/yTM;IAOI,+BAAA;IAAA,kCAAA;EvE4yTV;EuEnzTM;IAOI,8BAAA;IAAA,iCAAA;EvEgzTV;EuEvzTM;IAOI,4BAAA;IAAA,+BAAA;EvEozTV;EuE3zTM;IAOI,8BAAA;IAAA,iCAAA;EvEwzTV;EuE/zTM;IAOI,4BAAA;IAAA,+BAAA;EvE4zTV;EuEn0TM;IAOI,yBAAA;EvE+zTV;EuEt0TM;IAOI,+BAAA;EvEk0TV;EuEz0TM;IAOI,8BAAA;EvEq0TV;EuE50TM;IAOI,4BAAA;EvEw0TV;EuE/0TM;IAOI,8BAAA;EvE20TV;EuEl1TM;IAOI,4BAAA;EvE80TV;EuEr1TM;IAOI,2BAAA;EvEi1TV;EuEx1TM;IAOI,iCAAA;EvEo1TV;EuE31TM;IAOI,gCAAA;EvEu1TV;EuE91TM;IAOI,8BAAA;EvE01TV;EuEj2TM;IAOI,gCAAA;EvE61TV;EuEp2TM;IAOI,8BAAA;EvEg2TV;EuEv2TM;IAOI,4BAAA;EvEm2TV;EuE12TM;IAOI,kCAAA;EvEs2TV;EuE72TM;IAOI,iCAAA;EvEy2TV;EuEh3TM;IAOI,+BAAA;EvE42TV;EuEn3TM;IAOI,iCAAA;EvE+2TV;EuEt3TM;IAOI,+BAAA;EvEk3TV;EuEz3TM;IAOI,0BAAA;EvEq3TV;EuE53TM;IAOI,gCAAA;EvEw3TV;EuE/3TM;IAOI,+BAAA;EvE23TV;EuEl4TM;IAOI,6BAAA;EvE83TV;EuEr4TM;IAOI,+BAAA;EvEi4TV;EuEx4TM;IAOI,6BAAA;EvEo4TV;EuE34TM;IAOI,iBAAA;EvEu4TV;EuE94TM;IAOI,uBAAA;EvE04TV;EuEj5TM;IAOI,sBAAA;EvE64TV;EuEp5TM;IAOI,oBAAA;EvEg5TV;EuEv5TM;IAOI,sBAAA;EvEm5TV;EuE15TM;IAOI,oBAAA;EvEs5TV;EuE75TM;IAOI,2BAAA;EvEy5TV;EuEh6TM;IAOI,4BAAA;EvE45TV;EuEn6TM;IAOI,6BAAA;EvE+5TV;AACF;Aa16TI;E0DGI;IAOI,sBAAA;EvEo6TV;EuE36TM;IAOI,uBAAA;EvEu6TV;EuE96TM;IAOI,sBAAA;EvE06TV;EuEj7TM;IAOI,0BAAA;EvE66TV;EuEp7TM;IAOI,gCAAA;EvEg7TV;EuEv7TM;IAOI,yBAAA;EvEm7TV;EuE17TM;IAOI,wBAAA;EvEs7TV;EuE77TM;IAOI,yBAAA;EvEy7TV;EuEh8TM;IAOI,6BAAA;EvE47TV;EuEn8TM;IAOI,8BAAA;EvE+7TV;EuEt8TM;IAOI,wBAAA;EvEk8TV;EuEz8TM;IAOI,+BAAA;EvEq8TV;EuE58TM;IAOI,wBAAA;EvEw8TV;EuE/8TM;IAOI,yBAAA;EvE28TV;EuEl9TM;IAOI,8BAAA;EvE88TV;EuEr9TM;IAOI,iCAAA;EvEi9TV;EuEx9TM;IAOI,sCAAA;EvEo9TV;EuE39TM;IAOI,yCAAA;EvEu9TV;EuE99TM;IAOI,uBAAA;EvE09TV;EuEj+TM;IAOI,uBAAA;EvE69TV;EuEp+TM;IAOI,yBAAA;EvEg+TV;EuEv+TM;IAOI,yBAAA;EvEm+TV;EuE1+TM;IAOI,0BAAA;EvEs+TV;EuE7+TM;IAOI,4BAAA;EvEy+TV;EuEh/TM;IAOI,kCAAA;EvE4+TV;EuEn/TM;IAOI,sCAAA;EvE++TV;EuEt/TM;IAOI,oCAAA;EvEk/TV;EuEz/TM;IAOI,kCAAA;EvEq/TV;EuE5/TM;IAOI,yCAAA;EvEw/TV;EuE//TM;IAOI,wCAAA;EvE2/TV;EuElgUM;IAOI,wCAAA;EvE8/TV;EuErgUM;IAOI,kCAAA;EvEigUV;EuExgUM;IAOI,gCAAA;EvEogUV;EuE3gUM;IAOI,8BAAA;EvEugUV;EuE9gUM;IAOI,gCAAA;EvE0gUV;EuEjhUM;IAOI,+BAAA;EvE6gUV;EuEphUM;IAOI,oCAAA;EvEghUV;EuEvhUM;IAOI,kCAAA;EvEmhUV;EuE1hUM;IAOI,gCAAA;EvEshUV;EuE7hUM;IAOI,uCAAA;EvEyhUV;EuEhiUM;IAOI,sCAAA;EvE4hUV;EuEniUM;IAOI,iCAAA;EvE+hUV;EuEtiUM;IAOI,2BAAA;EvEkiUV;EuEziUM;IAOI,iCAAA;EvEqiUV;EuE5iUM;IAOI,+BAAA;EvEwiUV;EuE/iUM;IAOI,6BAAA;EvE2iUV;EuEljUM;IAOI,+BAAA;EvE8iUV;EuErjUM;IAOI,8BAAA;EvEijUV;EuExjUM;IAOI,oBAAA;EvEojUV;EuE3jUM;IAOI,mBAAA;EvEujUV;EuE9jUM;IAOI,mBAAA;EvE0jUV;EuEjkUM;IAOI,mBAAA;EvE6jUV;EuEpkUM;IAOI,mBAAA;EvEgkUV;EuEvkUM;IAOI,mBAAA;EvEmkUV;EuE1kUM;IAOI,mBAAA;EvEskUV;EuE7kUM;IAOI,mBAAA;EvEykUV;EuEhlUM;IAOI,oBAAA;EvE4kUV;EuEnlUM;IAOI,0BAAA;EvE+kUV;EuEtlUM;IAOI,yBAAA;EvEklUV;EuEzlUM;IAOI,uBAAA;EvEqlUV;EuE5lUM;IAOI,yBAAA;EvEwlUV;EuE/lUM;IAOI,uBAAA;EvE2lUV;EuElmUM;IAOI,uBAAA;EvE8lUV;EuErmUM;IAOI,0BAAA;IAAA,yBAAA;EvEkmUV;EuEzmUM;IAOI,gCAAA;IAAA,+BAAA;EvEsmUV;EuE7mUM;IAOI,+BAAA;IAAA,8BAAA;EvE0mUV;EuEjnUM;IAOI,6BAAA;IAAA,4BAAA;EvE8mUV;EuErnUM;IAOI,+BAAA;IAAA,8BAAA;EvEknUV;EuEznUM;IAOI,6BAAA;IAAA,4BAAA;EvEsnUV;EuE7nUM;IAOI,6BAAA;IAAA,4BAAA;EvE0nUV;EuEjoUM;IAOI,wBAAA;IAAA,2BAAA;EvE8nUV;EuEroUM;IAOI,8BAAA;IAAA,iCAAA;EvEkoUV;EuEzoUM;IAOI,6BAAA;IAAA,gCAAA;EvEsoUV;EuE7oUM;IAOI,2BAAA;IAAA,8BAAA;EvE0oUV;EuEjpUM;IAOI,6BAAA;IAAA,gCAAA;EvE8oUV;EuErpUM;IAOI,2BAAA;IAAA,8BAAA;EvEkpUV;EuEzpUM;IAOI,2BAAA;IAAA,8BAAA;EvEspUV;EuE7pUM;IAOI,wBAAA;EvEypUV;EuEhqUM;IAOI,8BAAA;EvE4pUV;EuEnqUM;IAOI,6BAAA;EvE+pUV;EuEtqUM;IAOI,2BAAA;EvEkqUV;EuEzqUM;IAOI,6BAAA;EvEqqUV;EuE5qUM;IAOI,2BAAA;EvEwqUV;EuE/qUM;IAOI,2BAAA;EvE2qUV;EuElrUM;IAOI,0BAAA;EvE8qUV;EuErrUM;IAOI,gCAAA;EvEirUV;EuExrUM;IAOI,+BAAA;EvEorUV;EuE3rUM;IAOI,6BAAA;EvEurUV;EuE9rUM;IAOI,+BAAA;EvE0rUV;EuEjsUM;IAOI,6BAAA;EvE6rUV;EuEpsUM;IAOI,6BAAA;EvEgsUV;EuEvsUM;IAOI,2BAAA;EvEmsUV;EuE1sUM;IAOI,iCAAA;EvEssUV;EuE7sUM;IAOI,gCAAA;EvEysUV;EuEhtUM;IAOI,8BAAA;EvE4sUV;EuEntUM;IAOI,gCAAA;EvE+sUV;EuEttUM;IAOI,8BAAA;EvEktUV;EuEztUM;IAOI,8BAAA;EvEqtUV;EuE5tUM;IAOI,yBAAA;EvEwtUV;EuE/tUM;IAOI,+BAAA;EvE2tUV;EuEluUM;IAOI,8BAAA;EvE8tUV;EuEruUM;IAOI,4BAAA;EvEiuUV;EuExuUM;IAOI,8BAAA;EvEouUV;EuE3uUM;IAOI,4BAAA;EvEuuUV;EuE9uUM;IAOI,4BAAA;EvE0uUV;EuEjvUM;IAOI,qBAAA;EvE6uUV;EuEpvUM;IAOI,2BAAA;EvEgvUV;EuEvvUM;IAOI,0BAAA;EvEmvUV;EuE1vUM;IAOI,wBAAA;EvEsvUV;EuE7vUM;IAOI,0BAAA;EvEyvUV;EuEhwUM;IAOI,wBAAA;EvE4vUV;EuEnwUM;IAOI,2BAAA;IAAA,0BAAA;EvEgwUV;EuEvwUM;IAOI,iCAAA;IAAA,gCAAA;EvEowUV;EuE3wUM;IAOI,gCAAA;IAAA,+BAAA;EvEwwUV;EuE/wUM;IAOI,8BAAA;IAAA,6BAAA;EvE4wUV;EuEnxUM;IAOI,gCAAA;IAAA,+BAAA;EvEgxUV;EuEvxUM;IAOI,8BAAA;IAAA,6BAAA;EvEoxUV;EuE3xUM;IAOI,yBAAA;IAAA,4BAAA;EvEwxUV;EuE/xUM;IAOI,+BAAA;IAAA,kCAAA;EvE4xUV;EuEnyUM;IAOI,8BAAA;IAAA,iCAAA;EvEgyUV;EuEvyUM;IAOI,4BAAA;IAAA,+BAAA;EvEoyUV;EuE3yUM;IAOI,8BAAA;IAAA,iCAAA;EvEwyUV;EuE/yUM;IAOI,4BAAA;IAAA,+BAAA;EvE4yUV;EuEnzUM;IAOI,yBAAA;EvE+yUV;EuEtzUM;IAOI,+BAAA;EvEkzUV;EuEzzUM;IAOI,8BAAA;EvEqzUV;EuE5zUM;IAOI,4BAAA;EvEwzUV;EuE/zUM;IAOI,8BAAA;EvE2zUV;EuEl0UM;IAOI,4BAAA;EvE8zUV;EuEr0UM;IAOI,2BAAA;EvEi0UV;EuEx0UM;IAOI,iCAAA;EvEo0UV;EuE30UM;IAOI,gCAAA;EvEu0UV;EuE90UM;IAOI,8BAAA;EvE00UV;EuEj1UM;IAOI,gCAAA;EvE60UV;EuEp1UM;IAOI,8BAAA;EvEg1UV;EuEv1UM;IAOI,4BAAA;EvEm1UV;EuE11UM;IAOI,kCAAA;EvEs1UV;EuE71UM;IAOI,iCAAA;EvEy1UV;EuEh2UM;IAOI,+BAAA;EvE41UV;EuEn2UM;IAOI,iCAAA;EvE+1UV;EuEt2UM;IAOI,+BAAA;EvEk2UV;EuEz2UM;IAOI,0BAAA;EvEq2UV;EuE52UM;IAOI,gCAAA;EvEw2UV;EuE/2UM;IAOI,+BAAA;EvE22UV;EuEl3UM;IAOI,6BAAA;EvE82UV;EuEr3UM;IAOI,+BAAA;EvEi3UV;EuEx3UM;IAOI,6BAAA;EvEo3UV;EuE33UM;IAOI,iBAAA;EvEu3UV;EuE93UM;IAOI,uBAAA;EvE03UV;EuEj4UM;IAOI,sBAAA;EvE63UV;EuEp4UM;IAOI,oBAAA;EvEg4UV;EuEv4UM;IAOI,sBAAA;EvEm4UV;EuE14UM;IAOI,oBAAA;EvEs4UV;EuE74UM;IAOI,2BAAA;EvEy4UV;EuEh5UM;IAOI,4BAAA;EvE44UV;EuEn5UM;IAOI,6BAAA;EvE+4UV;AACF;AwEt8UA;ED+CQ;IAOI,4BAAA;EvEo5UV;EuE35UM;IAOI,0BAAA;EvEu5UV;EuE95UM;IAOI,6BAAA;EvE05UV;EuEj6UM;IAOI,4BAAA;EvE65UV;AACF;AwEj8UA;ED4BQ;IAOI,0BAAA;EvEk6UV;EuEz6UM;IAOI,gCAAA;EvEq6UV;EuE56UM;IAOI,yBAAA;EvEw6UV;EuE/6UM;IAOI,wBAAA;EvE26UV;EuEl7UM;IAOI,yBAAA;EvE86UV;EuEr7UM;IAOI,6BAAA;EvEi7UV;EuEx7UM;IAOI,8BAAA;EvEo7UV;EuE37UM;IAOI,wBAAA;EvEu7UV;EuE97UM;IAOI,+BAAA;EvE07UV;EuEj8UM;IAOI,wBAAA;EvE67UV;AACF;AyEvgVA;EACE,2BAAA;EACA,mCAAA;EACA,qCAAA;EACA,4CAAA;EACA,qCAAA;EACA,oCAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AzEygVF;;A0ElhVE;EACE,4DAAA;A1EqhVJ;A0EnhVI;EACE,yCAAA;A1EqhVN;A0EjhVM;EACE,0CAAA;A1EmhVR;A0E/gVI;EACE,8DAAA;A1EihVN;A0E9gVI;EACE,8DAAA;EACA,qDAAA;EACA,0CAAA;A1EghVN;A0E9gVM;EACE,0CAAA;A1EghVR;A0E9gVQ;EACE,qDAAA;EACA,0CAAA;A1EghVV;A0E1gVE;EACE,qDAAA;A1E4gVJ;A0E1gVI;EACE,8DAAA;EACA,4DAAA;EACA,0CAAA;A1E4gVN;A0EzgVI;EACE,8DAAA;EACA,4DAAA;A1E2gVN;A0EzgVM;EACE,0CAAA;A1E2gVR;A0EzgVQ;EACE,uBAAA;A1E2gVV;A0EtgVI;EACE,wDAAA;EACA,4DAAA;EACA,0CAAA;A1EwgVN;A0ErgVI;EACE,4DAAA;A1EugVN;A0ErgVM;EACE,uBAAA;A1EugVR;A0EpgVM;EACE,8DAAA;EACA,0CAAA;A1EsgVR;A0ElgVI;EACE,oDAAA;A1EogVN;A0EjgVI;EACE,0CAAA;A1EmgVN;A0EhgVI;EACE,oDAAA;A1EkgVN;A0E9/UE;EACE,qEAAA;EACA,qDAAA;EACA,0CAAA;A1EggVJ;A0E7/UE;EACE,sDAAA;A1E+/UJ;A0E5/UE;EACE,oDAAA;EACA,gDAAA;A1E8/UJ;A0E1/UI;EAEE,sDAAA;A1E2/UN;A0Ex/UI;EAGE,qEAAA;A1Ew/UN;A0Er/UI;EAKE,qDAAA;EACA,0CAAA;A1Em/UN;A0E1+UM;EACE,uBAAA;A1E4+UR;A0Ez+UM;EAIE,qDAAA;EACA,gBAAA;A1Ew+UR;A0Er+UM;EACE,gBAAA;A1Eu+UR;A0El+UE;EACE,qEAAA;A1Eo+UJ;A0Ej+UE;EACE,yBAAA;A1Em+UJ;A0Eh+UE;EACE,sDAAA;A1Ek+UJ;A0E/9UE;EACE,qDAAA;EACA,yCAAA;A1Ei+UJ;A0E/9UI;EACE,yCAAA;A1Ei+UN;A0E99UI;EACE,+BAAA;A1Eg+UN;A0E59UE;EACE,qEAAA;EACA,qDAAA;A1E89UJ;A0E59UI;EACE,yCAAA;EACA,qDAAA;EACA,uBAAA;A1E89UN;A0E19UE;EACE,iDAAA;A1E49UJ;A0E19UI;EACE,qDAAA;A1E49UN;A0Ez9UI;EACE,0CAAA;EACA,qEAAA;A1E29UN;A0Ev9UE;;;EAGE,qDAAA;A1Ey9UJ;A0Et9UE;EACE,+BAAA;A1Ew9UJ;A0Er9UE;EACE,uBAAA;A1Eu9UJ;A0Er9UI;EACE,uBAAA;A1Eu9UN;A0El9UI;EACE,0CAAA;A1Eo9UN;A0El9UM;EACE,kCAAA;EACA,yCAAA;A1Eo9UR;A0Eh9UI;EACE,qEAAA;EACA,qDAAA;A1Ek9UN;A0Eh9UM;EAEE,qDAAA;EACA,qDAAA;A1Ei9UR;A0Ep9UM;EAEE,qDAAA;EACA,qDAAA;A1Ei9UR;A0E98UM;EAIE,qDAAA;EACA,gBAAA;A1E68UR;A0E18UM;EACE,gBAAA;A1E48UR;A0Ex8UI;EACE,0CAAA;A1E08UN;A0Ex8UM;EACE,qDAAA;EACA,yCAAA;EACA,uBAAA;A1E08UR;A0Er8UE;EACE,iDAAA;EACA,qDAAA;A1Eu8UJ;A0Er8UI;EACE,iDAAA;EACA,qDAAA;A1Eu8UN;A0Ez8UI;EACE,iDAAA;EACA,qDAAA;A1Eu8UN;A0En8UE;EACE,iDAAA;EACA,qDAAA;A1Eq8UJ;A0El8UE;EACE,qDAAA;A1Eo8UJ;A0Ej8UE;EACE,sDAAA;EACA,qDAAA;EACA,0CAAA;A1Em8UJ;A0Eh8UM;EACE,2BAAA;EACA,qDAAA;A1Ek8UR;A0E/7UM;EACE,0CAAA;A1Ei8UR;A0E57UE;EACE,sDAAA;EACA,4DAAA;A1E87UJ;A0Ex7UQ;EACE,sDAAA;EACA,qDAAA;EACA,0CAAA;A1E07UV;A0Ex7UU;EAIE,qEAAA;A1Eu7UZ;A0En7UQ;EACE,qEAAA;A1Eq7UV;A0El7UQ;EACE,uBAAA;A1Eo7UV;A0E96UM;EACE,qEAAA;EACA,qDAAA;EACA,0CAAA;A1Eg7UR;A0E96UQ;EACE,oDAAA;A1Eg7UV;A0E36UQ;EACE,0CAAA;A1E66UV;A0E16UQ;EACE,0CAAA;A1E46UV;A0Er6UI;EACE,yCAAA;A1Eu6UN;A0Er6UM;EACE,qDAAA;A1Eu6UR;A0En6UI;EACE,qEAAA;A1Eq6UN;A0El6UI;;;EAGE,oDAAA;EACA,4DAAA;A1Eo6UN;A0El6UM;;;EACE,qEAAA;A1Es6UR;A0El6UI;;EAEE,uBAAA;A1Eo6UN;A0Ej6UI;EACE,yDAAA;A1Em6UN;A0Ej6UM;EACE,qEAAA;A1Em6UR;A0E95UM;EACE,qEAAA;EACA,0CAAA;A1Eg6UR;A0E75UM;EACE,yCAAA;A1E+5UR;A0E35UI;EACE,qDAAA;A1E65UN;A0E35UM;EACE,oDAAA;EACA,0CAAA;A1E65UR;A0E35UQ;EACE,0DAAA;A1E65UV;A0E15UQ;EACE,qEAAA;A1E45UV;A0Ex5UM;EACE,oDAAA;EACA,qDAAA;EACA,0CAAA;A1E05UR;A0Er5UE;EACE,gDAAA;EACA,2DAAA;A1Eu5UJ;A0Ep5UE;EACE,0CAAA;A1Es5UJ;A0Ep5UI;EACE,uBAAA;A1Es5UN;A0Ej5UI;EACE,gDAAA;EACA,qDAAA;A1Em5UN;A0Eh5UI;EACE,wDAAA;A1Ek5UN;A0Eh5UM;EACE,0CAAA;A1Ek5UR;A0E/4UM;EACE,sDAAA;A1Ei5UR;A0E74UI;EACE,sDAAA;A1E+4UN;A0E34UE;EACE,+DAAA;A1E64UJ;A0E34UI;EACE,0CAAA;A1E64UN;A0E14UI;EACE,sDAAA;A1E44UN;A0Ex4UE;EACE,8DAAA;EACA,oDAAA;EACA,0CAAA;A1E04UJ;A0Ex4UI;EACE,yCAAA;A1E04UN;A0Ev4UI;EACE,yCAAA;A1Ey4UN;A0Et4UI;EACE,oDAAA;A1Ew4UN;A0Er4UI;;EAEE,qDAAA;A1Eu4UN;A0En4UE;EACE,8DAAA;EACA,qDAAA;A1Eq4UJ;A0El4UE;EACE,mDAAA;A1Eo4UJ;A0Ej4UE;EACE,0CAAA;A1Em4UJ;A0E93UM;EACE,oDAAA;EACA,0CAAA;A1Eg4UR;A0E93UQ;EACE,uBAAA;A1Eg4UV;A0E53UM;EACE,qEAAA;EACA,qDAAA;EACA,0CAAA;A1E83UR;A0E53UQ;EACE,0CAAA;A1E83UV;A0E53UU;EACE,yCAAA;EACA,qDAAA;EACA,uBAAA;A1E83UZ;A0E33UU;EACE,4BAAA;EACA,sDAAA;A1E63UZ;A0Ex3UM;EACE,yCAAA;EACA,qDAAA;EACA,uBAAA;A1E03UR;A0Ev3UM;EACE,0CAAA;A1Ey3UR;A0Et3UM;EACE,qDAAA;EACA,8BAAA;A1Ew3UR;A0Er3UM;EACE,0CAAA;A1Eu3UR;A0Ep3UM;EACE,0CAAA;A1Es3UR;A0Ej3UE;EACE,sDAAA;A1Em3UJ;A0Eh3UE;;;;;;;;;;;;;EAUE,0CAAA;A1Eq3UJ;;A2Er7VA;EACE,qCAAA;A3Ew7VF;A2Et7VE;EACE,qCAAA;A3Ew7VJ;A2Ej7VI;EACE,wBAAA;A3Em7VN;A2E/6VE;EACE,sBAAA;A3Ei7VJ;A2E96VE;EACE,sBAAA;A3Eg7VJ;A2E76VE;EACE,sBAAA;A3E+6VJ;A2E56VE;EACE,sBAAA;A3E86VJ;A2E36VE;EACE,sBAAA;A3E66VJ;A2E16VE;EACE,sBAAA;A3E46VJ;A2Ez6VE;EACE,sBAAA;A3E26VJ;A2Ex6VE;EACE,sBAAA;A3E06VJ;A2Ev6VE;EACE,sBAAA;A3Ey6VJ;A2Et6VE;EACE,2BAAA;A3Ew6VJ;A2Er6VE;EACE,2BAAA;A3Eu6VJ;A2El6VI;EACE,2BAAA;A3Eo6VN;A2Eh6VE;EACI,2BAAA;A3Ek6VN;;A4Et+VA;EACE,mBAAA;A5Ey+VF;A4Er+VM;EACE,8BAAA;A5Eu+VR;A4Ep+VM;EACE,0BAAA;A5Es+VR;A4En+VM;EACE,8BAAA;A5Eq+VR;A4Ej+VI;EACE,8BAAA;A5Em+VN;A4Eh+VI;EACE,8BAAA;A5Ek+VN;A4E99VM;EACE,8BAAA;A5Eg+VR;A4E79VM;EACE,8BAAA;A5E+9VR;A4E59VM;EACE,0BAAA;A5E89VR;A4Ez9VE;EACE,4BAAA;A5E29VJ;A4Ex9VE;EACE,8BAAA;A5E09VJ;A4Ev9VE;EACE,8BAAA;EAEA,uBAAA;A5Ew9VJ;A4Et9VI;EACE,6BAAA;EACA,uBAAA;A5Ew9VN;A4Ep9VE;EACE,6BAAA;EACA,2BAAA;A5Es9VJ;A4En9VE;EACE,6BAAA;A5Eq9VJ;A4El9VE;EACE,6BAAA;EACA,8BAAA;A5Eo9VJ;A4Ej9VE;EACE,uBAAA;A5Em9VJ;A4Ej9VI;EACE,0BAAA;EACA,iCAAA;A5Em9VN;A4Ej9VM;EACE,sBAAA;EACA,uBAAA;A5Em9VR;A4E98VE;EACE,2BAAA;A5Eg9VJ;A4E78VE;EACE,6BAAA;A5E+8VJ;A4E78VI;EACE,uBAAA;A5E+8VN;A4E38VE;EACE,sBAAA;EACA,uBAAA;EAEA,4BAAA;A5E48VJ;A4Ez8VE;EACE,8BAAA;A5E28VJ;A4Ex8VE;EACE,6BAAA;A5E08VJ;A4Et8VI;EACE,uBAAA;A5Ew8VN;A4Ep8VE;EACE,uBAAA;A5Es8VJ;A4Ep8VI;EACE,sBAAA;EACA,uBAAA;A5Es8VN;A4El8VE;;;EAGE,8BAAA;A5Eo8VJ;A4Ej8VE;EACE,4BAAA;A5Em8VJ;A4Eh8VE;EACE,8BAAA;A5Ek8VJ;A4E97VI;;EAEE,4BAAA;EACA,uBAAA;A5Eg8VN;A4E57VE;EACE,8BAAA;A5E87VJ;A4E17VI;EACE,4BAAA;A5E47VN;A4E17VM;EACE,6BAAA;A5E47VR;A4Ex7VI;EACE,4BAAA;A5E07VN;A4Et7VE;EACE,qBAAA;A5Ew7VJ;A4Er7VE;EACE,oBAAA;A5Eu7VJ;A4El7VM;EACE,2BAAA;A5Eo7VR;A4El7VQ;EACE,6BAAA;EACA,2BAAA;A5Eo7VV;A4Ej7VQ;EACE,6BAAA;EACA,2BAAA;A5Em7VV;A4E/6VM;EACE,8BAAA;A5Ei7VR;A4E96VM;EACE,8BAAA;A5Eg7VR;A4E76VM;EACE,8BAAA;A5E+6VR;A4E56VM;EACE,8BAAA;A5E86VR;A4Ez6VE;EACE,8BAAA;A5E26VJ;A4Ex6VE;EACE,8BAAA;A5E06VJ;A4Ev6VE;EACE,8BAAA;A5Ey6VJ;A4Et6VE;EACE,8BAAA;A5Ew6VJ;A4Er6VE;EACE,8BAAA;A5Eu6VJ;;A6E5oWA;EACE,mBAAA;A7E+oWF;A6E3oWM;EACE,8BAAA;A7E6oWR;A6E1oWM;EACE,6BAAA;A7E4oWR;A6EzoWM;EACE,8BAAA;A7E2oWR;A6EvoWI;EACE,8BAAA;A7EyoWN;A6EtoWI;EACE,8BAAA;A7EwoWN;A6EpoWM;EACE,8BAAA;A7EsoWR;A6EnoWM;EACE,8BAAA;A7EqoWR;A6EloWM;EACE,0BAAA;A7EooWR;A6E/nWE;EACE,4BAAA;A7EioWJ;A6E9nWE;EACE,8BAAA;A7EgoWJ;A6E7nWE;EACE,8BAAA;EAEA,uBAAA;A7E8nWJ;A6E5nWI;EACE,4BAAA;EACA,2BAAA;A7E8nWN;A6E1nWE;EACE,6BAAA;EACA,2BAAA;A7E4nWJ;A6EznWE;EACE,0BAAA;A7E2nWJ;A6ExnWE;EACE,6BAAA;EACA,8BAAA;A7E0nWJ;A6EvnWE;EACE,uBAAA;A7EynWJ;A6EvnWI;EACE,0BAAA;EACA,iCAAA;A7EynWN;A6EvnWM;EACE,sBAAA;EACA,uBAAA;A7EynWR;A6EpnWE;EACE,2BAAA;A7EsnWJ;A6EnnWE;EACE,4BAAA;A7EqnWJ;A6EnnWI;EACE,uBAAA;A7EqnWN;A6EjnWE;EACE,8BAAA;A7EmnWJ;A6EhnWE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;A7EinWJ;A6E9mWE;EACE,4BAAA;A7EgnWJ;A6E7mWE;EACE,uBAAA;A7E+mWJ;A6E5mWE;EACE,uBAAA;A7E8mWJ;A6E5mWI;EACE,sBAAA;EACA,uBAAA;A7E8mWN;A6E1mWE;;;EAGE,8BAAA;A7E4mWJ;A6EzmWE;EACE,6BAAA;A7E2mWJ;A6ExmWE;EACE,8BAAA;A7E0mWJ;A6EtmWI;;EAEE,4BAAA;EACA,uBAAA;A7EwmWN;A6EpmWE;EACE,8BAAA;A7EsmWJ;A6ElmWI;EACE,6BAAA;A7EomWN;A6ElmWM;EACE,4BAAA;A7EomWR;A6EhmWI;EACE,6BAAA;A7EkmWN;A6E9lWE;EACE,qBAAA;A7EgmWJ;A6E7lWE;EACE,oBAAA;A7E+lWJ;A6E1lWM;EACE,2BAAA;A7E4lWR;A6E1lWQ;EACE,4BAAA;EACA,2BAAA;A7E4lWV;A6EzlWQ;EACE,4BAAA;EACA,2BAAA;A7E2lWV;A6EvlWM;EACE,8BAAA;A7EylWR;A6EtlWM;EACE,8BAAA;A7EwlWR;A6ErlWM;EACE,8BAAA;A7EulWR;A6EplWM;EACE,8BAAA;A7EslWR;A6EjlWE;EACE,8BAAA;A7EmlWJ;A6EhlWE;EACE,8BAAA;A7EklWJ;A6E/kWE;EACE,8BAAA;A7EilWJ;A6E9kWE;EACE,8BAAA;A7EglWJ;A6E7kWE;EACE,8BAAA;A7E+kWJ;;A8ElzWA;EACE,mBAAA;A9EqzWF;A8EjzWM;EACE,8BAAA;A9EmzWR;A8EhzWM;EACE,4BAAA;A9EkzWR;A8E/yWM;EACE,8BAAA;A9EizWR;A8E7yWI;EACE,8BAAA;A9E+yWN;A8E5yWI;EACE,8BAAA;A9E8yWN;A8E1yWM;EACE,8BAAA;A9E4yWR;A8EzyWM;EACE,8BAAA;A9E2yWR;A8ExyWM;EACE,0BAAA;A9E0yWR;A8EryWE;EACE,4BAAA;A9EuyWJ;A8EpyWE;EACE,8BAAA;A9EsyWJ;A8EnyWE;EACE,8BAAA;EAEA,uBAAA;A9EoyWJ;A8ElyWI;EACE,6BAAA;EACA,uBAAA;A9EoyWN;A8EhyWE;EACE,4BAAA;EACA,2BAAA;A9EkyWJ;A8E/xWE;EACE,6BAAA;A9EiyWJ;A8E9xWE;EACE,4BAAA;EACA,8BAAA;A9EgyWJ;A8E7xWE;EACE,uBAAA;A9E+xWJ;A8E7xWI;EACE,0BAAA;EACA,gCAAA;A9E+xWN;A8E7xWM;EACE,sBAAA;EACA,uBAAA;A9E+xWR;A8E1xWE;EACE,2BAAA;A9E4xWJ;A8EzxWE;EACE,6BAAA;A9E2xWJ;A8EzxWI;EACE,uBAAA;A9E2xWN;A8EvxWE;EACE,8BAAA;A9EyxWJ;A8EtxWE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;A9EuxWJ;A8EpxWE;EACE,6BAAA;A9EsxWJ;A8ElxWI;EACE,uBAAA;A9EoxWN;A8EhxWE;EACE,uBAAA;A9EkxWJ;A8EhxWI;EACE,sBAAA;EACA,uBAAA;A9EkxWN;A8E9wWE;;;EAGE,8BAAA;A9EgxWJ;A8E7wWE;EACE,4BAAA;A9E+wWJ;A8E5wWE;EACE,8BAAA;A9E8wWJ;A8E1wWI;;EAEE,4BAAA;EACA,uBAAA;A9E4wWN;A8ExwWE;EACE,8BAAA;A9E0wWJ;A8EtwWI;EACE,4BAAA;A9EwwWN;A8EtwWM;EACE,6BAAA;A9EwwWR;A8EpwWI;EACE,4BAAA;A9EswWN;A8ElwWE;EACE,qBAAA;A9EowWJ;A8EjwWE;EACE,oBAAA;A9EmwWJ;A8E9vWM;EACE,2BAAA;A9EgwWR;A8E9vWQ;EACE,6BAAA;EACA,2BAAA;A9EgwWV;A8E7vWQ;EACE,6BAAA;EACA,2BAAA;A9E+vWV;A8E3vWM;EACE,8BAAA;A9E6vWR;A8E1vWM;EACE,8BAAA;A9E4vWR;A8EzvWM;EACE,8BAAA;A9E2vWR;A8ExvWM;EACE,8BAAA;A9E0vWR;A8ErvWE;EACE,8BAAA;A9EuvWJ;A8EpvWE;EACE,8BAAA;A9EsvWJ;A8EnvWE;EACE,8BAAA;A9EqvWJ;A8ElvWE;EACE,8BAAA;A9EovWJ;A8EjvWE;EACE,8BAAA;A9EmvWJ;;A+Ex9WA;EACE,mBAAA;A/E29WF;A+Ev9WM;EACE,8BAAA;A/Ey9WR;A+Et9WM;EACE,6BAAA;A/Ew9WR;A+Er9WM;EACE,8BAAA;A/Eu9WR;A+En9WI;EACE,8BAAA;A/Eq9WN;A+El9WI;EACE,8BAAA;A/Eo9WN;A+Eh9WM;EACE,8BAAA;A/Ek9WR;A+E/8WM;EACE,8BAAA;A/Ei9WR;A+E98WM;EACE,0BAAA;A/Eg9WR;A+E38WE;EACE,4BAAA;A/E68WJ;A+E18WE;EACE,8BAAA;A/E48WJ;A+Ez8WE;EACE,8BAAA;EAEA,uBAAA;A/E08WJ;A+Ex8WI;EACE,4BAAA;EACA,uBAAA;A/E08WN;A+Et8WE;EACE,6BAAA;EACA,2BAAA;A/Ew8WJ;A+Er8WE;EACE,4BAAA;A/Eu8WJ;A+Ep8WE;EACE,4BAAA;EACA,8BAAA;A/Es8WJ;A+En8WE;EACE,uBAAA;A/Eq8WJ;A+En8WI;EACE,yBAAA;EACA,gCAAA;A/Eq8WN;A+En8WM;EACE,sBAAA;EACA,uBAAA;A/Eq8WR;A+Eh8WE;EACE,2BAAA;A/Ek8WJ;A+E/7WE;EACE,4BAAA;A/Ei8WJ;A+E/7WI;EACE,uBAAA;A/Ei8WN;A+E77WE;EACE,8BAAA;A/E+7WJ;A+E57WE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;A/E67WJ;A+E17WE;EACE,4BAAA;A/E47WJ;A+Ex7WI;EACE,uBAAA;A/E07WN;A+Et7WE;EACE,uBAAA;A/Ew7WJ;A+Et7WI;EACE,sBAAA;EACA,uBAAA;A/Ew7WN;A+Ep7WE;;;EAGE,8BAAA;A/Es7WJ;A+En7WE;EACE,6BAAA;A/Eq7WJ;A+El7WE;EACE,8BAAA;A/Eo7WJ;A+Eh7WI;;EAEE,4BAAA;EACA,uBAAA;A/Ek7WN;A+E96WE;EACE,8BAAA;A/Eg7WJ;A+E56WI;EACE,6BAAA;A/E86WN;A+E56WM;EACE,4BAAA;A/E86WR;A+E16WI;EACE,6BAAA;A/E46WN;A+Ex6WE;EACE,qBAAA;A/E06WJ;A+Ev6WE;EACE,oBAAA;A/Ey6WJ;A+Ep6WM;EACE,2BAAA;A/Es6WR;A+Ep6WQ;EACE,4BAAA;EACA,2BAAA;A/Es6WV;A+En6WQ;EACE,4BAAA;EACA,2BAAA;A/Eq6WV;A+Ej6WM;EACE,8BAAA;A/Em6WR;A+Eh6WM;EACE,8BAAA;A/Ek6WR;A+E/5WM;EACE,8BAAA;A/Ei6WR;A+E95WM;EACE,8BAAA;A/Eg6WR;A+E35WE;EACE,8BAAA;A/E65WJ;A+E15WE;EACE,8BAAA;A/E45WJ;A+Ez5WE;EACE,8BAAA;A/E25WJ;A+Ex5WE;EACE,8BAAA;A/E05WJ;A+Ev5WE;EACE,8BAAA;A/Ey5WJ;;AgF9nXA;EACE,mBAAA;AhFioXF;AgF7nXM;EACE,6BAAA;AhF+nXR;AgF5nXM;EACE,6BAAA;AhF8nXR;AgF3nXO;EACC,8BAAA;AhF6nXR;AgFznXI;EACE,8BAAA;AhF2nXN;AgFxnXI;EACE,4BAAA;AhF0nXN;AgFtnXM;EACE,8BAAA;AhFwnXR;AgFrnXM;EACE,8BAAA;AhFunXR;AgFpnXM;EACE,0BAAA;AhFsnXR;AgFjnXE;EACE,8BAAA;AhFmnXJ;AgFhnXE;EACE,0BAAA;EAEA,2BAAA;AhFinXJ;AgF/mXI;EACE,6BAAA;AhFinXN;AgF7mXE;EACE,4BAAA;EACA,2BAAA;AhF+mXJ;AgF5mXE;EACE,6BAAA;AhF8mXJ;AgF3mXE;EACE,6BAAA;EACA,8BAAA;AhF6mXJ;AgF1mXE;EACE,2BAAA;AhF4mXJ;AgF1mXI;EACE,0BAAA;EACA,iCAAA;AhF4mXN;AgF1mXM;EACE,sBAAA;EACA,uBAAA;AhF4mXR;AgFvmXE;EACE,6BAAA;AhFymXJ;AgFtmXE;EACE,8BAAA;AhFwmXJ;AgFrmXE;EACE,sBAAA;EACA,uBAAA;EAEA,4BAAA;AhFsmXJ;AgFnmXE;EACE,6BAAA;AhFqmXJ;AgFjmXI;EACE,uBAAA;AhFmmXN;AgF/lXE;EACE,sBAAA;EACA,uBAAA;AhFimXJ;AgF9lXE;;;EAGE,8BAAA;AhFgmXJ;AgF7lXE;EACE,4BAAA;AhF+lXJ;AgF5lXE;EACE,0BAAA;AhF8lXJ;AgF1lXI;;EAEE,4BAAA;EACA,uBAAA;AhF4lXN;AgFxlXE;EACE,6BAAA;AhF0lXJ;AgFtlXI;EACE,4BAAA;AhFwlXN;AgFtlXM;EACE,6BAAA;AhFwlXR;AgFplXI;EACE,4BAAA;AhFslXN;AgFllXE;EACE,qBAAA;AhFolXJ;AgFjlXE;EACE,qBAAA;AhFmlXJ;AgF7kXQ;EACE,6BAAA;AhF+kXV;AgF5kXQ;EACE,6BAAA;AhF8kXV;AgF1kXM;EACE,0BAAA;AhF4kXR;AgFzkXM;EACE,8BAAA;AhF2kXR;AgFxkXM;EACE,8BAAA;AhF0kXR;AgFvkXM;EACE,0BAAA;AhFykXR;AgFpkXE;EACE,8BAAA;AhFskXJ;AgFnkXE;EACE,8BAAA;AhFqkXJ;AgFlkXE;EACE,8BAAA;AhFokXJ;AgFjkXE;EACE,8BAAA;AhFmkXJ;AgFhkXE;EACE,8BAAA;AhFkkXJ;;AiFlxXA;EACE,mBAAA;AjFqxXF;AiFjxXM;EACE,4BAAA;AjFmxXR;AiFhxXM;EACE,4BAAA;AjFkxXR;AiF/wXM;EACE,8BAAA;AjFixXR;AiF7wXI;EACE,8BAAA;AjF+wXN;AiF5wXI;EACE,6BAAA;AjF8wXN;AiF1wXM;EACE,8BAAA;AjF4wXR;AiFzwXM;EACE,8BAAA;AjF2wXR;AiFxwXM;EACE,0BAAA;AjF0wXR;AiFrwXE;EACE,8BAAA;AjFuwXJ;AiFpwXE;EACE,6BAAA;EAEA,2BAAA;AjFqwXJ;AiFnwXI;EACE,4BAAA;AjFqwXN;AiFjwXE;EACE,6BAAA;EACA,2BAAA;AjFmwXJ;AiFhwXE;EACE,4BAAA;AjFkwXJ;AiF/vXE;EACE,6BAAA;EACA,8BAAA;AjFiwXJ;AiF9vXE;EACE,2BAAA;AjFgwXJ;AiF9vXI;EACE,0BAAA;EACA,iCAAA;AjFgwXN;AiF9vXM;EACE,sBAAA;EACA,uBAAA;AjFgwXR;AiF3vXE;EACE,4BAAA;AjF6vXJ;AiF1vXE;EACE,8BAAA;AjF4vXJ;AiFzvXE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;AjF0vXJ;AiFvvXE;EACE,4BAAA;AjFyvXJ;AiFrvXI;EACE,uBAAA;AjFuvXN;AiFnvXE;EACE,sBAAA;EACA,uBAAA;AjFqvXJ;AiFlvXE;;;EAGE,8BAAA;AjFovXJ;AiFjvXE;EACE,6BAAA;AjFmvXJ;AiFhvXE;EACE,8BAAA;AjFkvXJ;AiF9uXI;;EAEE,4BAAA;EACA,uBAAA;AjFgvXN;AiF5uXE;EACE,4BAAA;AjF8uXJ;AiF1uXI;EACE,6BAAA;AjF4uXN;AiF1uXM;EACE,4BAAA;AjF4uXR;AiFxuXI;EACE,6BAAA;AjF0uXN;AiFtuXE;EACE,qBAAA;AjFwuXJ;AiFruXE;EACE,qBAAA;AjFuuXJ;AiFjuXQ;EACE,4BAAA;AjFmuXV;AiFhuXQ;EACE,4BAAA;AjFkuXV;AiF9tXM;EACE,6BAAA;AjFguXR;AiF7tXM;EACE,8BAAA;AjF+tXR;AiF5tXM;EACE,8BAAA;AjF8tXR;AiF3tXM;EACE,6BAAA;AjF6tXR;AiFxtXE;EACE,8BAAA;AjF0tXJ;AiFvtXE;EACE,8BAAA;AjFytXJ;AiFttXE;EACE,8BAAA;AjFwtXJ;AiFrtXE;EACE,8BAAA;AjFutXJ;AiFptXE;EACE,8BAAA;AjFstXJ;;AkFt6XA;EACE,mBAAA;AlFy6XF;AkFr6XM;EACE,6BAAA;AlFu6XR;AkFp6XM;EACE,6BAAA;AlFs6XR;AkFn6XM;EACE,8BAAA;AlFq6XR;AkFj6XI;EACE,8BAAA;AlFm6XN;AkFh6XI;EACE,4BAAA;AlFk6XN;AkF95XM;EACE,8BAAA;AlFg6XR;AkF75XM;EACE,8BAAA;AlF+5XR;AkF55XM;EACE,0BAAA;AlF85XR;AkFz5XE;EACE,8BAAA;AlF25XJ;AkFx5XE;EACE,4BAAA;EAEA,2BAAA;AlFy5XJ;AkFv5XI;EACE,6BAAA;AlFy5XN;AkFr5XE;EACE,0BAAA;EACA,2BAAA;AlFu5XJ;AkFp5XE;EACE,6BAAA;AlFs5XJ;AkFn5XE;EACE,6BAAA;EACA,8BAAA;AlFq5XJ;AkFl5XE;EACE,2BAAA;AlFo5XJ;AkFl5XI;EACE,0BAAA;EACA,iCAAA;AlFo5XN;AkFl5XM;EACE,sBAAA;EACA,uBAAA;AlFo5XR;AkF/4XE;EACE,6BAAA;AlFi5XJ;AkF94XE;EACE,8BAAA;AlFg5XJ;AkF74XE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;AlF84XJ;AkF14XI;EACE,uBAAA;AlF44XN;AkFx4XE;EACE,6BAAA;AlF04XJ;AkFv4XE;EACE,sBAAA;EACA,uBAAA;AlFy4XJ;AkFt4XE;;;EAGE,8BAAA;AlFw4XJ;AkFr4XE;EACE,4BAAA;AlFu4XJ;AkFp4XE;EACE,6BAAA;AlFs4XJ;AkFl4XI;;EAEE,4BAAA;EACA,uBAAA;AlFo4XN;AkFh4XE;EACE,6BAAA;AlFk4XJ;AkF93XI;EACE,4BAAA;AlFg4XN;AkF93XM;EACE,6BAAA;AlFg4XR;AkF53XI;EACE,4BAAA;AlF83XN;AkF13XE;EACE,qBAAA;AlF43XJ;AkFz3XE;EACE,qBAAA;AlF23XJ;AkFr3XQ;EACE,6BAAA;AlFu3XV;AkFp3XQ;EACE,6BAAA;AlFs3XV;AkFl3XM;EACE,4BAAA;AlFo3XR;AkFj3XM;EACE,8BAAA;AlFm3XR;AkFh3XM;EACE,8BAAA;AlFk3XR;AkF/2XM;EACE,4BAAA;AlFi3XR;AkF52XE;EACE,8BAAA;AlF82XJ;AkF32XE;EACE,8BAAA;AlF62XJ;AkF12XE;EACE,8BAAA;AlF42XJ;AkFz2XE;EACE,8BAAA;AlF22XJ;AkFx2XE;EACE,8BAAA;AlF02XJ;;AmF1jYA;EACE,mBAAA;AnF6jYF;AmFzjYM;EACE,4BAAA;AnF2jYR;AmFxjYM;EACE,4BAAA;AnF0jYR;AmFvjYM;EACE,8BAAA;AnFyjYR;AmFrjYI;EACE,8BAAA;AnFujYN;AmFpjYI;EACE,6BAAA;AnFsjYN;AmFljYM;EACE,8BAAA;AnFojYR;AmFjjYM;EACE,8BAAA;AnFmjYR;AmFhjYM;EACE,0BAAA;AnFkjYR;AmF7iYE;EACE,8BAAA;AnF+iYJ;AmF5iYE;EACE,6BAAA;EAEA,2BAAA;AnF6iYJ;AmF3iYI;EACE,4BAAA;AnF6iYN;AmFziYE;EACE,6BAAA;EACA,2BAAA;AnF2iYJ;AmFxiYE;EACE,4BAAA;AnF0iYJ;AmFviYE;EACE,6BAAA;EACA,8BAAA;AnFyiYJ;AmFtiYE;EACE,2BAAA;AnFwiYJ;AmFtiYI;EACE,0BAAA;EACA,iCAAA;AnFwiYN;AmFtiYM;EACE,sBAAA;EACA,uBAAA;AnFwiYR;AmFniYE;EACE,4BAAA;AnFqiYJ;AmFliYE;EACE,8BAAA;AnFoiYJ;AmFjiYE;EACE,sBAAA;EACA,uBAAA;EAEA,8BAAA;AnFkiYJ;AmF/hYE;EACE,4BAAA;AnFiiYJ;AmF7hYI;EACE,uBAAA;AnF+hYN;AmF3hYE;EACE,sBAAA;EACA,uBAAA;AnF6hYJ;AmF1hYE;;;EAGE,8BAAA;AnF4hYJ;AmFzhYE;EACE,6BAAA;AnF2hYJ;AmFxhYE;EACE,8BAAA;AnF0hYJ;AmFthYI;;EAEE,4BAAA;EACA,uBAAA;AnFwhYN;AmFphYE;EACE,4BAAA;AnFshYJ;AmFlhYI;EACE,6BAAA;AnFohYN;AmFlhYM;EACE,4BAAA;AnFohYR;AmFhhYI;EACE,6BAAA;AnFkhYN;AmF9gYE;EACE,qBAAA;AnFghYJ;AmF7gYE;EACE,qBAAA;AnF+gYJ;AmFzgYQ;EACE,4BAAA;AnF2gYV;AmFxgYQ;EACE,4BAAA;AnF0gYV;AmFtgYM;EACE,6BAAA;AnFwgYR;AmFrgYM;EACE,8BAAA;AnFugYR;AmFpgYM;EACE,8BAAA;AnFsgYR;AmFngYM;EACE,6BAAA;AnFqgYR;AmFhgYE;EACE,8BAAA;AnFkgYJ;AmF//XE;EACE,8BAAA;AnFigYJ;AmF9/XE;EACE,8BAAA;AnFggYJ;AmF7/XE;EACE,8BAAA;AnF+/XJ;AmF5/XE;EACE,8BAAA;AnF8/XJ;;AA/rYA;EACE,4BAAA;EACA,mEAAA;EACA,sLACE;EAEF,mBAAA;EACA,kBAAA;AAgsYF;AA7rYA;EACE,mBAAA;EACA,SAAA;AA+rYF;;AA5rYA;EACE,aAAA;EACA,wBAAA;EACA,qBAAA;AA+rYF;;AA5rYA;EACE,cAAA;EACA,iBAAA;AA+rYF;;AA5rYA;EAEE,sBAAA;AA+rYF;AA9rYE;EAGE,sBAAA;AA+rYJ;;AA3rYA;EACE,aAAA;EACA,sBAAA;AA8rYF;AA7rYE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AA+rYJ;AA9rYI;EACE,aAAA;AAgsYN;;AA3rYA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AA8rYF;AA7rYE;EACE,WAAA;EACA,OAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AA+rYJ;;AA3rYA;EACE,UAAA;AA8rYF;;AA3rYA;EACE,yBAAA;EACA,qBAAA;AA8rYF;AA5rYE;EAME,yBKrDM;ELsDN,qBKtDM;AL+uYV;;AArrYA;EACE,qBKvFS;ELwFT,cKtFS;AL8wYX;AArrYI;EACE,cK1FK;ALixYX;AAnrYE;EAME,yBKtGO;ALsxYX;AA/qYI;EACE,WoFjGE;ApFkxYR;;AA3qYE;EACE,gCAAA;EACA,YAAA;EACA,oCAAA;AA8qYJ;AA5qYE;EACE,gCAAA;EACA,YAAA;EACA,oCAAA;AA8qYJ;;AA1qYA;EACE,kBAAA;EACA,aAAA;EACA,sCAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AA6qYF;;AA1qYA;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;AA6qYF;;AA1qYA;;4EAAA;AAIA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AA4qYF;;AAzqYA;;4EAAA;AAIA;EACE,6BAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AA2qYF;AA1qYE;EACE,6BAAA;EACA,yBAAA;AA4qYJ;AA1qYE;EAEE,gBAAA;AA4qYJ;;AAxqYA;;4EAAA;AAIA,4DAAA;AACA;EACE,eAAA;AA0qYF;;AAvqYA,yBAAA;AAEA;EACE,iBAAA;EACA,yBAAA;AAyqYF;;AAtqYA;EACE,gBAAA;EACA,yBAAA;AAyqYF;;AAtqYA;EACE,yBAAA;AAyqYF;;AAtqYA;EACE,4EACE;EAEF,kBAAA;AAuqYF;;AApqYA;EACE,YAAA;EACA,qBAAA;AAuqYF;;AApqYA;EACE,mBAAA;EACA,qBAAA;AAuqYF;;AApqYA;EACE,mBAAA;EACA,oBAAA;AAuqYF;;AApqYA;EACE,qBAAA;AAuqYF;;AApqYA,oBAAA;AAKM;EACE,wBAAA;AAmqYR;;AA1pYM;EACE,uBAAA;AA6pYR;;AA9pYM;EACE,uBAAA;AAiqYR;;AAlqYM;EACE,uBAAA;AAqqYR;;AAtqYM;EACE,wBAAA;AAyqYR;;AA1qYM;EACE,wBAAA;AA6qYR;;AA9qYM;EACE,wBAAA;AAirYR;;AAlrYM;EACE,wBAAA;AAqrYR;;AAtrYM;EACE,wBAAA;AAyrYR;;AA1rYM;EACE,wBAAA;AA6rYR;;AA9rYM;EACE,yBAAA;AAisYR;;AA9rYM;EACE,2BAAA;AAisYR;;AAlsYM;EACE,2BAAA;AAqsYR;;AAtsYM;EACE,4BAAA;AAysYR;;AA1sYM;EACE,4BAAA;AA6sYR;;AA9sYM;EACE,4BAAA;AAitYR;;AAltYM;EACE,4BAAA;AAqtYR;;AAttYM;EACE,4BAAA;AAytYR;;AA1tYM;EACE,4BAAA;AA6tYR;;AA9tYM;EACE,6BAAA;AAiuYR;;AAluYM;EACE,8BAAA;AAquYR;;AAtuYM;EACE,8BAAA;AAyuYR;;AA1uYM;EACE,+BAAA;AA6uYR;;AA9uYM;EACE,+BAAA;AAivYR;;AAlvYM;EACE,+BAAA;AAqvYR;;AAtvYM;EACE,+BAAA;AAyvYR;;AA1vYM;EACE,+BAAA;AA6vYR;;AA9vYM;EACE,+BAAA;AAiwYR;;AAlwYM;EACE,gCAAA;AAqwYR;;AAtwYM;EACE,6BAAA;AAywYR;;AA1wYM;EACE,8BAAA;AA6wYR;;AA9wYM;EACE,8BAAA;AAixYR;;AAlxYM;EACE,8BAAA;AAqxYR;;AAtxYM;EACE,8BAAA;AAyxYR;;AA1xYM;EACE,8BAAA;AA6xYR;;AA9xYM;EACE,8BAAA;AAiyYR;;AAlyYM;EACE,+BAAA;AAqyYR;;AAtyYM;EACE,4BAAA;AAyyYR;;AA1yYM;EACE,6BAAA;AA6yYR;;AA9yYM;EACE,6BAAA;AAizYR;;AAlzYM;EACE,6BAAA;AAqzYR;;AAtzYM;EACE,6BAAA;AAyzYR;;AA1zYM;EACE,6BAAA;AA6zYR;;AA9zYM;EACE,6BAAA;AAi0YR;;AAl0YM;EACE,8BAAA;AAq0YR;;AA3wYI;EACE,0BAAA;AA8wYN;;AA/wYI;EACE,2BAAA;AAkxYN;;AAnxYI;EACE,yBAAA;AAsxYN;;AAvxYI;EACE,4BAAA;AA0xYN;;AA/xYI;EACE,qBAAA;AAkyYN;;AAnxYA,2BAAA;AAEA;EACE,WAAA;AAqxYF;;AAjxYI;EACE,0BAAA;AAoxYN;;AAjxYI;EACE,0BAAA;AAoxYN;;AArxYI;EACE,2BAAA;AAwxYN;;AAzxYI;EACE,2BAAA;AA4xYN;;AA7xYI;EACE,2BAAA;AAgyYN;;AAjyYI;EACE,2BAAA;AAoyYN;;AAryYI;EACE,2BAAA;AAwyYN;;AAzyYI;EACE,2BAAA;AA4yYN;;AA7yYI;EACE,4BAAA;AAgzYN;;AAjzYI;EACE,4BAAA;AAozYN;;AApyYA;EACE,sBAAA;EACA,UAAA;AAuyYF;;AApyYA;;4EAAA;AAIA;EACE,eAAA;AAsyYF;;AAnyYA;EACE,eAAA;AAsyYF;;AAnyYA;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAsyYF;;AAnyYA;EACE,qBAAA;AAsyYF;;AAnyYA;;4EAAA;AAIA;;EAEE,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAqyYF;;AAlyYA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAqyYF;;AAlyYA;EACE,kBAAA;AAqyYF;;AAlyYA;EACE,gBAAA;AAqyYF;;AAlyYA;+EAAA;AAGA;EACE,oBAAA;AAoyYF;;AAjyYA,kEAAA;AACA;EACE,aAAA;AAoyYF;;AAjyYA;EACE,iCAAA;EACA,eAAA;AAoyYF;;AAjyYA;EACE,yCAAA;AAoyYF;;AAjyYA;EACE,6BAAA;EACA,oCAAA;AAoyYF;;AAjyYA;EACE,coF/ZM;EpFgaN,iBAAA;EACA,mBAAA;AAoyYF;;AAhyYE;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;AAmyYJ;AAhyYE;EACE,qBoFxaG;EpFyaH,YAAA;EACA,oBAAA;EACA,yBoF3aG;ApF6sZP;AA/xYE;EACE,qBoF/aG;EpFgbH,YAAA;EACA,oBAAA;EACA,yBoFlbG;ApFmtZP;AA9xYE;EACE,qBoF/bS;EpFgcT,YAAA;EACA,yBoFjcS;ApFiuZb;AA9xYE;EACE,qBoF3bG;EpF4bH,YAAA;EACA,oBAAA;EACA,yBoF9bG;ApF8tZP;;AA5xYA;EACE,eAAA;EACA,iBAAA;EACA,coF3dU;ApF0vZZ;;AA5xYA;EACE,uBAAA;EACA,6BAAA;AA+xYF;AA7xYE;EACE,6BAAA;AA+xYJ;;AA3xYA;EACE,qBAAA;EACA,uCAAA;EACA,coF7dW;ApF2vZb;;AA3xYA;EACE,qBAAA;EACA,uCAAA;EACA,coFneW;ApFiwZb;;AA3xYA;EACE,coF9dK;ApF4vZP;;AA3xYA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AA8xYF;;AA3xYA;EACE,qBAAA;EACA,uCAAA;EACA,coFnfW;ApFixZb;;AA3xYA;EACE,YAAA;AA8xYF;;AA3xYA;EACE,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,4CAAA;EACA,uBAAA;EACA,mBAAA;AA8xYF;;AA3xYA;EACE,wBAAA;EACA,2BAAA;AA8xYF;;AA3xYA;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA8xYF;;AA3xYA;EACE,+BAAA;AA8xYF;;AA3xYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA8xYF;;AA3xYA;EACE,yBoFjiBU;EpFkiBV,uBAAA;AA8xYF;;AA3xYA;EACE,yBoFtiBU;EpFuiBV,YAAA;AA8xYF;;AA3xYA;EACE,WAAA;EACA,YAAA;AA8xYF;;AA1xYE;EACE,0BAAA;EACA,6BAAA;AA6xYJ;AA3xYE;EACE,yBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AA6xYJ;;AAzxYA;EACE,yBAAA;EAEA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AA2xYF;AAzxYE;EACE,+BAAA;EACA,6BAAA;AA2xYJ;;AAvxYA;EACE,eAAA;EACA,iBAAA;EACA,coF/kBI;ApFy2ZN;;AAvxYA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;AA0xYF;;AAvxYA;EACE,YAAA;AA0xYF;;AAvxYA;EACE,kBAAA,EAAA,4BAAA;EACA,mBAAA,EAAA,mBAAA;EACA,sBAAA;AA0xYF;;AAvxYA;EACE,YAAA;EACA,YAAA;AA0xYF;AAxxYI;EACE,gCAAA;EACA,YAAA;EACA,yBAAA;AA0xYN;AAxxYI;EACE,qBoFrmBO;EpFsmBP,YAAA;EACA,yBoFvmBO;ApFi4Zb;AAxxYI;EACE,qBoFjmBC;EpFkmBD,YAAA;EACA,oBAAA;EACA,yBoFpmBC;ApF83ZP;;AArxYA;EACE,uBAAA;AAwxYF;;AArxYA;EACE,2BAAA;EAAA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;AAwxYF;;AArxYA;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;AAwxYF;;AArxYA;EACE,uBAAA;EACA,SAAA;AAwxYF;;AArxYA;;EAEE,0BAAA;EACA,6BAAA;AAwxYF;;AArxYA;;EAEE,yBAAA;EACA,4BAAA;AAwxYF;;AArxYA;EACE,YAAA;AAwxYF;;AArxYA;EACE,YAAA;AAwxYF;;AArxYA;EACE,WAAA;AAwxYF;;AArxYA;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AAwxYF","sourcesContent":["// Import Bootstrap source files from node_modules\n@import '~bootstrap/scss/bootstrap';\n@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n@import '../content/css/dark-colors';\n@import '../content/css/accessibility/contrast';\n@import '../content/css/accessibility/dyslexia';\n@import '../content/css/accessibility/font-size/small/font-size-s';\n@import '../content/css/accessibility/font-size/small/font-size-xs';\n@import '../content/css/accessibility/font-size/small/font-size-2xs';\n@import '../content/css/accessibility/font-size/small/font-size-3xs';\n@import '../content/css/accessibility/font-size/large/font-size-l';\n@import '../content/css/accessibility/font-size/large/font-size-xl';\n@import '../content/css/accessibility/font-size/large/font-size-2xl';\n@import '../content/css/accessibility/font-size/large/font-size-3xl';\n\n@font-face {\n  font-family: 'open-dyslexic';\n  src: url('../content/fonts/open-dyslexic/OpenDyslexic-Regular.eot');\n  src:\n    url('../content/fonts/open-dyslexic/OpenDyslexic-Regular.eot?#iefix') format('embedded-opentype'),\n    url('../content/fonts/open-dyslexic/OpenDyslexic-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody {\n  background: #fafafa;\n  margin: 0;\n}\n\n::-webkit-scrollbar {\n  display: none;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\na {\n  color: #533f03;\n  font-weight: bold;\n}\n\n* {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  &:after,\n  &::before {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n}\n\n.app-container {\n  height: 100vh;\n  box-sizing: border-box;\n  .view-container {\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    scrollbar-width: none;      // Firefox\n    -ms-overflow-style: none;   // IE 10+\n    overflow-x: hidden;\n    padding: 25px 1rem 1rem;\n    .card {\n      padding: 1rem;\n    }\n  }\n}\n\n.view-routes {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  > main {\n    width: 100%;\n    flex: 1;\n    flex-direction: column;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n}\n\nmain > .page-content {\n  z-index: 0;\n}\n\n.btn-danger {\n  background-color: #960C0C;\n  border-color: #960C0C;\n\n  &:hover,\n  &:active,\n  &:focus,\n  &:focus:active,\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active {\n    background-color: $red-500;\n    border-color: $red-500;\n  }\n}\n\n.btn-secondary:not(:has(.dropdown-toggle-item)), .btn-outline-secondary:not(:has(.dropdown-toggle-item)) {\n  border-color: $gray-600;\n  color: $gray-800;\n\n  &:not(.disabled) {\n    .btn-label {\n      color: $gray-800;\n    }\n  }\n\n  &:hover,\n  &:active,\n  &:focus,\n  &:focus:active,\n  &:not(:disabled):not(.disabled).active,\n  &:not(:disabled):not(.disabled):active {\n    background-color: $gray-600;\n    .btn-label {\n      color: $white;\n    }\n  }\n}\n\n.red-addon-append {\n  .input-group-text {\n    border-color: #960C0C !important;\n    color: white;\n    background-color: #960C0C !important;\n  }\n  .input-group-text:hover {\n    border-color: $red-500 !important;\n    color: white;\n    background-color: $red-500 !important;\n  }\n}\n\n.fullscreen {\n  text-align: center;\n  z-index: 9999;\n  padding: 5px 25px 50px 25px !important;\n  height: 100vh !important;\n  width: 100%;\n  position: absolute;\n  top: -100px;\n}\n\n.loader-animation {\n  width: 15% !important;\n  position: absolute;\n  top: 50%;\n}\n\n/* ==========================================================================\nBrowser Upgrade Prompt\n========================================================================== */\n\n.browserupgrade {\n  margin: 0.2em 0;\n  background: #ccc;\n  color: #000;\n  padding: 0.2em 0;\n}\n\n/* ==========================================================================\nCustom button styles\n========================================================================== */\n\n.icon-button > .btn {\n  background-color: transparent;\n  border-color: transparent;\n  padding: 0.5rem;\n  line-height: 1rem;\n  &:hover {\n    background-color: transparent;\n    border-color: transparent;\n  }\n  &:focus {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n/* ==========================================================================\nGeneric styles\n========================================================================== */\n\n/* Temporary workaround for availity-reactstrap-validation */\n.invalid-feedback {\n  display: inline;\n}\n\n/* other generic styles */\n\n.title {\n  font-size: 1.25em;\n  margin: 1px 10px 1px 10px;\n}\n\n.description {\n  font-size: 0.9em;\n  margin: 1px 10px 1px 10px;\n}\n\ninput:disabled {\n  color: #828a90 !important;\n}\n\n.shadow {\n  box-shadow:\n    rgba(0, 0, 0, 0.12) 0px 1px 6px,\n    rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  border-radius: 2px;\n}\n\n.error {\n  color: white;\n  background-color: red;\n}\n\n.break {\n  white-space: normal;\n  word-break: break-all;\n}\n\n.break-word {\n  white-space: normal;\n  word-break: keep-all;\n}\n\n.preserve-space {\n  white-space: pre-wrap;\n}\n\n/* padding helpers */\n\n@mixin pad($size, $side) {\n  @if $size== '' {\n    @if $side== '' {\n      .pad {\n        padding: 10px !important;\n      }\n    } @else {\n      .pad {\n        padding-#{$side}: 10px !important;\n      }\n    }\n  } @else {\n    @if $side== '' {\n      .pad-#{$size} {\n        padding: #{$size}px !important;\n      }\n    } @else {\n      .pad-#{$side}-#{$size} {\n        padding-#{$side}: #{$size}px !important;\n      }\n    }\n  }\n}\n\n@include pad('', '');\n@include pad('2', '');\n@include pad('3', '');\n@include pad('5', '');\n@include pad('10', '');\n@include pad('20', '');\n@include pad('25', '');\n@include pad('30', '');\n@include pad('50', '');\n@include pad('75', '');\n@include pad('100', '');\n@include pad('4', 'top');\n@include pad('5', 'top');\n@include pad('10', 'top');\n@include pad('20', 'top');\n@include pad('25', 'top');\n@include pad('30', 'top');\n@include pad('50', 'top');\n@include pad('75', 'top');\n@include pad('100', 'top');\n@include pad('4', 'bottom');\n@include pad('5', 'bottom');\n@include pad('10', 'bottom');\n@include pad('20', 'bottom');\n@include pad('25', 'bottom');\n@include pad('30', 'bottom');\n@include pad('50', 'bottom');\n@include pad('75', 'bottom');\n@include pad('100', 'bottom');\n@include pad('5', 'right');\n@include pad('10', 'right');\n@include pad('20', 'right');\n@include pad('25', 'right');\n@include pad('30', 'right');\n@include pad('50', 'right');\n@include pad('75', 'right');\n@include pad('100', 'right');\n@include pad('5', 'left');\n@include pad('10', 'left');\n@include pad('20', 'left');\n@include pad('25', 'left');\n@include pad('30', 'left');\n@include pad('50', 'left');\n@include pad('75', 'left');\n@include pad('100', 'left');\n\n@mixin no-padding($side) {\n  @if $side== 'all' {\n    .no-padding {\n      padding: 0 !important;\n    }\n  } @else {\n    .no-padding-#{$side} {\n      padding-#{$side}: 0 !important;\n    }\n  }\n}\n\n@include no-padding('left');\n@include no-padding('right');\n@include no-padding('top');\n@include no-padding('bottom');\n@include no-padding('all');\n\n/* end of padding helpers */\n\n.no-margin {\n  margin: 0px;\n}\n@mixin voffset($size) {\n  @if $size== '' {\n    .voffset {\n      margin-top: 2px !important;\n    }\n  } @else {\n    .voffset-#{$size} {\n      margin-top: #{$size}px !important;\n    }\n  }\n}\n\n@include voffset('');\n@include voffset('5');\n@include voffset('10');\n@include voffset('15');\n@include voffset('30');\n@include voffset('40');\n@include voffset('60');\n@include voffset('80');\n@include voffset('100');\n@include voffset('150');\n\n.readonly {\n  background-color: #eee;\n  opacity: 1;\n}\n\n/* ==========================================================================\nmake sure browsers use the pointer cursor for anchors, even with no href\n========================================================================== */\n\na:hover {\n  cursor: pointer;\n}\n\n.hand {\n  cursor: pointer;\n}\n\nbutton.anchor-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  align-items: initial;\n  text-align: initial;\n  width: 100%;\n}\n\na.anchor-btn:hover {\n  text-decoration: none;\n}\n\n/* ==========================================================================\nMetrics and Health styles\n========================================================================== */\n\n#threadDump .popover,\n#healthCheck .popover {\n  top: inherit;\n  display: block;\n  font-size: 10px;\n  max-width: 1024px;\n}\n\n.thread-dump-modal-lock {\n  max-width: 450px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#healthCheck .popover {\n  margin-left: -50px;\n}\n\n.health-details {\n  min-width: 400px;\n}\n\n/* bootstrap 3 input-group 100% width\nhttp://stackoverflow.com/questions/23436430/bootstrap-3-input-group-100-width */\n\n.width-min {\n  width: 1% !important;\n}\n\n/* jhipster-needle-scss-add-main JHipster will add new css style */\n.hidden-upload {\n  display: none;\n}\n\n.readonly-upload-input {\n  background-color: #fff !important;\n  cursor: pointer;\n}\n\n.modal-footer {\n  justify-content: space-between !important;\n}\n\n.input-invalid {\n  border-radius: 5px !important;\n  border: 1px #ca1820 solid !important;\n}\n\n.paragraph-header {\n  color: $black;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.input-group {\n  .input-group-text {\n    border-color: #199cb4;\n    color: white;\n    background-color: #199cb4;\n  }\n\n  input[disabled] ~ .input-group-text, input[readonly] ~ .input-group-text {\n    border-color: $gray;\n    color: white;\n    pointer-events: none;\n    background-color: $gray;\n  }\n\n  .input-group-text:has(~ input[disabled], ~ input[readonly]) {\n    border-color: $gray;\n    color: white;\n    pointer-events: none;\n    background-color: $gray;\n  }\n\n  .input-group-text:hover {\n    border-color: $blue-light;\n    color: white;\n    background-color: $blue-light;\n  }\n  .input-group-text:has(.svg-inline--fa[aria-disabled='true']) {\n    border-color: $gray;\n    color: white;\n    pointer-events: none;\n    background-color: $gray;\n  }\n}\n\n.icon-table {\n  font-size: 18px;\n  font-weight: bold;\n  color: $secondary;\n}\n\n.button-in-action-column {\n  height: 100% !important;\n  margin-top: 0.5rem !important;\n\n  & > .btn-label {\n    text-wrap: initial !important;\n  }\n}\n\n.button-in-action-column:hover {\n  transform: scale(1.1);\n  transition: transform 0.15s ease-in-out;\n  color: $blue-light;\n}\n\n.icon-table:hover:not([aria-disabled=\"true\"]) {\n  transform: scale(1.4);\n  transition: transform 0.15s ease-in-out;\n  color: $blue-light;\n}\n\n.icon-table[aria-disabled=\"true\"] {\n  color: $gray;\n}\n\n.icon-table-header {\n  font-size: 18px;\n  font-weight: 500;\n  color: white;\n}\n\n.icon-table-header:hover {\n  transform: scale(1.4);\n  transition: transform 0.15s ease-in-out;\n  color: $blue-light;\n}\n\n.invalid-table-row .icon-table {\n  color: white;\n}\n\n.actions-container {\n  height: 40px;\n  display: inline-grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(min-content, 30px);\n  justify-content: center;\n  align-items: center;\n}\n\n.form-check {\n  min-height: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.form-header {\n  font-weight: bold;\n  font-size: 16px;\n  color: $primary !important;\n  margin-bottom: 20px;\n}\n\n.form-switch {\n  padding-left: 1.5rem !important;\n}\n\n.custom-checkbox {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.invalid-table-row {\n  background-color: $red-light;\n  color: white !important;\n}\n\n.table-striped tbody tr:nth-of-type(odd).invalid-table-row > * {\n  background-color: $red-light;\n  color: white;\n}\n\n.delete-button {\n  width: 30px;\n  height: 30px;\n}\n\n.ispu-input-wrapper {\n  input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    margin-left: 0;\n    max-height: 34px;\n  }\n}\n\n.sidebar-statement-link {\n  background-color: #343a40;\n\n  padding: 15px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n\n  .bm-item {\n    margin-bottom: unset !important;\n    text-align: center !important;\n  }\n}\n\n.act-error-icon {\n  font-size: 18px;\n  font-weight: bold;\n  color: $red;\n}\n\n.act-error-icon:hover {\n  transform: scale(1.4);\n  transition: transform 0.15s ease-in-out;\n  cursor: pointer;\n}\n\n.act-error-toast {\n  width: 500px;\n}\n\n.acts-error-line-break {\n  padding-left: 2rem;   /* space for wrapped lines */\n  white-space: normal;    /* allow wrapping */\n  word-break: break-word;\n}\n\n.case-copy-from-other-case {\n  width: 300px;\n  height: 50px;\n  .input-group {\n    .input-group-text {\n      border-color: #199cb4 !important;\n      color: white;\n      background-color: #199cb4;\n    }\n    .input-group-text:hover {\n      border-color: $blue-light;\n      color: white;\n      background-color: $blue-light;\n    }\n    .input-group-text:has(.svg-inline--fa[aria-disabled='true']) {\n      border-color: $gray;\n      color: white;\n      pointer-events: none;\n      background-color: $gray;\n    }\n  }\n}\n\n.btn-group .btn {\n  height: 100% !important;\n}\n\n.fit-content-modal {\n  min-width: fit-content;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%);\n}\n\n.custom-btn-group {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.custom-btn-group .btn {\n  height: 100% !important;\n  margin: 0;\n}\n\n.custom-btn-group .btn-group-first-button,\n.custom-btn-group span .btn-group-first-button {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.custom-btn-group .btn-group-last-button,\n.custom-btn-group span .btn-group-last-button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-full-width {\n  width: 160px;\n}\n\n.btn-primary-width {\n  width: 130px;\n}\n\n.btn-secondary-width {\n  width: 30px;\n}\n\ntd {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  white-space: normal;\n}\n","@mixin bsBanner($file, $suffix:\"\") {\n  /*!\n   * Bootstrap #{$file} v5.2.0 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-2xl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $body-bg !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($dropdown-link-color, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     $white !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-border-width:           $border-width !default;\n$pagination-margin-start:           ($pagination-border-width * -1) !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                $border-radius !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              var(--#{$prefix}heading-color) !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                $border-width !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba($black, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 3;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu):not(.form-floating)#{$validation-messages},\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    @include form-validation-state-selector($state) {\n      @if $state == \"valid\" {\n        z-index: 1;\n      } @else if $state == \"invalid\" {\n        z-index: 2;\n      }\n      &:focus {\n        z-index: 3;\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n\n  &:hover,\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-end {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-start {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == end {\n        @include caret-end();\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-start();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(var(--#{$prefix}nav-tabs-border-width) * -1); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(var(--#{$prefix}nav-tabs-border-width) * -1); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{color-contrast($accordion-bg)};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(var(--#{$prefix}accordion-border-width) * -1) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      @include border-radius(0);\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == (calc($pagination-border-width * -1)) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(var(--#{$prefix}list-group-border-width) * -1); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(var(--#{$prefix}list-group-border-width) * -1); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  position: absolute;\n  z-index: $zindex-toast;\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(var(--#{$prefix}toast-padding-x) * -.5); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(var(--#{$prefix}modal-header-padding-y) * -.5) calc(var(--#{$prefix}modal-header-padding-x) * -.5) calc(var(--#{$prefix}modal-header-padding-y) * -.5) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc((var(--#{$prefix}popover-arrow-height) * -1) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc((var(--#{$prefix}popover-arrow-height) * -1) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc((var(--#{$prefix}popover-arrow-height) * -1) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(var(--#{$prefix}popover-arrow-width) * -.5); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc((var(--#{$prefix}popover-arrow-height) * -1) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: $zindex-offcanvas;\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(var(--#{$prefix}offcanvas-padding-y) * -.5);\n    margin-right: calc(var(--#{$prefix}offcanvas-padding-x) * -.5);\n    margin-bottom: calc(var(--#{$prefix}offcanvas-padding-y) * -.5);\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (eg. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",":root {\n  --darkBodyBackground: black;\n  --darkBodyBackgroundActive: #202020;\n  --darkContentBackgroundColor: #2d2d2d;\n  --darkLightenContentBackgroundColor: #3c3c3c;\n  --darkBootstrapDefaultBorder: #ced4da;\n  --darkPaginationHoverNotActive: #ddd;\n  --darkDisabledField: #323232;\n  --darkDisabledIcon: #757575;\n  --darkContentColor: black;\n  --lightContentColor: white;\n}\n",".accessibility-contrast {\n  #egradjani {\n    border-bottom: 1px solid var(--lightContentColor) !important;\n\n    .zgl-showmore a:hover {\n      color: var(--darkContentColor) !important\n    }\n\n    #current_user {\n      a, .unread a {\n        color: var(--lightContentColor) !important;\n      }\n    }\n\n    #fontsize_slideout .lining {\n      background-color: var(--darkContentBackgroundColor) !important;\n    }\n\n    #user_slideout {\n      background-color: var(--darkContentBackgroundColor) !important;\n      border: 1px solid var(--lightContentColor) !important;\n      color: var(--lightContentColor) !important;\n\n      a.action {\n        color: var(--lightContentColor) !important;\n\n        &:hover {\n          border: 2px solid var(--lightContentColor) !important;\n          color: var(--lightContentColor) !important;\n        }\n      }\n    }\n  }\n\n  #promjena_subjekta {\n    border: 1px solid var(--lightContentColor) !important;\n\n    #egradani_modal_izaberite_subjekt {\n      background-color: var(--darkContentBackgroundColor) !important;\n      border-bottom: 1px solid var(--lightContentColor) !important;\n      color: var(--lightContentColor) !important;\n    }\n\n    .assist {\n      background-color: var(--darkContentBackgroundColor) !important;\n      border-bottom: 1px solid var(--lightContentColor) !important;\n\n      a {\n        color: var(--lightContentColor) !important;\n\n        &:hover {\n          opacity: 0.5 !important;\n        }\n      }\n    }\n\n    .lining {\n      background: var(--darkContentBackgroundColor) !important;\n      border-bottom: 1px solid var(--lightContentColor) !important;\n      color: var(--lightContentColor) !important;\n    }\n\n    .mfp-close {\n      border-bottom: 1px solid var(--lightContentColor) !important;\n\n      &:hover::before {\n        opacity: 0.5 !important;\n      }\n\n      &::before {\n        background-color: var(--darkContentBackgroundColor) !important;\n        color: var(--lightContentColor) !important;\n      }\n    }\n\n    .selection ul li:hover {\n      background-color: var(--darkContentColor) !important;\n    }\n\n    .zgl-area::before {\n      color: var(--lightContentColor) !important;\n    }\n\n    input {\n      background-color: var(--darkContentColor) !important;\n    }\n  }\n\n  .alert {\n    background-color: var(--darkLightenContentBackgroundColor) !important;\n    border: 1px solid var(--lightContentColor) !important;\n    color: var(--lightContentColor) !important;\n  }\n\n  .bg-white, .navbar-content {\n    background-color: var(--darkBodyBackground) !important;\n  }\n\n  .bm-menu {\n    background-color: var(--darkContentColor) !important;\n    border-right: 1px solid var(--lightContentColor);\n  }\n\n  .btn {\n    &.btn-primary,\n    &.btn-info {\n      background-color: var(--darkBodyBackground) !important;\n    }\n\n    &.btn-secondary,\n    &.btn-outline-secondary,\n    &.btn-danger {\n      background-color: var(--darkLightenContentBackgroundColor) !important;\n    }\n\n    &.btn-primary,\n    &.btn-secondary,\n    &.btn-info,\n    &.btn-outline-secondary,\n    &.btn-danger {\n      border: 1px solid var(--lightContentColor) !important;\n      color: var(--lightContentColor) !important;\n    }\n\n    &.btn-primary,\n    &.btn-secondary,\n    &.btn-info,\n    &.btn-outline-secondary,\n    &.btn-white,\n    &.btn-danger {\n      &:disabled {\n        opacity: 0.5 !important;\n      }\n\n      &:hover,\n      &:active,\n      &:not(:disabled):not(.disabled).active,\n      &:not(:disabled):not(.disabled):active {\n        background-color: rgba(255, 255, 255, 0.4) !important;\n        transition: 0.2s;\n      }\n\n      &:not(:hover) {\n        transition: 0.2s;\n      }\n    }\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    background-color: var(--darkLightenContentBackgroundColor) !important;\n  }\n\n  .error-tab, .error-tab svg {\n    color: $red-light !important;\n  }\n\n  .file-drop-wrapper:hover {\n    border: 3px dashed var(--lightContentColor) !important;\n  }\n\n  .footer {\n    background-color: var(--lightContentColor) !important;\n    color: var(--darkContentColor) !important;\n\n    span {\n      color: var(--darkContentColor) !important;\n    }\n\n    img {\n      filter: grayscale(1) !important;\n    }\n  }\n\n  .form-control {\n    background-color: var(--darkLightenContentBackgroundColor) !important;\n    border: 1px solid var(--lightContentColor) !important;\n\n    &:disabled {\n      color: var(--darkContentColor) !important;\n      background-color: var(--lightContentColor) !important;\n      opacity: 0.5 !important;\n    }\n  }\n\n  .form-check-input {\n    border-color: var(--lightContentColor) !important;\n\n    &:focus {\n      box-shadow: 0 0 0 0.1em rgb(255, 255, 255) !important;\n    }\n\n    &:checked {\n      color: var(--lightContentColor) !important;\n      background-color: var(--darkLightenContentBackgroundColor) !important;\n    }\n  }\n\n  .form-header,\n  .form-label,\n  .invalid-feedback {\n    color: var(--darkPaginationHoverNotActive) !important;\n  }\n\n  .form-switch .form-check-input:focus {\n    filter: grayscale(1) !important;\n  }\n\n  .icon-table, .icon-table-header {\n    color: white !important;\n\n    &:hover {\n      opacity: 0.5 !important;\n    }\n  }\n\n  .input-group {\n    .addon-icon {\n      color: var(--lightContentColor) !important;\n\n      &:hover {\n        background-color: unset !important;\n        color: var(--darkContentColor) !important;\n      }\n    }\n\n    .input-group-text {\n      background-color: var(--darkLightenContentBackgroundColor) !important;\n      border: 1px solid var(--lightContentColor) !important;\n\n      &:disabled,\n      &:read-only {\n        background-color: rgba(255, 255, 255, 0.4) !important;\n        border: 1px solid var(--lightContentColor) !important\n      }\n\n      &:hover,\n      &:active,\n      &:not(:disabled):not(.disabled).active,\n      &:not(:disabled):not(.disabled):active {\n        background-color: rgba(255, 255, 255, 0.4) !important;\n        transition: 0.2s;\n      }\n\n      &:not(:hover) {\n        transition: 0.2s;\n      }\n    }\n\n    input {\n      color: var(--lightContentColor) !important;\n\n      &:disabled {\n        background-color: var(--lightContentColor) !important;\n        color: var(--darkContentColor) !important;\n        opacity: 0.5 !important;\n      }\n    }\n  }\n\n  .has-validation .input-group-text {\n    border-color: var(--lightContentColor) !important;\n    border: 3px solid var(--lightContentColor) !important;\n\n    &:read-only {\n      border-color: var(--lightContentColor) !important;\n      border: 3px solid var(--lightContentColor) !important;\n    }\n  }\n\n  .is-invalid {\n    border-color: var(--lightContentColor) !important;\n    border: 3px solid var(--lightContentColor) !important;\n  }\n\n  .input-invalid {\n    border: 3px solid var(--lightContentColor) !important;\n  }\n\n  .modal-content {\n    background-color: var(--darkBodyBackground) !important;\n    border: 1px solid var(--lightContentColor) !important;\n    color: var(--lightContentColor) !important;\n\n    .modal-header .btn-close {\n      &:focus {\n        box-shadow: none !important;\n        border: 1px solid var(--lightContentColor) !important;\n      }\n\n      &::after {\n        color: var(--lightContentColor) !important;\n      }\n    }\n  }\n\n  .page-content {\n    background-color: var(--darkBodyBackground) !important;\n    border-bottom: 1px solid var(--lightContentColor) !important;\n  }\n\n  .pagination-wrapper {\n    .pagination {\n      .page-item {\n        .page-link {\n          background-color: var(--darkBodyBackground) !important;\n          border: 1px solid var(--lightContentColor) !important;\n          color: var(--lightContentColor) !important;\n\n          &:hover,\n          &:active,\n          &:focus,\n          &:focus:active {\n            background-color: var(--darkLightenContentBackgroundColor) !important;\n          }\n        }\n\n        &.active .page-link {\n          background-color: var(--darkLightenContentBackgroundColor) !important;\n        }\n\n        &.disabled .page-link {\n          opacity: 0.5 !important;\n        }\n      }\n    }\n\n    .pagination-size {\n      .edozvola-select {\n        background-color: var(--darkLightenContentBackgroundColor) !important;\n        border: 1px solid var(--lightContentColor) !important;\n        color: var(--lightContentColor) !important;\n\n        & > option {\n          background-color: var(--darkContentColor) !important;\n        }\n      }\n\n      .custom-select {\n        &:hover:not(:disabled) {\n          color: var(--lightContentColor) !important;\n        }\n\n        &:focus:not(:disabled) {\n          color: var(--lightContentColor) !important;\n        }\n      }\n    }\n  }\n\n  .rdt {\n    .rdtActive {\n      color: var(--darkContentColor) !important;\n\n      &:before {\n        background-color: var(--lightContentColor) !important;\n      }\n    }\n\n    .rdtBtn:hover {\n      background-color: var(--darkLightenContentBackgroundColor) !important;\n    }\n\n    .rdtNext,\n    .rdtPrev,\n    .rdtSwitch {\n      background-color: var(--darkContentColor) !important;\n      border-bottom: 1px solid var(--lightContentColor) !important;\n\n      &:hover {\n        background-color: var(--darkLightenContentBackgroundColor) !important;\n      }\n    }\n\n    .rdtNew,\n    .rdtOld {\n      opacity: 0.5 !important;\n    }\n\n    .rdtTimeToggle {\n      border-top: 1px solid var(--lightContentColor) !important;\n\n      &:hover {\n        background-color: var(--darkLightenContentBackgroundColor) !important;\n      }\n    }\n\n    .rdtToday {\n      &:before {\n        background-color: var(--darkLightenContentBackgroundColor) !important;\n        color: var(--lightContentColor) !important;\n      }\n\n      &:hover {\n        color: var(--darkContentColor) !important;\n      }\n    }\n\n    table {\n      border: 1px solid var(--lightContentColor) !important;\n\n      td {\n        background-color: var(--darkContentColor) !important;\n        color: var(--lightContentColor) !important;\n\n        &.rdtDisabled {\n          color: var(--darkLightenContentBackgroundColor) !important;\n        }\n\n        &:not(.rdtDisabled):hover:before {\n          background-color: var(--darkLightenContentBackgroundColor) !important;\n        }\n      }\n\n      tr {\n        background-color: var(--darkContentColor) !important;\n        border: 1px solid var(--lightContentColor) !important;\n        color: var(--lightContentColor) !important;\n      }\n    }\n  }\n\n  .sidebar-statement-link {\n    background: var(--darkBodyBackground) !important;\n    border-right: 1px solid var(--lightContentColor) !important;\n  }\n\n  .sort-arrow {\n    color: var(--lightContentColor) !important;\n\n    &:hover {\n      opacity: 0.5 !important;\n    }\n  }\n\n  .table {\n    thead {\n      background: var(--darkBodyBackground) !important;\n      border: 1px solid var(--lightContentColor) !important;\n    }\n\n    tbody tr {\n      background: var(--darkContentBackgroundColor) !important;\n\n      td {\n        color: var(--lightContentColor) !important;\n      }\n\n      &:hover {\n        background: var(--darkBodyBackgroundActive) !important;\n      }\n    }\n\n    .custom-toggle-checkbox:checked + .custom-toggle-slider {\n      background-color: var(--darkBodyBackground) !important;\n    }\n  }\n\n  .table-striped tbody tr:nth-of-type(odd) {\n    background: var(--darkLightenContentBackgroundColor) !important;\n\n    td {\n      color: var(--lightContentColor) !important;\n    }\n\n    &:hover {\n      background: var(--darkBodyBackgroundActive) !important;\n    }\n  }\n\n  .Toastify__toast {\n    background-color: var(--darkContentBackgroundColor) !important;\n    border: 4px solid var(--darkContentColor) !important;\n    color: var(--lightContentColor) !important;\n\n    .Toastify__close-button svg {\n      fill: var(--lightContentColor) !important;\n    }\n\n    .Toastify__toast-icon svg {\n      fill: var(--lightContentColor) !important;\n    }\n\n    .Toastify__progress-bar--wrp {\n      background-color: var(--darkContentColor) !important;\n    }\n\n    .Toastify__progress-bar--error,\n    .Toastify__progress-bar--success {\n      background-color: var(--lightContentColor) !important;\n    }\n  }\n\n  .uploaded-file-item {\n    background-color: var(--darkContentBackgroundColor) !important;\n    border: 2px solid var(--lightContentColor) !important;\n  }\n\n  .upload-icon {\n    color: var(--darkContentBackgroundColor) !important;\n  }\n\n  .fw-bold, .loader-text, .text-danger, .text-gray {\n    color: var(--lightContentColor) !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn .multiple {\n        background-color: var(--darkContentColor) !important;\n        color: var(--lightContentColor) !important;\n\n        &:disabled {\n          opacity: 0.5 !important;\n        }\n      }\n\n      .dropdown-menu {\n        background-color: var(--darkLightenContentBackgroundColor) !important;\n        border: 1px solid var(--lightContentColor) !important;\n        color: var(--lightContentColor) !important;\n\n        .dropdown-item {\n          color: var(--lightContentColor) !important;\n\n          &.disabled {\n            color: var(--darkContentColor) !important;\n            background-color: var(--lightContentColor) !important;\n            opacity: 0.5 !important;\n          }\n\n          &:hover {\n            font-weight: bold !important;\n            background-color: var(--darkBodyBackground) !important;\n          }\n        }\n      }\n\n      .disabled {\n        color: var(--darkContentColor) !important;\n        background-color: var(--lightContentColor) !important;\n        opacity: 0.5 !important;\n      }\n\n      .hint, .close {\n        color: var(--lightContentColor) !important;\n      }\n\n      .is-invalid {\n        border: 3px solid var(--lightContentColor) !important;\n        border-color: unset !important;\n      }\n\n      .icon {\n        color: var(--lightContentColor) !important;\n      }\n\n      .no-value-text {\n        color: var(--lightContentColor) !important;\n      }\n    }\n  }\n\n  main {\n    background-color: var(--darkBodyBackground) !important;\n  }\n\n  a,\n  input,\n  hr,\n  h3,\n  h5,\n  h6,\n  p,\n  svg,\n  span,\n  textarea {\n    color: var(--lightContentColor) !important;\n  }\n}\n",".accessibility-dyslexia {\n  font-family: open-dyslexic !important;\n\n  .Toastify__toast {\n    font-family: open-dyslexic !important;\n  }\n\n  &.accessibility-font-size-s,\n  &.accessibility-font-size-xs,\n  &.accessibility-font-size-2xs,\n  &.accessibility-font-size-3xs {\n    .button-in-action-column.btn {\n      padding: 20px !important;\n    }\n  }\n\n  .form-switch .form-check-input {\n    width: 68px !important;\n  }\n\n  &.accessibility-font-size-s .form-switch .form-check-input {\n    width: 62px !important;\n  }\n\n  &.accessibility-font-size-xs .form-switch .form-check-input {\n    width: 60px !important;\n  }\n\n  &.accessibility-font-size-2xs .form-switch .form-check-input {\n    width: 58px !important;\n  }\n\n  &.accessibility-font-size-3xs .form-switch .form-check-input {\n    width: 54px !important;\n  }\n\n  &.accessibility-font-size-l .form-switch .form-check-input {\n    width: 76px !important;\n  }\n\n  &.accessibility-font-size-xl .form-switch .form-check-input {\n    width: 80px !important;\n  }\n\n  &.accessibility-font-size-2xl .form-switch .form-check-input {\n    width: 84px !important;\n  }\n\n  &.accessibility-font-size-3xl .form-switch .form-check-input {\n    width: 88px !important;\n  }\n\n  .footer .row span {\n    margin-top: 17px !important;\n  }\n\n  &.accessibility-font-size-s .footer .row span  {\n    margin-top: 18px !important;\n  }\n\n  &.accessibility-font-size-xs,\n  &.accessibility-font-size-2xs {\n    .footer .row span  {\n      margin-top: 20px !important;\n    }\n  }\n\n  &.accessibility-font-size-3xs .footer .row span  {\n      margin-top: 21px !important;\n  }\n}\n",".accessibility-font-size-s {\n  font-size: 0.875rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.075rem !important;\n      }\n\n      h4 {\n        font-size: 1rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 0.875rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 0.875rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.325rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 0.875rem !important;\n      }\n\n      a.action {\n        font-size: 0.875rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 33px !important;\n      }\n    }\n  }\n\n  .alert {\n    line-height: 18px !important;\n  }\n\n  .bm-subitem {\n    font-size: 0.785rem !important;\n  }\n\n  .btn {\n    font-size: 0.825rem !important;\n\n    height: 30px !important;\n\n    &.btn-lg {\n      font-size: 0.95rem !important;\n      height: 32px !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.75rem !important;\n    min-height: 24px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text {\n    font-size: 1.05rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 11px !important;\n    padding-right: 36px !important;\n  }\n\n  .custom-toggle-wrapper {\n    height: 26px !important;\n\n    .custom-toggle-slider {\n      font-size: 12px !important;\n      padding: 0 11px 0 36px !important;\n\n      .custom-toggle-ball {\n        width: 22px !important;\n        height: 22px !important;\n      }\n    }\n  }\n\n  .footer .row span {\n    margin-top: 16px !important;\n  }\n\n  .form-control {\n    font-size: 0.95rem !important;\n\n    &:not(textarea) {\n      height: 32px !important;\n    }\n  }\n\n  .form-switch .form-check-input {\n    width: 54px !important;\n    height: 22px !important;\n\n    margin-left: -3em !important;\n  }\n\n  .form-header {\n    font-size: 0.875rem !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 0.95rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 32px !important;\n    }\n  }\n\n  .input-group-text {\n    height: 32px !important;\n\n    svg {\n      width: 15px !important;\n      height: 15px !important;\n    }\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 0.775rem !important;\n  }\n\n  .lead {\n    font-size: 1.2rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 0.825rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 0.9rem !important;\n      height: 32px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 0.925rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.7rem !important;\n\n      th .table-sort {\n        font-size: 0.95rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.7rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 25px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 8px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        min-height: 32px !important;\n\n        .dropdown-toggle-item {\n          font-size: 0.95rem !important;\n          margin-top: -2px !important;\n        }\n\n        .multiple {\n          font-size: 0.95rem !important;\n          margin-top: -2px !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 0.825rem !important;\n      }\n\n      .icon {\n        font-size: 0.875rem !important;\n      }\n\n      .hint, .close {\n        font-size: 0.875rem !important;\n      }\n\n      .no-value-text {\n        font-size: 0.825rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.625rem !important;\n  }\n\n  h4 {\n    font-size: 1.375rem !important;\n  }\n\n  h5 {\n    font-size: 1.125rem !important;\n  }\n\n  h6 {\n    font-size: 0.875rem !important;\n  }\n\n  p {\n    font-size: 0.825rem !important;\n  }\n}\n",".accessibility-font-size-xs {\n  font-size: 0.825rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.025rem !important;\n      }\n\n      h4 {\n        font-size: 0.95rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 0.825rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 0.825rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.275rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 0.825rem !important;\n      }\n\n      a.action {\n        font-size: 0.825rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 31px !important;\n      }\n    }\n  }\n\n  .alert {\n    line-height: 16px !important;\n  }\n\n  .bm-subitem {\n    font-size: 0.725rem !important;\n  }\n\n  .btn {\n    font-size: 0.775rem !important;\n\n    height: 29px !important;\n\n    &.btn-lg {\n      font-size: 0.9rem !important;\n      min-height: 30px !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.75rem !important;\n    min-height: 23px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 1rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 10px !important;\n    padding-right: 34px !important;\n  }\n\n  .custom-toggle-wrapper {\n    height: 24px !important;\n\n    .custom-toggle-slider {\n      font-size: 11px !important;\n      padding: 0 10px 0 34px !important;\n\n      .custom-toggle-ball {\n        width: 20px !important;\n        height: 20px !important;\n      }\n    }\n  }\n\n  .footer .row span {\n    margin-top: 17px !important;\n  }\n\n  .form-control {\n    font-size: 0.9rem !important;\n\n    &:not(textarea) {\n      height: 30px !important;\n    }\n  }\n\n  .form-header {\n    font-size: 0.825rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 52px !important;\n    height: 22px !important;\n\n    margin-left: -3.2em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 0.9rem !important;\n  }\n\n  .input-group {\n    height: 30px !important;\n  }\n\n  .input-group-text {\n    height: 30px !important;\n\n    svg {\n      width: 14px !important;\n      height: 14px !important;\n    }\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 0.725rem !important;\n  }\n\n  .lead {\n    font-size: 1.15rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 0.775rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 0.8rem !important;\n      height: 30px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 0.875rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.65rem !important;\n\n      th .table-sort {\n        font-size: 0.9rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.65rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 25px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 6px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        min-height: 30px !important;\n\n        .dropdown-toggle-item {\n          font-size: 0.9rem !important;\n          margin-top: -2px !important;\n        }\n\n        .multiple {\n          font-size: 0.9rem !important;\n          margin-top: -2px !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 0.775rem !important;\n      }\n\n      .icon {\n        font-size: 0.825rem !important;\n      }\n\n      .hint, .close {\n        font-size: 0.825rem !important;\n      }\n\n      .no-value-text {\n        font-size: 0.775rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.575rem !important;\n  }\n\n  h4 {\n    font-size: 1.325rem !important;\n  }\n\n  h5 {\n    font-size: 1.075rem !important;\n  }\n\n  h6 {\n    font-size: 0.825rem !important;\n  }\n\n  p {\n    font-size: 0.775rem !important;\n  }\n}\n",".accessibility-font-size-2xs {\n  font-size: 0.775rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 0.975rem !important;\n      }\n\n      h4 {\n        font-size: 0.9rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 0.775rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 0.775rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.225rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 0.775rem !important;\n      }\n\n      a.action {\n        font-size: 0.775rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 29px !important;\n      }\n    }\n  }\n\n  .alert {\n    line-height: 14px !important;\n  }\n\n  .bm-subitem {\n    font-size: 0.675rem !important;\n  }\n\n  .btn {\n    font-size: 0.725rem !important;\n\n    height: 28px !important;\n\n    &.btn-lg {\n      font-size: 0.85rem !important;\n      height: 28px !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.7rem !important;\n    min-height: 22px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 0.95rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 9px !important;\n    padding-right: 32px !important;\n  }\n\n  .custom-toggle-wrapper {\n    height: 22px !important;\n\n    .custom-toggle-slider {\n      font-size: 10px !important;\n      padding: 0 9px 0 32px !important;\n\n      .custom-toggle-ball {\n        width: 18px !important;\n        height: 18px !important;\n      }\n    }\n  }\n\n  .footer .row span {\n    margin-top: 18px !important;\n  }\n\n  .form-control {\n    font-size: 0.85rem !important;\n\n    &:not(textarea) {\n      height: 28px !important;\n    }\n  }\n\n  .form-header {\n    font-size: 0.775rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 48px !important;\n    height: 20px !important;\n\n    margin-left: -3.4em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 0.85rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 28px !important;\n    }\n  }\n\n  .input-group-text {\n    height: 28px !important;\n\n    svg {\n      width: 13px !important;\n      height: 13px !important;\n    }\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 0.675rem !important;\n  }\n\n  .lead {\n    font-size: 1.1rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 0.725rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 0.7rem !important;\n      height: 28px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 0.825rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.6rem !important;\n\n      th .table-sort {\n        font-size: 0.85rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.6rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 25px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 6px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        min-height: 28px !important;\n\n        .dropdown-toggle-item {\n          font-size: 0.85rem !important;\n          margin-top: -2px !important;\n        }\n\n        .multiple {\n          font-size: 0.85rem !important;\n          margin-top: -2px !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 0.725rem !important;\n      }\n\n      .icon {\n        font-size: 0.775rem !important;\n      }\n\n      .hint, .close {\n        font-size: 0.775rem !important;\n      }\n\n      .no-value-text {\n        font-size: 0.725rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.525rem !important;\n  }\n\n  h4 {\n    font-size: 1.275rem !important;\n  }\n\n  h5 {\n    font-size: 1.025rem !important;\n  }\n\n  h6 {\n    font-size: 0.775rem !important;\n  }\n\n  p {\n    font-size: 0.725rem !important;\n  }\n}\n",".accessibility-font-size-3xs {\n  font-size: 0.725rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 0.925rem !important;\n      }\n\n      h4 {\n        font-size: 0.85rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 0.725rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 0.725rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.175rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 0.725rem !important;\n      }\n\n      a.action {\n        font-size: 0.725rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 27px !important;\n      }\n    }\n  }\n\n  .alert {\n    line-height: 12px !important;\n  }\n\n  .bm-subitem {\n    font-size: 0.625rem !important;\n  }\n\n  .btn {\n    font-size: 0.675rem !important;\n\n    height: 28px !important;\n\n    &.btn-lg {\n      font-size: 0.8rem !important;\n      height: 26px !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.65rem !important;\n    min-height: 21px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text {\n    font-size: 0.9rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 8px !important;\n    padding-right: 30px !important;\n  }\n\n  .custom-toggle-wrapper {\n    height: 20px !important;\n\n    .custom-toggle-slider {\n      font-size: 9px !important;\n      padding: 0 8px 0 32px !important;\n\n      .custom-toggle-ball {\n        width: 16px !important;\n        height: 16px !important;\n      }\n    }\n  }\n\n  .footer .row span {\n    margin-top: 19px !important;\n  }\n\n  .form-control {\n    font-size: 0.8rem !important;\n\n    &:not(textarea) {\n      height: 26px !important;\n    }\n  }\n\n  .form-header {\n    font-size: 0.725rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 44px !important;\n    height: 19px !important;\n\n    margin-left: -3.5em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 0.8rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 26px !important;\n    }\n  }\n\n  .input-group-text {\n    height: 26px !important;\n\n    svg {\n      width: 12px !important;\n      height: 12px !important;\n    }\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 0.625rem !important;\n  }\n\n  .lead {\n    font-size: 1.05rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 0.675rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 0.6rem !important;\n      height: 26px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 0.775rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.55rem !important;\n\n      th .table-sort {\n        font-size: 0.8rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.55rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 20px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 4px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        min-height: 26px !important;\n\n        .dropdown-toggle-item {\n          font-size: 0.8rem !important;\n          margin-top: -2px !important;\n        }\n\n        .multiple {\n          font-size: 0.8rem !important;\n          margin-top: -2px !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 0.675rem !important;\n      }\n\n      .icon {\n        font-size: 0.725rem !important;\n      }\n\n      .hint, .close {\n        font-size: 0.725rem !important;\n      }\n\n      .no-value-text {\n        font-size: 0.675rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.475rem !important;\n  }\n\n  h4 {\n    font-size: 1.225rem !important;\n  }\n\n  h5 {\n    font-size: 0.975rem !important;\n  }\n\n  h6 {\n    font-size: 0.725rem !important;\n  }\n\n  p {\n    font-size: 0.675rem !important;\n  }\n}\n",".accessibility-font-size-l {\n  font-size: 1.125rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.25rem !important;\n      }\n\n      h4 {\n        font-size: 1.15rem !important;\n      }\n\n       p.filter_results {\n        font-size: 1.125rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 1.125rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.5rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 1.125rem !important;\n      }\n\n      a.action {\n        font-size: 1.125rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 37px !important;\n      }\n    }\n  }\n\n  .bm-subitem {\n    font-size: 0.875rem !important;\n  }\n\n  .btn {\n    font-size: 1rem !important;\n\n    min-height: 36px !important;\n\n    &.btn-lg {\n      font-size: 1.05rem !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.9rem !important;\n    min-height: 26px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 1.15rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 13px !important;\n    padding-right: 40px !important;\n  }\n\n  .custom-toggle-wrapper {\n    min-height: 30px !important;\n\n    .custom-toggle-slider {\n      font-size: 16px !important;\n      padding: 0 13px 0 40px !important;\n\n      .custom-toggle-ball {\n        width: 26px !important;\n        height: 26px !important;\n      }\n    }\n  }\n\n  .form-control {\n    font-size: 1.05rem !important;\n  }\n\n  .form-header {\n    font-size: 1.125rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 68px !important;\n    height: 28px !important;\n\n    margin-left: -2em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 1.25rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 36px !important;\n    }\n  }\n\n  .input-group-text svg {\n    width: 17px !important;\n    height: 17px !important;\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 0.975rem !important;\n  }\n\n  .lead {\n    font-size: 1.3rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 1rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 1.1rem !important;\n      height: 36px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 1.05rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.8rem !important;\n\n      th .table-sort {\n        font-size: 1.05rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.8rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 32px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 12px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        .dropdown-toggle-item {\n          font-size: 1.05rem !important;\n        }\n\n        .multiple {\n          font-size: 1.05rem !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 1rem !important;\n      }\n\n      .icon {\n        font-size: 1.125rem !important;\n      }\n\n      .hint, .close {\n        font-size: 1.125rem !important;\n      }\n\n      .no-value-text {\n        font-size: 1rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.875rem !important;\n  }\n\n  h4 {\n    font-size: 1.625rem !important;\n  }\n\n  h5 {\n    font-size: 1.375rem !important;\n  }\n\n  h6 {\n    font-size: 1.125rem !important;\n  }\n\n  p {\n    font-size: 0.925rem !important;\n  }\n}\n",".accessibility-font-size-xl {\n  font-size: 1.175rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.3rem !important;\n      }\n\n      h4 {\n        font-size: 1.2rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 1.175rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 1.175rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.55rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 1.175rem !important;\n      }\n\n      a.action {\n        font-size: 1.175rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 39px !important;\n      }\n    }\n  }\n\n  .bm-subitem {\n    font-size: 0.925rem !important;\n  }\n\n  .btn {\n    font-size: 1.05rem !important;\n\n    min-height: 38px !important;\n\n    &.btn-lg {\n      font-size: 1.1rem !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 0.95rem !important;\n    min-height: 27px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 1.2rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 14px !important;\n    padding-right: 42px !important;\n  }\n\n  .custom-toggle-wrapper {\n    min-height: 32px !important;\n\n    .custom-toggle-slider {\n      font-size: 17px !important;\n      padding: 0 14px 0 42px !important;\n\n      .custom-toggle-ball {\n        width: 28px !important;\n        height: 28px !important;\n      }\n    }\n  }\n\n  .form-control {\n    font-size: 1.1rem !important;\n  }\n\n  .form-header {\n    font-size: 1.175rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 72px !important;\n    height: 30px !important;\n\n    margin-left: -1.8em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 1.3rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 38px !important;\n    }\n  }\n\n  .input-group-text svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 1.025rem !important;\n  }\n\n  .lead {\n    font-size: 1.35rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 1.125rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 1.2rem !important;\n      height: 38px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 1.1rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.85rem !important;\n\n      th .table-sort {\n        font-size: 1.1rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.85rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 34px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 14px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        .dropdown-toggle-item {\n          font-size: 1.1rem !important;\n        }\n\n        .multiple {\n          font-size: 1.1rem !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 1.05rem !important;\n      }\n\n      .icon {\n        font-size: 1.175rem !important;\n      }\n\n      .hint, .close {\n        font-size: 1.175rem !important;\n      }\n\n      .no-value-text {\n        font-size: 1.05rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.925rem !important;\n  }\n\n  h4 {\n    font-size: 1.675rem !important;\n  }\n\n  h5 {\n    font-size: 1.425rem !important;\n  }\n\n  h6 {\n    font-size: 1.175rem !important;\n  }\n\n  p {\n    font-size: 0.975rem !important;\n  }\n}\n",".accessibility-font-size-2xl {\n  font-size: 1.225rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.35rem !important;\n      }\n\n      h4 {\n        font-size: 1.25rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 1.225rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 1.225rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.6rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 1.225rem !important;\n      }\n\n      a.action {\n        font-size: 1.225rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 41px !important;\n      }\n    }\n  }\n\n  .bm-subitem {\n    font-size: 0.975rem !important;\n  }\n\n  .btn {\n    font-size: 1.1rem !important;\n\n    min-height: 40px !important;\n\n    &.btn-lg {\n      font-size: 1.15rem !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 1rem !important;\n    min-height: 28px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 1.25rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 15px !important;\n    padding-right: 44px !important;\n  }\n\n  .custom-toggle-wrapper {\n    min-height: 34px !important;\n\n    .custom-toggle-slider {\n      font-size: 18px !important;\n      padding: 0 15px 0 44px !important;\n\n      .custom-toggle-ball {\n        width: 30px !important;\n        height: 30px !important;\n      }\n    }\n  }\n\n  .form-control {\n    font-size: 1.15rem !important;\n  }\n\n  .form-header {\n    font-size: 1.225rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 76px !important;\n    height: 32px !important;\n\n    margin-left: -1.6em !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 40px !important;\n    }\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 1.35rem !important;\n  }\n\n  .input-group-text svg {\n    width: 19px !important;\n    height: 19px !important;\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 1.075rem !important;\n  }\n\n  .lead {\n    font-size: 1.4rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 1.25rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 1.3rem !important;\n      height: 40px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 1.15rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.9rem !important;\n\n      th .table-sort {\n        font-size: 1.15rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.9rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 36px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 16px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        .dropdown-toggle-item {\n          font-size: 1.15rem !important;\n        }\n\n        .multiple {\n          font-size: 1.15rem !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 1.1rem !important;\n      }\n\n      .icon {\n        font-size: 1.225rem !important;\n      }\n\n      .hint, .close {\n        font-size: 1.225rem !important;\n      }\n\n      .no-value-text {\n        font-size: 1.1rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 1.975rem !important;\n  }\n\n  h4 {\n    font-size: 1.725rem !important;\n  }\n\n  h5 {\n    font-size: 1.475rem !important;\n  }\n\n  h6 {\n    font-size: 1.225rem !important;\n  }\n\n  p {\n    font-size: 1.025rem !important;\n  }\n}\n",".accessibility-font-size-3xl {\n  font-size: 1.275rem;\n\n  #egradjani {\n    #filter_slideout {\n      h3 {\n        font-size: 1.4rem !important;\n      }\n\n      h4 {\n        font-size: 1.3rem !important;\n      }\n\n      .filter_results.p {\n        font-size: 1.275rem !important;\n      }\n    }\n\n    .zgl-inputfield {\n      font-size: 1.275rem !important;\n    }\n\n    .zgl-searchbutton {\n      font-size: 1.65rem !important;\n    }\n\n    #user_slideout {\n      p {\n        font-size: 1.275rem !important;\n      }\n\n      a.action {\n        font-size: 1.275rem !important;\n      }\n\n      .zgl-icon {\n        font-size: 43px !important;\n      }\n    }\n  }\n\n  .bm-subitem {\n    font-size: 1.025rem !important;\n  }\n\n  .btn {\n    font-size: 1.15rem !important;\n\n    min-height: 42px !important;\n\n    &.btn-lg {\n      font-size: 1.2rem !important;\n    }\n  }\n\n  .button-in-action-column.btn {\n    font-size: 1.05rem !important;\n    min-height: 29px !important;\n  }\n\n  .case-header-column > .case-header-label, .case-header-text  {\n    font-size: 1.3rem !important;\n  }\n\n  .custom-toggle-checkbox:checked + .custom-toggle-slider {\n    padding-left: 16px !important;\n    padding-right: 46px !important;\n  }\n\n  .custom-toggle-wrapper {\n    min-height: 36px !important;\n\n    .custom-toggle-slider {\n      font-size: 19px !important;\n      padding: 0 16px 0 46px !important;\n\n      .custom-toggle-ball {\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n\n  .form-control {\n    font-size: 1.2rem !important;\n  }\n\n  .form-header {\n    font-size: 1.275rem !important;\n  }\n\n  .form-switch .form-check-input {\n    width: 80px !important;\n    height: 34px !important;\n\n    margin-left: -1.4em !important;\n  }\n\n  .icon-table, .icon-table-header {\n    font-size: 1.4rem !important;\n  }\n\n  .input-group {\n    input[type='text'] {\n      height: 42px !important;\n    }\n  }\n\n  .input-group-text svg {\n    width: 20px !important;\n    height: 20px !important;\n  }\n\n  .label label,\n  .invalid-feedback,\n  .sidebar a {\n    font-size: 1.125rem !important;\n  }\n\n  .lead {\n    font-size: 1.45rem !important;\n  }\n\n  .modal-content .modal-body {\n    font-size: 1.375rem !important;\n  }\n\n  .pagination-wrapper {\n    .pagination .page-item .page-link,\n    .edozvola-select {\n      font-size: 1.4rem !important;\n      height: 42px !important;\n    }\n  }\n\n  .rdt .rdtPicker table {\n    font-size: 1.2rem !important;\n  }\n\n  .table {\n    thead {\n      font-size: 0.95rem !important;\n\n      th .table-sort {\n        font-size: 1.2rem !important;\n      }\n    }\n\n    tbody {\n      font-size: 0.95rem !important;\n    }\n  }\n\n  .toggle-text.false:after {\n    left: 38px !important;\n  }\n\n  .toggle-text.true:after {\n    left: 16px !important;\n  }\n\n  div[id$=\"-paginated-dropdown\"] {\n    &.dropdown {\n      .btn {\n        .dropdown-toggle-item {\n          font-size: 1.2rem !important;\n        }\n\n        .multiple {\n          font-size: 1.2rem !important;\n        }\n      }\n\n      .dropdown-item {\n        font-size: 1.15rem !important;\n      }\n\n      .icon {\n        font-size: 1.275rem !important;\n      }\n\n      .hint, .close {\n        font-size: 1.275rem !important;\n      }\n\n      .no-value-text {\n        font-size: 1.15rem !important;\n      }\n    }\n  }\n\n  h3 {\n    font-size: 2.025rem !important;\n  }\n\n  h4 {\n    font-size: 1.775rem !important;\n  }\n\n  h5 {\n    font-size: 1.525rem !important;\n  }\n\n  h6 {\n    font-size: 1.275rem !important;\n  }\n\n  p {\n    font-size: 1.075rem !important;\n  }\n}\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
